<template>
	<!-- 帳戶設定》修改結算資訊 -->
	<div class="deal_index_box">
		<!-- 内容 -->
		<div class="deal_title">
			<div>帳戶設定<span>》</span>修改管理員資訊</div>
			<div class="deal_hr">
				<div class="cut_off"></div>
			</div>
		</div>
		<!-- 修改結算資訊 -->
		<div class="deal_content_box">
			<div class="deal_content_title">修改結算資訊 </div>
			<div class="deal_content div_hight_end"  >
				<!-- <div class="remind_box">
					<i class="el-icon-warning icon_warning"></i>
					您送出的資料尚在審核中，審核期間無法再次變更，請耐心等待。
				</div> -->
				<div class="bank_box" v-show="showTF">
					<div class="bank_content" v-loading="loading">
						<!-- 內容： -->
						<el-form  label-width="90px" :model="formBank">
							<el-form-item label="銀行戶名：">
							<el-input class="form_mail_input" type="text" v-model="formBank.name" placeholder="須與存摺所載內容相符" :disabled="true"></el-input>
							</el-form-item>
							<el-form-item label="銀行代碼：">
							<!-- <el-input class="form_mail_input" type="text" v-model="formBank.number" placeholder="須與存摺所載內容相符"></el-input> -->
							<el-select class="select_div" v-model="formBank.numberVal" placeholder="請選擇銀行" @change="numberValFun()">
								<el-option
									v-for="item in numberOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							</el-form-item>
							<el-form-item label="所屬分行：">
							<el-select class="select_div" v-model="formBank.affiliation" placeholder="請選擇銀行">
								<el-option
									v-for="item in bankOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							</el-form-item>
							<el-form-item label="銀行帳號：">
							<el-input class="form_mail_input" type="text" v-model="formBank.account" maxlength="40"  placeholder="須與存摺所載內容相符"></el-input>
							</el-form-item>
							<div class="form_bank_box">
								<i v-show="formBankTF" class="el-icon-error form_bank">請補齊完整收款銀行帳號資料</i>
							</div>
						</el-form>
						<div class="btn_box">
							<el-button plain @click="goLoginbu()">返回</el-button>
							<el-button type="primary" @click="buttonFun()">送出</el-button>
						</div>
					</div>
				</div>
				<!-- <div class="btn_go" v-show="!showTF">
					<el-button plain @click="goLoginbu()">返回</el-button>
				</div> -->


			</div>
		</div>
	</div>



</template>

<script>
import axios from 'axios';

	export default {
		data() {
			return {
                ruleForm:{email:''},
				formMail: {
					fileFront: '',
					trader: '',
					name: '',
					full_name: '',
				},
				formBank: {
				  name: '',
				  affiliation: '',
				  account: '',
				  numberVal: ''
				},
				showTF: true,
				formBankTF: false,
				loading: false,

				lilist:1,
				numberOptions: [
					{
					value: '000',
					label: '中央銀行國庫局 - 000'
					}, {
					value: '004',
					label: '臺灣銀行 - 004'
					}, {
					value: '005',
					label: '臺灣土地銀行 - 005'
					}, {
					value: '006',
					label: '合作金庫商業銀行 - 006'
					}, {
					value: '007',
					label: '第一商業銀行 - 007'
					}, {
					value: '008',
					label: '華南商業銀行 - 008'
					}, {
					value: '009',
					label: '彰化商業銀行 - 009'
					}, {
					value: '011',
					label: '上海商業儲蓄銀行 - 011'
					}, {
					value: '012',
					label: '台北富邦商業銀行 - 012'
					}, {
					value: '013',
					label: '國泰世華商業銀行 - 013'
					}, {
					value: '016',
					label: '高雄銀行 - 016'
					}, {
					value: '017',
					label: '兆豐國際商業銀行 - 017'
					}, {
					value: '018',
					label: '全國農業金庫 - 018'
					}, {
					value: '020',
					label: '日商瑞穗銀行台北分行 - 020'
					}, {
					value: '021',
					label: '花旗(台灣)商業銀行 - 021'
					}, {
					value: '022',
					label: '美國銀行台北分行 - 022'
					}, {
					value: '023',
					label: '泰國盤谷銀行台北分行 - 023'
					}, {
					value: '025',
					label: '菲律賓首都銀行台北分行 - 025'
					}, {
					value: '029',
					label: '新加坡商大華銀行台北分行 - 029'
					}, {
					value: '030',
					label: '美商道富銀行台北分行 - 030'
					}, {
					value: '037',
					label: '法商法國興業銀行台北分行 - 037'
					}, {
					value: '039',
					label: '澳盛(台灣)商業銀行 - 039'
					}, {
					value: '048',
					label: '王道商業銀行 - 048'
					}, {
					value: '050',
					label: '臺灣中小企業銀行 - 050'
					}, {
					value: '052',
					label: '渣打國際商業銀行 - 052'
					}, {
					value: '053',
					label: '台中商業銀行 - 053'
					}, {
					value: '054',
					label: '京城商業銀行 - 054'
					}, {
					value: '060',
					label: '兆豐票券金融股份有限公司 - 060'
					}, {
					value: '061',
					label: '中華票券金融股份有限公司 - 061'
					}, {
					value: '062',
					label: '國際票券金融股份有限公司 - 062'
					}, {
					value: '066',
					label: '萬通票券金融股份有限公司 - 066'
					}, {
					value: '072',
					label: '德商德意志銀行台北分行 - 072'
					}, {
					value: '075',
					label: '香港商東亞銀行台北分行 - 075'
					}, {
					value: '076',
					label: '美商摩根大通銀行台北分行 - 076'
					}, {
					value: '081',
					label: '"匯豐(台灣)商業銀行 - 081'
					}, {
					value: '082',
					label: '法國巴黎銀行台北分行 - 082'
					}, {
					value: '085',
					label: '新加坡商新加坡華僑銀行台北分行 - 085'
					}, {
					value: '086',
					label: '法商東方匯理銀行台北分行 - 086'
					}, {
					value: '092',
					label: '瑞士商瑞士銀行台北分行 - 092'
					}, {
					value: '093',
					label: '荷商安智銀行台北分行 - 093'
					}, {
					value: '098',
					label: '日商三菱東京日聯銀行台北分行 - 098'
					}, {
					value: '101',
					label: '瑞興商業銀行 - 101'
					}, {
					value: '102',
					label: '華泰商業銀行 - 102'
					}, {
					value: '103',
					label: '臺灣新光商業銀行 - 103'
					}, {
					value: '108',
					label: '陽信商業銀行 - 108'
					}, {
					value: '114',
					label: '基隆第一信用合作社 - 114'
					}, {
					value: '115',
					label: '基隆市第二信用合作社 - 115'
					}, {
					value: '118',
					label: '板信商業銀行 - 118'
					}, {
					value: '119',
					label: '淡水第一信用合作社 - 119'
					}, {
					value: '130',
					label: '新竹第一信用合作社 - 130'
					}, {
					value: '132',
					label: '新竹第三信用合作社 - 132'
					}, {
					value: '146',
					label: '台中市第二信用合作社 - 146'
					}, {
					value: '147',
					label: '三信商業銀行 - 147'
					}, {
					value: '162',
					label: '彰化第六信用合作社 - 162'
					}, {
					value: '165',
					label: '彰化縣鹿港信用合作社 - 165'
					}, {
					value: '204',
					label: '高雄市第三信用合作社 - 204'
					}, {
					value: '215',
					label: '花蓮第一信用合作社 - 215'
					}, {
					value: '216',
					label: '花蓮第二信用合作社 - 216'
					}, {
					value: '321',
					label: '日商三井住友銀行台北分行 - 321'
					}, {
					value: '326',
					label: '西班牙商西班牙對外銀行臺北分行 - 326'
					}, {
					value: '372',
					label: '大慶票券金融股份有限公司 - 372'
					}, {
					value: '380',
					label: '大陸商中國銀行臺北分行 - 380'
					}, {
					value: '381',
					label: '大陸商交通銀行臺北分行 - 381'
					}, {
					value: '625',
					label: '臺中市臺中地區農會 - 625'
					}, {
					value: '700',
					label: '中華郵政股份有限公司 - 700'
					}, {
					value: '803',
					label: '聯邦商業銀行 - 803'
					}, {
					value: '805',
					label: '遠東國際商業銀行 - 805'
					}, {
					value: '806',
					label: '元大商業銀行 - 806'
					}, {
					value: '807',
					label: '永豐商業銀行 - 807'
					}, {
					value: '808',
					label: '玉山商業銀行 - 808'
					}, {
					value: '809',
					label: '凱基商業銀行 - 809'
					}, {
					value: '810',
					label: '星展(台灣)商業銀行 - 810'
					}, {
					value: '812',
					label: '台新國際商業銀行 - 812'
					}, {
					value: '815',
					label: '日盛國際商業銀行 - 815'
					}, {
					value: '816',
					label: '安泰商業銀行 - 816'
					}, {
					value: '822',
					label: '中國信託商業銀行 - 822'
					}, {
					value: '910',
					label: '財團法人農漁會聯合資訊中心 - 910'
					}, {
					value: '928',
					label: '板橋區農會電腦共用中心 - 928'
					}, {
					value: '951',
					label: '新北市農會附設北區農會電腦共同利用中心 - 951'
					}, {
					value: '952',
					label: '財團法人農漁會南區資訊中心 - 952'
					}, {
					value: '995',
					label: '關貿網路股份有限公司 - 995'
					}, {
					value: '996',
					label: '財政部國庫署 - 996'
					}, {
					value: '997',
					label: '中華民國信用合作社聯合社南區聯合資訊處理中心 - 997'
					}
				],
				bankList: {
					"000": {
						"one": "中央銀行國庫局 000"
					},
					"004": {
						"one": "臺灣銀行 004",
						"two": {
							"0037": "臺灣銀行營業部 0037",
							"0059": "臺灣銀行公庫部 0059",
							"0071": "臺灣銀行館前分行 0071",
							"0082": "臺灣銀行信託部 0082",
							"0093": "臺灣銀行臺南分行 0093",
							"0107": "臺灣銀行臺中分行 0107",
							"0118": "臺灣銀行高雄分行 0118",
							"0129": "臺灣銀行基隆分行 0129",
							"0130": "臺灣銀行中興新村分行 0130",
							"0141": "臺灣銀行嘉義分行 0141",
							"0152": "臺灣銀行新竹分行 0152",
							"0163": "臺灣銀行彰化分行 0163",
							"0174": "臺灣銀行屏東分行 0174",
							"0185": "臺灣銀行花蓮分行 0185",
							"0196": "臺灣銀行延平分行 0196",
							"0200": "臺灣銀行中山分行 0200",
							"0211": "臺灣銀行高雄加工出口區分行 0211",
							"0222": "臺灣銀行宜蘭分行 0222",
							"0233": "臺灣銀行臺東分行 0233",
							"0244": "臺灣銀行澎湖分行 0244",
							"0255": "臺灣銀行鳳山分行 0255",
							"0266": "臺灣銀行桃園分行 0266",
							"0277": "臺灣銀行板橋分行 0277",
							"0288": "臺灣銀行新營分行 0288",
							"0299": "臺灣銀行苗栗分行 0299",
							"0303": "臺灣銀行豐原分行 0303",
							"0314": "臺灣銀行斗六分行 0314",
							"0325": "臺灣銀行南投分行 0325",
							"0336": "臺灣銀行南門分行 0336",
							"0347": "臺灣銀行公館分行 0347",
							"0358": "臺灣銀行左營分行 0358",
							"0369": "臺灣銀行北投分行 0369",
							"0370": "臺灣銀行霧峰分行 0370",
							"0381": "臺灣銀行金門分行 0381",
							"0392": "臺灣銀行馬祖分行 0392",
							"0406": "臺灣銀行安平分行 0406",
							"0417": "臺灣銀行中壢分行 0417",
							"0428": "臺灣銀行三重分行 0428",
							"0439": "臺灣銀行頭份分行 0439",
							"0440": "臺灣銀行前鎮分行 0440",
							"0451": "臺灣銀行城中分行 0451",
							"0462": "臺灣銀行民權分行 0462",
							"0473": "臺灣銀行潭子分行 0473",
							"0484": "臺灣銀行連城分行 0484",
							"0495": "臺灣銀行員林分行 0495",
							"0509": "臺灣銀行松江分行 0509",
							"0510": "臺灣銀行鼓山分行 0510",
							"0521": "臺灣銀行龍山分行 0521",
							"0532": "臺灣銀行忠孝分行 0532",
							"0543": "臺灣銀行信義分行 0543",
							"0554": "臺灣銀行復興分行 0554",
							"0565": "臺灣銀行三民分行 0565",
							"0576": "臺灣銀行臺中港分行 0576",
							"0587": "臺灣銀行羅東分行 0587",
							"0598": "臺灣銀行埔里分行 0598",
							"0602": "臺灣銀行岡山分行 0602",
							"0613": "臺灣銀行新興分行 0613",
							"0624": "臺灣銀行苓雅分行 0624",
							"0646": "臺灣銀行松山分行 0646",
							"0657": "臺灣銀行健行分行 0657",
							"0668": "臺灣銀行中和分行 0668",
							"0679": "臺灣銀行太保分行 0679",
							"0680": "臺灣銀行竹北分行 0680",
							"0691": "臺灣銀行國際金融業務分行 0691",
							"0705": "臺灣銀行士林分行 0705",
							"0716": "臺灣銀行新莊分行 0716",
							"0727": "臺灣銀行大甲分行 0727",
							"0738": "臺灣銀行新竹科學園區分行 0738",
							"0749": "臺灣銀行樹林分行 0749",
							"0750": "臺灣銀行新店分行 0750",
							"0794": "臺灣銀行黎明分行 0794",
							"0808": "臺灣銀行民生分行 0808",
							"0819": "臺灣銀行永康分行 0819",
							"0820": "臺灣銀行三多分行 0820",
							"0831": "臺灣銀行紐約分行 0831",
							"0853": "臺灣銀行臺北世貿中心分行 0853",
							"0864": "臺灣銀行大安分行 0864",
							"0875": "臺灣銀行華江分行 0875",
							"0886": "臺灣銀行潮州分行 0886",
							"0897": "臺灣銀行蘇澳分行 0897",
							"0901": "臺灣銀行大雅分行 0901",
							"0912": "臺灣銀行楠梓分行 0912",
							"0923": "臺灣銀行臺中工業區分行 0923",
							"0945": "臺灣銀行洛杉磯分行 0945",
							"1067": "臺灣銀行敦化分行 1067",
							"1078": "臺灣銀行南港分行 1078",
							"1089": "臺灣銀行和平分行 1089",
							"1090": "臺灣銀行水湳分行 1090",
							"1104": "臺灣銀行中崙分行 1104",
							"1115": "臺灣銀行土城分行 1115",
							"1148": "臺灣銀行香港分行 1148",
							"1159": "臺灣銀行桃園國際機場分行 1159",
							"1160": "臺灣銀行大昌分行 1160",
							"1171": "臺灣銀行東京分行 1171",
							"1182": "臺灣銀行五甲分行 1182",
							"1193": "臺灣銀行博愛分行 1193",
							"1207": "臺灣銀行中庄分行 1207",
							"1218": "臺灣銀行平鎮分行 1218",
							"1229": "臺灣銀行仁愛分行 1229",
							"1230": "臺灣銀行南崁分行 1230",
							"1241": "臺灣銀行圓山分行 1241",
							"1355": "臺灣銀行五股分行 1355",
							"1366": "臺灣銀行大里分行 1366",
							"1377": "臺灣銀行安南分行 1377",
							"1388": "臺灣銀行新加坡分行 1388",
							"1414": "臺灣銀行西屯分行 1414",
							"1425": "臺灣銀行天母分行 1425",
							"1436": "臺灣銀行鹿港分行 1436",
							"1447": "臺灣銀行內壢分行 1447",
							"1469": "臺灣銀行臺南科學園區分行 1469",
							"1470": "臺灣銀行虎尾分行 1470",
							"1481": "臺灣銀行淡水分行 1481",
							"1539": "臺灣銀行內湖分行 1539",
							"1540": "臺灣銀行嘉北分行 1540",
							"1551": "臺灣銀行東港分行 1551",
							"1562": "臺灣銀行汐止分行 1562",
							"1573": "臺灣銀行梧棲分行 1573",
							"1595": "臺灣銀行小港分行 1595",
							"1609": "臺灣銀行中屏分行 1609",
							"1610": "臺灣銀行南非分行 1610",
							"1621": "臺灣銀行群賢分行 1621",
							"1643": "臺灣銀行北大路分行 1643",
							"1654": "臺灣銀行文山分行 1654",
							"1702": "臺灣銀行太平分行 1702",
							"1713": "臺灣銀行德芳分行 1713",
							"1724": "臺灣銀行建國分行 1724",
							"1768": "臺灣銀行屏東農科園區分行 1768",
							"1861": "臺灣銀行東桃園分行 1861",
							"1872": "臺灣銀行蘆洲分行 1872",
							"1919": "臺灣銀行高雄國際機場分行 1919",
							"1931": "臺灣銀行永吉簡易型分行 1931",
							"1942": "臺灣銀行東門簡易型分行 1942",
							"1953": "臺灣銀行愛國簡易型分行 1953",
							"1986": "臺灣銀行臺電簡易型分行 1986",
							"2053": "臺灣銀行北府簡易型分行 2053",
							"2101": "臺灣銀行倫敦分行 2101",
							"2189": "臺灣銀行臺北港分行 2189",
							"2204": "臺灣銀行臺中科學園區分行 2204",
							"2215": "臺灣銀行高雄科學園區分行 2215",
							"2237": "臺灣銀行東湖分行 2237",
							"2248": "臺灣銀行高榮分行 2248",
							"2259": "臺灣銀行南港軟體園區分行 2259",
							"2260": "臺灣銀行龍潭分行 2260",
							"2271": "臺灣銀行仁德分行 2271",
							"2282": "臺灣銀行林口分行 2282",
							"2293": "臺灣銀行木柵分行 2293",
							"2307": "臺南創新園區分行 2307",
							"2363": "臺灣銀行武昌分行 2363",
							"2385": "臺灣銀行臺北分行 2385",
							"2396": "臺灣銀行金山分行 2396",
							"2400": "臺灣銀行信安分行 2400",
							"2411": "臺灣銀行劍潭分行 2411",
							"2422": "臺灣銀行萬華分行 2422",
							"2433": "臺灣銀行板新分行 2433",
							"2444": "臺灣銀行新永和分行 2444",
							"2455": "臺灣銀行南新莊分行 2455",
							"2477": "臺灣銀行新明分行 2477",
							"2488": "臺灣銀行六家分行 2488",
							"2499": "臺灣銀行北臺中分行 2499",
							"2525": "臺灣銀行嘉南分行 2525",
							"2536": "臺灣銀行南都分行 2536",
							"2558": "臺灣銀行北高雄分行 2558",
							"2569": "臺灣銀行成功分行 2569",
							"2570": "臺灣銀行北花蓮分行 2570",
							"2709": "臺灣銀行新湖分行 2709",
							"2710": "臺灣銀行五福分行 2710",
							"2721": "臺灣銀行六甲頂分行 2721",
							"2776": "臺灣銀行上海分行 2776",
							"2787": "臺灣銀行中都分行 2787",
							"2798": "臺灣銀行臺北國際機場分行 2798",
							"2802": "新莊副都心分行 2802",
							"2813": "臺灣銀行孟買代表人辦事處 2813",
							"2824": "臺灣銀行雪梨分行 2824",
							"2835": "臺灣銀行仁武分行 2835",
							"2846": "臺灣銀行上海嘉定支行 2846",
							"2868": "臺灣銀行仰光代表人辦事處 2868",
							"2879": "臺灣銀行廣州分行 2879",
							"2880": "臺灣銀行福州分行 2880",
							"2891": "臺灣銀行臺中國際機場分行 2891",
							"2905": "臺中精密園區分行 2905",
							"2927": "臺灣銀行曼谷代表人辦事處 2927",
							"2949": "臺灣銀行馬尼拉代表人辦事處 2949",
							"2950": "臺灣銀行矽谷代表人辦事處 2950",
							"2961": "臺灣銀行法蘭克福代表人辦事處 2961",
							"2972": "臺灣銀行亞矽創新分行 2972"
						}
					},
					"005": {
						"one": "臺灣土地銀行 005",
						"two": {
							"0027": "臺灣土地銀行基隆分行 0027",
							"0038": "臺灣土地銀行中和分行 0038",
							"0049": "臺灣土地銀行南港分行 0049",
							"0050": "臺灣土地銀行台北分行 0050",
							"0061": "臺灣土地銀行民權分行 0061",
							"0072": "臺灣土地銀行古亭分行 0072",
							"0083": "臺灣土地銀行長安分行 0083",
							"0094": "臺灣土地銀行士林分行 0094",
							"0108": "臺灣土地銀行三重分行 0108",
							"0119": "臺灣土地銀行宜蘭分行 0119",
							"0120": "臺灣土地銀行羅東分行 0120",
							"0131": "臺灣土地銀行桃園分行 0131",
							"0142": "臺灣土地銀行中壢分行 0142",
							"0153": "臺灣土地銀行石門分行 0153",
							"0164": "臺灣土地銀行新竹分行 0164",
							"0175": "臺灣土地銀行竹東分行 0175",
							"0186": "臺灣土地銀行花蓮分行 0186",
							"0197": "臺灣土地銀行玉里分行 0197",
							"0201": "臺灣土地銀行苗栗分行 0201",
							"0212": "臺灣土地銀行頭份分行 0212",
							"0223": "臺灣土地銀行豐原分行 0223",
							"0234": "臺灣土地銀行大甲分行 0234",
							"0245": "臺灣土地銀行台中分行 0245",
							"0256": "臺灣土地銀行南投分行 0256",
							"0267": "臺灣土地銀行員林分行 0267",
							"0278": "臺灣土地銀行斗六分行 0278",
							"0289": "臺灣土地銀行北港分行 0289",
							"0290": "臺灣土地銀行嘉義分行 0290",
							"0304": "臺灣土地銀行新營分行 0304",
							"0315": "臺灣土地銀行永康分行 0315",
							"0326": "臺灣土地銀行台南分行 0326",
							"0337": "臺灣土地銀行高雄分行 0337",
							"0348": "臺灣土地銀行岡山分行 0348",
							"0359": "臺灣土地銀行美濃分行 0359",
							"0360": "臺灣土地銀行屏東分行 0360",
							"0371": "臺灣土地銀行臺東分行 0371",
							"0382": "臺灣土地銀行青年分行 0382",
							"0393": "臺灣土地銀行金門分行 0393",
							"0407": "臺灣土地銀行澎湖分行 0407",
							"0418": "臺灣土地銀行營業部 0418",
							"0452": "臺灣土地銀行和平分行 0452",
							"0463": "臺灣土地銀行潮州分行 0463",
							"0474": "臺灣土地銀行彰化分行 0474",
							"0485": "臺灣土地銀行中山分行 0485",
							"0496": "臺灣土地銀行永和分行 0496",
							"0500": "臺灣土地銀行板橋分行 0500",
							"0511": "臺灣土地銀行鳳山分行 0511",
							"0522": "臺灣土地銀行湖口分行 0522",
							"0533": "臺灣土地銀行蘇澳分行 0533",
							"0544": "臺灣土地銀行新興分行 0544",
							"0555": "臺灣土地銀行西台中分行 0555",
							"0566": "臺灣土地銀行虎尾分行 0566",
							"0577": "臺灣土地銀行仁愛分行 0577",
							"0588": "臺灣土地銀行忠孝分行 0588",
							"0599": "臺灣土地銀行中正分行 0599",
							"0614": "臺灣土地銀行新店分行 0614",
							"0625": "臺灣土地銀行北台南分行 0625",
							"0636": "臺灣土地銀行松山分行 0636",
							"0647": "臺灣土地銀行內湖分行 0647",
							"0658": "臺灣土地銀行三民分行 0658",
							"0669": "臺灣土地銀行民雄分行 0669",
							"0670": "臺灣土地銀行大社分行 0670",
							"0692": "臺灣土地銀行前鎮分行 0692",
							"0706": "臺灣土地銀行路竹分行 0706",
							"0717": "臺灣土地銀行五甲分行 0717",
							"0728": "臺灣土地銀行太平分行 0728",
							"0739": "臺灣土地銀行正濱分行 0739",
							"0740": "臺灣土地銀行敦化分行 0740",
							"0751": "臺灣土地銀行信託部 0751",
							"0762": "臺灣土地銀行蘆洲分行 0762",
							"0773": "臺灣土地銀行北臺中分行 0773",
							"0784": "臺灣土地銀行苓雅分行 0784",
							"0795": "臺灣土地銀行信義分行 0795",
							"0809": "臺灣土地銀行土城分行 0809",
							"0810": "臺灣土地銀行淡水分行 0810",
							"0821": "臺灣土地銀行草屯分行 0821",
							"0832": "臺灣土地銀行東台南分行 0832",
							"0843": "臺灣土地銀行通霄分行 0843",
							"0854": "臺灣土地銀行學甲分行 0854",
							"0865": "臺灣土地銀行新莊分行 0865",
							"0876": "臺灣土地銀行雙和分行 0876",
							"0887": "臺灣土地銀行國外部 0887",
							"0898": "臺灣土地銀行白河分行 0898",
							"0902": "臺灣土地銀行復興分行 0902",
							"0913": "臺灣土地銀行平鎮分行 0913",
							"0924": "臺灣土地銀行國際金融業務分行 0924",
							"0935": "臺灣土地銀行文山分行 0935",
							"0946": "臺灣土地銀行中港分行 0946",
							"0957": "臺灣土地銀行東板橋分行 0957",
							"0968": "臺灣土地銀行南崁分行 0968",
							"0979": "臺灣土地銀行建國分行 0979",
							"0980": "臺灣土地銀行樹林分行 0980",
							"0991": "臺灣土地銀行東台北分行 0991",
							"1002": "臺灣土地銀行西三重分行 1002",
							"1013": "臺灣土地銀行南台中分行 1013",
							"1024": "臺灣土地銀行長春分行 1024",
							"1035": "臺灣土地銀行東新竹分行 1035",
							"1046": "臺灣土地銀行新市分行 1046",
							"1057": "臺灣土地銀行博愛分行 1057",
							"1068": "臺灣土地銀行中崙分行 1068",
							"1079": "臺灣土地銀行華江分行 1079",
							"1080": "臺灣土地銀行竹北分行 1080",
							"1091": "臺灣土地銀行安平分行 1091",
							"1105": "臺灣土地銀行嘉興分行 1105",
							"1116": "臺灣土地銀行南新莊分行 1116",
							"1127": "臺灣土地銀行三峽分行 1127",
							"1138": "臺灣土地銀行沙鹿分行 1138",
							"1149": "臺灣土地銀行南桃園分行 1149",
							"1150": "臺灣土地銀行汐止分行 1150",
							"1161": "臺灣土地銀行萬華分行 1161",
							"1172": "臺灣土地銀行小港分行 1172",
							"1183": "臺灣土地銀行新工分行 1183",
							"1194": "臺灣土地銀行烏日分行 1194",
							"1208": "臺灣土地銀行西湖分行 1208",
							"1219": "臺灣土地銀行八德分行 1219",
							"1220": "臺灣土地銀行北屯分行 1220",
							"1231": "臺灣土地銀行大安分行 1231",
							"1242": "臺灣土地銀行北中壢分行 1242",
							"1253": "臺灣土地銀行高樹分行 1253",
							"1264": "臺灣土地銀行枋寮分行 1264",
							"1286": "臺灣土地銀行金城分行 1286",
							"1297": "臺灣土地銀行光復分行 1297",
							"1301": "臺灣土地銀行左營分行 1301",
							"1312": "臺灣土地銀行北桃園分行 1312",
							"1323": "臺灣土地銀行東港分行 1323",
							"1334": "臺灣土地銀行天母分行 1334",
							"1345": "臺灣土地銀行泰山分行 1345",
							"1356": "臺灣土地銀行中科分行 1356",
							"1367": "臺灣土地銀行大園分行 1367",
							"1378": "臺灣土地銀行楊梅分行 1378",
							"1389": "臺灣土地銀行東門分行 1389",
							"1404": "臺灣土地銀行城東分行 1404",
							"1415": "臺灣土地銀行松南分行 1415",
							"1426": "臺灣土地銀行福興分行 1426",
							"1437": "臺灣土地銀行林口分行 1437",
							"1448": "臺灣土地銀行西屯分行 1448",
							"1459": "臺灣土地銀行內壢分行 1459",
							"1460": "臺灣土地銀行竹南分行 1460",
							"1471": "臺灣土地銀行安南分行 1471",
							"1482": "臺灣土地銀行汐科分行 1482",
							"1493": "臺灣土地銀行楠梓分行 1493",
							"1507": "臺灣土地銀行大里分行 1507",
							"1518": "臺灣土地銀行大灣分行 1518",
							"1530": "臺灣土地銀行大發分行 1530",
							"1552": "臺灣土地銀行圓山分行 1552",
							"1563": "臺灣土地銀行工研院分行 1563",
							"1574": "臺灣土地銀行北三重分行 1574",
							"1585": "臺灣土地銀行圓通分行 1585",
							"1600": "臺灣土地銀行大直分行 1600",
							"1611": "臺灣土地銀行南屯分行 1611",
							"1622": "臺灣土地銀行證券部 1622",
							"1633": "臺灣土地銀行寶中分行 1633",
							"1644": "臺灣土地銀行中清分行 1644",
							"1655": "臺灣土地銀行南京東路分行 1655",
							"1666": "臺灣土地銀行仁武分行 1666",
							"5011": "臺灣土地銀行洛杉磯分行 5011",
							"5022": "臺灣土地銀行香港分行 5022",
							"5033": "臺灣土地銀行新加坡分行 5033",
							"5044": "臺灣土地銀行上海分行 5044",
							"5066": "臺灣土地銀行紐約分行 5066",
							"5077": "臺灣土地銀行天津分行 5077",
							"5088": "臺灣土地銀行武漢分行 5088"
						}
					},
					"006": {
						"one": "合作金庫商業銀行 006",
						"two": {
							"0017": "合作金庫商業銀行財務部 0017",
							"0028": "合作金庫商業銀行館前分行 0028",
							"0039": "合作金庫商業銀行西門分行 0039",
							"0040": "合作金庫商業銀行延平分行 0040",
							"0051": "合作金庫商業銀行大稻埕分行 0051",
							"0062": "合作金庫商業銀行東門分行 0062",
							"0073": "合作金庫商業銀行松山分行 0073",
							"0084": "合作金庫商業銀行新店分行 0084",
							"0095": "合作金庫商業銀行永和分行 0095",
							"0109": "合作金庫商業銀行三重分行 0109",
							"0110": "合作金庫商業銀行板橋分行 0110",
							"0121": "合作金庫商業銀行基隆分行 0121",
							"0132": "合作金庫商業銀行宜蘭分行 0132",
							"0143": "合作金庫商業銀行蘇澳分行 0143",
							"0154": "合作金庫商業銀行桃園分行 0154",
							"0165": "合作金庫商業銀行中壢分行 0165",
							"0176": "合作金庫商業銀行新竹分行 0176",
							"0187": "合作金庫商業銀行苗栗分行 0187",
							"0198": "合作金庫商業銀行頭份分行 0198",
							"0202": "合作金庫商業銀行豐原分行 0202",
							"0213": "合作金庫商業銀行沙鹿分行 0213",
							"0224": "合作金庫商業銀行台中分行 0224",
							"0235": "合作金庫商業銀行彰化分行 0235",
							"0246": "合作金庫商業銀行員林分行 0246",
							"0257": "合作金庫商業銀行南投分行 0257",
							"0268": "合作金庫商業銀行斗六分行 0268",
							"0279": "合作金庫商業銀行北港分行 0279",
							"0280": "合作金庫商業銀行嘉義分行 0280",
							"0291": "合作金庫商業銀行新營分行 0291",
							"0305": "合作金庫商業銀行台南分行 0305",
							"0316": "合作金庫商業銀行成功分行 0316",
							"0327": "合作金庫商業銀行鳳山分行 0327",
							"0338": "合作金庫商業銀行岡山分行 0338",
							"0349": "合作金庫商業銀行高雄分行 0349",
							"0350": "合作金庫商業銀行新興分行 0350",
							"0361": "合作金庫商業銀行屏東分行 0361",
							"0372": "合作金庫商業銀行潮州分行 0372",
							"0383": "合作金庫商業銀行花蓮分行 0383",
							"0394": "合作金庫商業銀行台東分行 0394",
							"0408": "合作金庫商業銀行澎湖分行 0408",
							"0419": "合作金庫商業銀行南京東路分行 0419",
							"0420": "合作金庫商業銀行北高雄分行 0420",
							"0431": "合作金庫商業銀行大同分行 0431",
							"0453": "合作金庫商業銀行忠孝分行 0453",
							"0464": "合作金庫商業銀行景美分行 0464",
							"0475": "合作金庫商業銀行士林分行 0475",
							"0486": "合作金庫商業銀行汐止分行 0486",
							"0497": "合作金庫商業銀行新莊分行 0497",
							"0501": "合作金庫商業銀行中興分行 0501",
							"0512": "合作金庫商業銀行苓雅分行 0512",
							"0523": "合作金庫商業銀行業務發展部 0523",
							"0534": "合作金庫商業銀行法遵暨法務部 0534",
							"0545": "合作金庫商業銀行台北分行 0545",
							"0556": "合作金庫商業銀行個人金融部 0556",
							"0567": "合作金庫商業銀行營業部 0567",
							"0578": "合作金庫商業銀行南豐原分行 0578",
							"0589": "合作金庫商業銀行羅東分行 0589",
							"0590": "合作金庫商業銀行三民分行 0590",
							"0604": "合作金庫商業銀行城東分行 0604",
							"0615": "合作金庫商業銀行佳里分行 0615",
							"0626": "合作金庫商業銀行中和分行 0626",
							"0637": "合作金庫商業銀行南高雄分行 0637",
							"0648": "合作金庫商業銀行南嘉義分行 0648",
							"0659": "合作金庫商業銀行竹東分行 0659",
							"0660": "合作金庫商業銀行林口文化分行 0660",
							"0671": "合作金庫商業銀行東三重分行 0671",
							"0682": "合作金庫商業銀行南興分行 0682",
							"0693": "合作金庫商業銀行五權分行 0693",
							"0707": "合作金庫商業銀行埔里分行 0707",
							"0718": "合作金庫商業銀行大順分行 0718",
							"0729": "合作金庫商業銀行南勢角分行 0729",
							"0730": "合作金庫商業銀行朴子分行 0730",
							"0763": "合作金庫商業銀行大安分行 0763",
							"0774": "合作金庫商業銀行民權分行 0774",
							"0785": "合作金庫商業銀行東高雄分行 0785",
							"0796": "合作金庫商業銀行東台北分行 0796",
							"0800": "合作金庫商業銀行城內分行 0800",
							"0811": "合作金庫商業銀行建國分行 0811",
							"0822": "合作金庫商業銀行圓山分行 0822",
							"0833": "合作金庫商業銀行信義分行 0833",
							"0844": "合作金庫商業銀行長春分行 0844",
							"0855": "合作金庫商業銀行仁愛分行 0855",
							"0866": "合作金庫商業銀行玉成分行 0866",
							"0877": "合作金庫商業銀行古亭分行 0877",
							"0888": "合作金庫商業銀行長安分行 0888",
							"0899": "合作金庫商業銀行松興分行 0899",
							"0903": "合作金庫商業銀行民族分行 0903",
							"0914": "合作金庫商業銀行復興分行 0914",
							"0925": "合作金庫商業銀行雙連分行 0925",
							"0936": "合作金庫商業銀行民生分行 0936",
							"0947": "合作金庫商業銀行新生分行 0947",
							"0958": "合作金庫商業銀行松江分行 0958",
							"0969": "合作金庫商業銀行永吉分行 0969",
							"0981": "合作金庫商業銀行東新莊分行 0981",
							"0992": "合作金庫商業銀行蘆洲分行 0992",
							"1003": "合作金庫商業銀行前金分行 1003",
							"1014": "合作金庫商業銀行成大分行 1014",
							"1025": "合作金庫商業銀行大里分行 1025",
							"1036": "合作金庫商業銀行海山分行 1036",
							"1047": "合作金庫商業銀行信託部 1047",
							"1069": "合作金庫商業銀行國際金融業務分行 1069",
							"1070": "合作金庫商業銀行南台中分行 1070",
							"1081": "合作金庫商業銀行埔墘分行 1081",
							"1092": "合作金庫商業銀行慈文分行 1092",
							"1106": "合作金庫商業銀行北寧分行 1106",
							"1117": "合作金庫商業銀行迴龍分行 1117",
							"1128": "合作金庫商業銀行太平分行 1128",
							"1139": "合作金庫商業銀行彰營分行 1139",
							"1140": "合作金庫商業銀行彰儲分行 1140",
							"1151": "合作金庫商業銀行虎尾分行 1151",
							"1162": "合作金庫商業銀行南屯分行 1162",
							"1173": "合作金庫商業銀行西台中分行 1173",
							"1184": "合作金庫商業銀行溪湖分行 1184",
							"1195": "合作金庫商業銀行烏日分行 1195",
							"1209": "合作金庫商業銀行和美分行 1209",
							"1210": "合作金庫商業銀行南桃園分行 1210",
							"1221": "合作金庫商業銀行屏南分行 1221",
							"1232": "合作金庫商業銀行東台南分行 1232",
							"1243": "合作金庫商業銀行北新竹分行 1243",
							"1254": "合作金庫商業銀行復旦分行 1254",
							"1265": "合作金庫商業銀行竹山分行 1265",
							"1276": "合作金庫商業銀行前鎮分行 1276",
							"1287": "合作金庫商業銀行灣內分行 1287",
							"1298": "合作金庫商業銀行路竹分行 1298",
							"1302": "合作金庫商業銀行憲德分行 1302",
							"1313": "合作金庫商業銀行竹北分行 1313",
							"1324": "合作金庫商業銀行北新分行 1324",
							"1335": "合作金庫商業銀行五洲分行 1335",
							"1346": "合作金庫商業銀行台大分行 1346",
							"1368": "合作金庫商業銀行龜山分行 1368",
							"1379": "合作金庫商業銀行大溪分行 1379",
							"1380": "合作金庫商業銀行龍潭分行 1380",
							"1391": "合作金庫商業銀行中原分行 1391",
							"1405": "合作金庫商業銀行三興分行 1405",
							"1427": "合作金庫商業銀行石牌分行 1427",
							"1438": "合作金庫商業銀行西屯分行 1438",
							"1449": "合作金庫商業銀行雙和分行 1449",
							"1450": "合作金庫商業銀行土城分行 1450",
							"1461": "合作金庫商業銀行光華分行 1461",
							"1472": "合作金庫商業銀行北台南分行 1472",
							"1483": "合作金庫商業銀行興鳳分行 1483",
							"1494": "合作金庫商業銀行北屯分行 1494",
							"1508": "合作金庫商業銀行一心路分行 1508",
							"1519": "合作金庫商業銀行三峽分行 1519",
							"1520": "合作金庫商業銀行北嘉義分行 1520",
							"1531": "合作金庫商業銀行永康分行 1531",
							"1542": "合作金庫商業銀行平鎮分行 1542",
							"1553": "合作金庫商業銀行大發分行 1553",
							"1564": "合作金庫商業銀行內湖分行 1564",
							"1575": "合作金庫商業銀行光復分行 1575",
							"1586": "合作金庫商業銀行二重分行 1586",
							"1601": "合作金庫商業銀行北台中分行 1601",
							"1656": "合作金庫商業銀行軍功分行 1656",
							"1715": "合作金庫商業銀行永安分行 1715",
							"1726": "合作金庫商業銀行中權分行 1726",
							"1759": "合作金庫商業銀行太原分行 1759",
							"1760": "合作金庫商業銀行松竹分行 1760",
							"1852": "合作金庫商業銀行中清分行 1852",
							"1885": "合作金庫商業銀行建成分行 1885",
							"1900": "合作金庫商業銀行朝馬分行 1900",
							"1966": "合作金庫商業銀行東台中分行 1966",
							"1988": "合作金庫商業銀行美村分行 1988",
							"2000": "合作金庫商業銀行黎明分行 2000",
							"2033": "合作金庫商業銀行昌平分行 2033",
							"2044": "合作金庫商業銀行精武分行 2044",
							"2055": "合作金庫商業銀行文心分行 2055",
							"2077": "合作金庫商業銀行神岡分行 2077",
							"3030": "合作金庫商業銀行大竹分行 3030",
							"3074": "合作金庫商業銀行林內分行 3074",
							"3100": "合作金庫商業銀行南港分行 3100",
							"3111": "合作金庫商業銀行伸港分行 3111",
							"3122": "合作金庫商業銀行五股分行 3122",
							"3133": "合作金庫商業銀行樹林分行 3133",
							"3144": "合作金庫商業銀行信用卡部 3144",
							"3155": "合作金庫商業銀行林口分行 3155",
							"3166": "合作金庫商業銀行左營分行 3166",
							"3177": "合作金庫商業銀行泰山分行 3177",
							"3199": "合作金庫商業銀行大坪林分行 3199",
							"3373": "合作金庫商業銀行鶯歌分行 3373",
							"3395": "合作金庫商業銀行鹿港分行 3395",
							"3409": "合作金庫商業銀行新樹分行 3409",
							"3410": "合作金庫商業銀行六家分行 3410",
							"3421": "合作金庫商業銀行大雅分行 3421",
							"3443": "合作金庫商業銀行八德分行 3443",
							"3465": "合作金庫商業銀行鼓山分行 3465",
							"3476": "合作金庫商業銀行大社分行 3476",
							"3498": "合作金庫商業銀行逢甲分行 3498",
							"3502": "合作金庫商業銀行立德分行 3502",
							"3513": "合作金庫商業銀行林園分行 3513",
							"3524": "合作金庫商業銀行高雄科技園區分行 3524",
							"3535": "合作金庫商業銀行蘆竹分行 3535",
							"3546": "合作金庫商業銀行北中和分行 3546",
							"3557": "合作金庫商業銀行新湖分行 3557",
							"3568": "合作金庫商業銀行丹鳳分行 3568",
							"3580": "合作金庫商業銀行旗山分行 3580",
							"3591": "合作金庫商業銀行大園分行 3591",
							"3605": "合作金庫商業銀行南土城分行 3605",
							"3616": "合作金庫商業銀行潭子分行 3616",
							"3627": "合作金庫商業銀行后里分行 3627",
							"3638": "合作金庫商業銀行長庚分行 3638",
							"3649": "合作金庫商業銀行楠梓分行 3649",
							"5012": "合作金庫商業銀行自強分行 5012",
							"5023": "合作金庫商業銀行中山分行 5023",
							"5034": "合作金庫商業銀行敦南分行 5034",
							"5056": "合作金庫商業銀行世貿分行 5056",
							"5078": "合作金庫商業銀行光復南路分行 5078",
							"5089": "合作金庫商業銀行北士林分行 5089",
							"5090": "合作金庫商業銀行信維分行 5090",
							"5104": "合作金庫商業銀行西湖分行 5104",
							"5115": "合作金庫商業銀行大湖分行 5115",
							"5137": "合作金庫商業銀行國醫中心分行 5137",
							"5159": "合作金庫商業銀行南門分行 5159",
							"5160": "合作金庫商業銀行新中分行 5160",
							"5171": "合作金庫商業銀行中港分行 5171",
							"5182": "合作金庫商業銀行衛道分行 5182",
							"5193": "合作金庫商業銀行忠明南路分行 5193",
							"5207": "合作金庫商業銀行東基隆分行 5207",
							"5218": "合作金庫商業銀行赤崁分行 5218",
							"5229": "合作金庫商業銀行府城分行 5229",
							"5230": "合作金庫商業銀行開元分行 5230",
							"5241": "合作金庫商業銀行港都分行 5241",
							"5252": "合作金庫商業銀行七賢分行 5252",
							"5274": "合作金庫商業銀行十全分行 5274",
							"5285": "合作金庫商業銀行九如分行 5285",
							"5296": "合作金庫商業銀行小港分行 5296",
							"5300": "合作金庫商業銀行北三峽分行 5300",
							"5311": "合作金庫商業銀行板新分行 5311",
							"5322": "合作金庫商業銀行南三重分行 5322",
							"5355": "合作金庫商業銀行寶橋分行 5355",
							"5366": "合作金庫商業銀行新泰分行 5366",
							"5377": "合作金庫商業銀行北土城分行 5377",
							"5388": "合作金庫商業銀行南汐止分行 5388",
							"5399": "合作金庫商業銀行北樹林分行 5399",
							"5403": "合作金庫商業銀行五股工業區分行 5403",
							"5414": "合作金庫商業銀行北羅東分行 5414",
							"5425": "合作金庫商業銀行礁溪分行 5425",
							"5436": "合作金庫商業銀行東桃園分行 5436",
							"5447": "合作金庫商業銀行壢新分行 5447",
							"5458": "合作金庫商業銀行南崁分行 5458",
							"5470": "合作金庫商業銀行新明分行 5470",
							"5481": "合作金庫商業銀行楊梅分行 5481",
							"5492": "合作金庫商業銀行東台東分行 5492",
							"5517": "合作金庫商業銀行東竹北分行 5517",
							"5528": "合作金庫商業銀行北苗栗分行 5528",
							"5539": "合作金庫商業銀行竹南分行 5539",
							"5540": "合作金庫商業銀行豐中分行 5540",
							"5551": "合作金庫商業銀行北大里分行 5551",
							"5562": "合作金庫商業銀行東沙鹿分行 5562",
							"5573": "合作金庫商業銀行草屯分行 5573",
							"5584": "合作金庫商業銀行集集分行 5584",
							"5595": "合作金庫商業銀行東埔里分行 5595",
							"5609": "合作金庫商業銀行員新分行 5609",
							"5610": "合作金庫商業銀行南彰化分行 5610",
							"5621": "合作金庫商業銀行北斗分行 5621",
							"5632": "合作金庫商業銀行竹塹分行 5632",
							"5643": "合作金庫商業銀行新竹科學園區分行 5643",
							"5665": "合作金庫商業銀行雲林分行 5665",
							"5687": "合作金庫商業銀行北朴子分行 5687",
							"5698": "合作金庫商業銀行北新營分行 5698",
							"5702": "合作金庫商業銀行仁德分行 5702",
							"5713": "合作金庫商業銀行南永康分行 5713",
							"5735": "合作金庫商業銀行鳳松分行 5735",
							"5746": "合作金庫商業銀行北岡山分行 5746",
							"5757": "合作金庫商業銀行美濃分行 5757",
							"5768": "合作金庫商業銀行大樹分行 5768",
							"5816": "合作金庫商業銀行東港分行 5816",
							"5827": "合作金庫商業銀行萬丹分行 5827",
							"5838": "合作金庫商業銀行枋寮分行 5838",
							"5849": "合作金庫商業銀行東嘉義分行 5849",
							"5850": "合作金庫商業銀行北花蓮分行 5850",
							"5919": "合作金庫商業銀行大直分行 5919",
							"5942": "合作金庫商業銀行水湳分行 5942",
							"6064": "合作金庫商業銀行仁美分行 6064",
							"6097": "合作金庫商業銀行社皮分行 6097",
							"6123": "合作金庫商業銀行港湖分行 6123",
							"6868": "合作金庫商業銀行保險代理部 6868",
							"9009": "合作金庫商業銀行馬尼拉分行 9009",
							"9021": "合作金庫商業銀行五甲分行 9021",
							"9043": "合作金庫商業銀行淡水分行 9043",
							"9054": "合作金庫商業銀行(子行)-臺灣聯合銀行 9054",
							"9065": "合作金庫商業銀行香港分行 9065",
							"9076": "合作金庫商業銀行北京代表人辦事處 9076",
							"9087": "合作金庫商業銀行雪梨分行 9087",
							"9098": "合作金庫商業銀行蘇州分行 9098",
							"9102": "合作金庫商業銀行蘇州高新支行 9102",
							"9113": "合作金庫商業銀行天津分行 9113",
							"9124": "合作金庫商業銀行福州分行 9124",
							"9135": "合作金庫商業銀行金邊分行德他拉支行 9135",
							"9146": "合作金庫商業銀行金邊分行菩森芷支行 9146",
							"9157": "合作金庫商業銀行紐約分行 9157",
							"9168": "合作金庫商業銀行金邊分行暹粒支行 9168",
							"9179": "合作金庫商業銀行仰光代表人辦事處 9179",
							"9180": "合作金庫商業銀行長沙分行 9180",
							"9191": "合作金庫商業銀行金邊分行永盛支行 9191",
							"9205": "合作金庫商業銀行金邊分行西哈努克支行 9205",
							"9951": "合作金庫商業銀行金邊分行市中心支行 9951",
							"9962": "合作金庫商業銀行墨爾本分行 9962",
							"9973": "合作金庫商業銀行金邊分行 9973",
							"9984": "合作金庫商業銀行洛杉磯分行 9984",
							"9995": "合作金庫商業銀行西雅圖分行 9995"
						}
					},
					"007": {
						"one": "第一商業銀行 007",
						"two": {
							"0731": "第一商業銀行信託處 0731",
							"0937": "第一商業銀行營業部 0937",
							"0948": "第一商業銀行安和分行 0948",
							"0959": "第一商業銀行國際金融業務分行 0959",
							"1015": "第一商業銀行南港分行 1015",
							"1026": "第一商業銀行西門分行 1026",
							"1037": "第一商業銀行忠孝路分行 1037",
							"1059": "第一商業銀行東湖分行 1059",
							"1060": "第一商業銀行景美分行 1060",
							"1071": "第一商業銀行大直分行 1071",
							"1118": "第一商業銀行大稻埕分行 1118",
							"1130": "第一商業銀行信維分行 1130",
							"1211": "第一商業銀行建成分行 1211",
							"1299": "第一商業銀行華山分行 1299",
							"1314": "第一商業銀行大同分行 1314",
							"1336": "第一商業銀行新生分行 1336",
							"1358": "第一商業銀行劍潭分行 1358",
							"1406": "第一商業銀行圓山分行 1406",
							"1417": "第一商業銀行中山分行 1417",
							"1428": "第一商業銀行中崙分行 1428",
							"1439": "第一商業銀行南京東路分行 1439",
							"1440": "第一商業銀行城東分行 1440",
							"1451": "第一商業銀行民生分行 1451",
							"1462": "第一商業銀行松江分行 1462",
							"1473": "第一商業銀行民權分行 1473",
							"1484": "第一商業銀行八德分行 1484",
							"1495": "第一商業銀行長春分行 1495",
							"1509": "第一商業銀行內湖分行 1509",
							"1510": "第一商業銀行松山分行 1510",
							"1521": "第一商業銀行延吉分行 1521",
							"1532": "第一商業銀行光復分行 1532",
							"1554": "第一商業銀行興雅分行 1554",
							"1576": "第一商業銀行永春分行 1576",
							"1587": "第一商業銀行內科園區分行 1587",
							"1598": "第一商業銀行吉林分行 1598",
							"1602": "第一商業銀行仁愛分行 1602",
							"1613": "第一商業銀行大安分行 1613",
							"1624": "第一商業銀行信義分行 1624",
							"1635": "第一商業銀行復興分行 1635",
							"1646": "第一商業銀行敦化分行 1646",
							"1657": "第一商業銀行仁和分行 1657",
							"1668": "第一商業銀行世貿分行 1668",
							"1679": "第一商業銀行木柵分行 1679",
							"1680": "第一商業銀行松貿分行 1680",
							"1691": "第一商業銀行新湖分行 1691",
							"1716": "第一商業銀行古亭分行 1716",
							"1727": "第一商業銀行南門分行 1727",
							"1738": "第一商業銀行公館分行 1738",
							"1761": "第一商業銀行和平分行 1761",
							"1819": "第一商業銀行萬華分行 1819",
							"1831": "第一商業銀行雙園分行 1831",
							"1901": "第一商業銀行天母分行 1901",
							"1912": "第一商業銀行北投分行 1912",
							"1923": "第一商業銀行士林分行 1923",
							"1934": "第一商業銀行建國分行 1934",
							"1945": "第一商業銀行萬隆分行 1945",
							"1956": "第一商業銀行石牌分行 1956",
							"2012": "第一商業銀行板橋分行 2012",
							"2023": "第一商業銀行華江分行 2023",
							"2034": "第一商業銀行樹林分行 2034",
							"2056": "第一商業銀行土城分行 2056",
							"2067": "第一商業銀行江子翠分行 2067",
							"2078": "第一商業銀行北土城分行 2078",
							"2089": "第一商業銀行林口工二分行 2089",
							"2115": "第一商業銀行三重埔分行 2115",
							"2126": "第一商業銀行長泰分行 2126",
							"2137": "第一商業銀行蘆洲分行 2137",
							"2148": "第一商業銀行頭前分行 2148",
							"2159": "第一商業銀行五股分行 2159",
							"2160": "第一商業銀行重陽分行 2160",
							"2171": "第一商業銀行五股工業區分行 2171",
							"2182": "第一商業銀行淡水分行 2182",
							"2218": "第一商業銀行新店分行 2218",
							"2229": "第一商業銀行大坪林分行 2229",
							"2300": "第一商業銀行泰山分行 2300",
							"2311": "第一商業銀行新莊分行 2311",
							"2322": "第一商業銀行鶯歌分行 2322",
							"2333": "第一商業銀行中和分行 2333",
							"2344": "第一商業銀行永和分行 2344",
							"2355": "第一商業銀行雙和分行 2355",
							"2366": "第一商業銀行連城分行 2366",
							"2377": "第一商業銀行瑞芳分行 2377",
							"2388": "第一商業銀行埔墘分行 2388",
							"2399": "第一商業銀行丹鳳分行 2399",
							"2414": "第一商業銀行基隆分行 2414",
							"2436": "第一商業銀行哨船頭分行 2436",
							"2458": "第一商業銀行汐止分行 2458",
							"2469": "第一商業銀行汐科分行 2469",
							"2470": "第一商業銀行幸福分行 2470",
							"2517": "第一商業銀行宜蘭分行 2517",
							"2610": "第一商業銀行羅東分行 2610",
							"2621": "第一商業銀行蘇澳分行 2621",
							"2713": "第一商業銀行桃園分行 2713",
							"2724": "第一商業銀行北桃分行 2724",
							"2791": "第一商業銀行大湳分行 2791",
							"2805": "第一商業銀行內壢分行 2805",
							"2816": "第一商業銀行中壢分行 2816",
							"2827": "第一商業銀行西壢分行 2827",
							"2838": "第一商業銀行平鎮分行 2838",
							"2849": "第一商業銀行大園分行 2849",
							"2850": "第一商業銀行南崁分行 2850",
							"2872": "第一商業銀行迴龍分行 2872",
							"2908": "第一商業銀行林口分行 2908",
							"2919": "第一商業銀行大溪分行 2919",
							"2920": "第一商業銀行龍潭分行 2920",
							"3019": "第一商業銀行新竹分行 3019",
							"3020": "第一商業銀行東門分行 3020",
							"3031": "第一商業銀行竹科分行 3031",
							"3112": "第一商業銀行竹東分行 3112",
							"3123": "第一商業銀行關西分行 3123",
							"3134": "第一商業銀行竹北分行 3134",
							"3215": "第一商業銀行苗栗分行 3215",
							"3318": "第一商業銀行竹南分行 3318",
							"3329": "第一商業銀行頭份分行 3329",
							"4016": "第一商業銀行台中分行 4016",
							"4027": "第一商業銀行南台中分行 4027",
							"4038": "第一商業銀行北台中分行 4038",
							"4049": "第一商業銀行中港分行 4049",
							"4050": "第一商業銀行北屯分行 4050",
							"4061": "第一商業銀行進化分行 4061",
							"4072": "第一商業銀行南屯分行 4072",
							"4119": "第一商業銀行豐原分行 4119",
							"4120": "第一商業銀行大里分行 4120",
							"4153": "第一商業銀行中科分行 4153",
							"4212": "第一商業銀行東勢分行 4212",
							"4223": "第一商業銀行沙鹿分行 4223",
							"4234": "第一商業銀行大甲分行 4234",
							"4245": "第一商業銀行太平分行 4245",
							"4256": "第一商業銀行清水分行 4256",
							"4267": "第一商業銀行大雅分行 4267",
							"4315": "第一商業銀行南投分行 4315",
							"4418": "第一商業銀行草屯分行 4418",
							"4429": "第一商業銀行埔里分行 4429",
							"4511": "第一商業銀行彰化分行 4511",
							"4614": "第一商業銀行員林分行 4614",
							"4625": "第一商業銀行鹿港分行 4625",
							"4636": "第一商業銀行溪湖分行 4636",
							"4647": "第一商業銀行北斗分行 4647",
							"4717": "第一商業銀行和美分行 4717",
							"5013": "第一商業銀行嘉義分行 5013",
							"5035": "第一商業銀行興嘉分行 5035",
							"5116": "第一商業銀行朴子分行 5116",
							"5219": "第一商業銀行斗六分行 5219",
							"5312": "第一商業銀行北港分行 5312",
							"5323": "第一商業銀行西螺分行 5323",
							"5334": "第一商業銀行虎尾分行 5334",
							"6010": "第一商業銀行台南分行 6010",
							"6043": "第一商業銀行富強分行 6043",
							"6054": "第一商業銀行赤崁分行 6054",
							"6065": "第一商業銀行竹溪分行 6065",
							"6076": "第一商業銀行金城分行 6076",
							"6087": "第一商業銀行安南分行 6087",
							"6113": "第一商業銀行新營分行 6113",
							"6216": "第一商業銀行鹽水分行 6216",
							"6227": "第一商業銀行麻豆分行 6227",
							"6238": "第一商業銀行善化分行 6238",
							"6249": "第一商業銀行佳里分行 6249",
							"6250": "第一商業銀行新化分行 6250",
							"6261": "第一商業銀行大灣分行 6261",
							"6283": "第一商業銀行南科園區分行 6283",
							"6294": "第一商業銀行歸仁分行 6294",
							"6308": "第一商業銀行永康分行 6308",
							"7017": "第一商業銀行高雄分行 7017",
							"7028": "第一商業銀行鹽埕分行 7028",
							"7039": "第一商業銀行新興分行 7039",
							"7040": "第一商業銀行三民分行 7040",
							"7051": "第一商業銀行苓雅分行 7051",
							"7062": "第一商業銀行左營分行 7062",
							"7073": "第一商業銀行楠梓分行 7073",
							"7084": "第一商業銀行五福分行 7084",
							"7095": "第一商業銀行十全分行 7095",
							"7109": "第一商業銀行前鎮分行 7109",
							"7110": "第一商業銀行灣內分行 7110",
							"7121": "第一商業銀行博愛分行 7121",
							"7143": "第一商業銀行小港分行 7143",
							"7202": "第一商業銀行五甲分行 7202",
							"7213": "第一商業銀行鳳山分行 7213",
							"7305": "第一商業銀行路竹分行 7305",
							"7316": "第一商業銀行岡山分行 7316",
							"7327": "第一商業銀行旗山分行 7327",
							"7338": "第一商業銀行林園分行 7338",
							"7419": "第一商業銀行屏東分行 7419",
							"7512": "第一商業銀行潮州分行 7512",
							"7523": "第一商業銀行東港分行 7523",
							"7534": "第一商業銀行恆春分行 7534",
							"7785": "第一商業銀行梓本分行 7785",
							"7855": "第一商業銀行萬巒分行 7855",
							"8014": "第一商業銀行花蓮分行 8014",
							"8117": "第一商業銀行台東分行 8117",
							"8210": "第一商業銀行澎湖分行 8210",
							"8438": "第一商業銀行上海分行自貿區支行 8438",
							"8829": "第一商業銀行金邊分行中洲支行 8829",
							"8830": "第一商業銀行金邊分行奧林匹克支行 8830",
							"8841": "第一商業銀行金邊分行桑園支行 8841",
							"8852": "第一商業銀行金邊分行堆谷支行 8852",
							"8863": "第一商業銀行金邊分行水淨華支行 8863",
							"8874": "第一商業銀行金邊分行永盛支行 8874",
							"8885": "第一商業銀行金邊分行暹粒支行 8885",
							"9011": "第一商業銀行關島分行 9011",
							"9022": "第一商業銀行紐約分行 9022",
							"9033": "第一商業銀行洛杉磯分行 9033",
							"9044": "第一商業銀行美國第一銀行 9044",
							"9055": "第一商銀美國第一銀行工業市分行 9055",
							"9066": "第一商銀美國第一銀行矽谷分行 9066",
							"9077": "第一商銀美國第一銀行爾灣分行 9077",
							"9088": "第一商業銀行溫哥華分行 9088",
							"9099": "第一商業銀行多倫多分行 9099",
							"9114": "第一商業銀行新加坡分行 9114",
							"9136": "第一商業銀行曼谷代表辦事處 9136",
							"9147": "第一商業銀行河內市分行 9147",
							"9158": "第一商業銀行仰光代表辦事處 9158",
							"9181": "第一商業銀行金邊分行 9181",
							"9206": "第一商業銀行胡志明市分行 9206",
							"9217": "第一商業銀行倫敦分行 9217",
							"9239": "第一商業銀行馬尼拉分行 9239",
							"9284": "第一商業銀行永珍分行 9284",
							"9309": "第一商銀美國第一銀行佛利蒙分行 9309",
							"9413": "第一商業銀行香港分行 9413",
							"9424": "第一商業銀行上海分行 9424",
							"9457": "第一商業銀行澳門分行 9457",
							"9468": "第一商業銀行成都分行 9468",
							"9480": "第一商業銀行廈門分行 9480",
							"9516": "第一商業銀行東京分行 9516",
							"9527": "第一商業銀行美國第一銀行奇諾崗分行 9527",
							"9620": "第一商業銀行布里斯本分行 9620",
							"9996": "第一商業銀行美國第一銀行亞凱迪亞分行 9996"
						}
					},
					"008": {
						"one": "華南商業銀行 008",
						"two": {
							"0069": "華南商業銀行信託部 0069",
							"0709": "華南商業銀行國際金融業務分行 0709",
							"0765": "華南商業銀行個金行銷部 0765",
							"1005": "華南商業銀行營業部 1005",
							"1016": "華南商業銀行儲蓄分行 1016",
							"1027": "華南商業銀行國際金融部 1027",
							"1038": "華南商業銀行城內分行 1038",
							"1049": "華南商業銀行大稻埕分行 1049",
							"1050": "華南商業銀行建成分行 1050",
							"1061": "華南商業銀行中山分行 1061",
							"1072": "華南商業銀行圓山分行 1072",
							"1083": "華南商業銀行城東分行 1083",
							"1094": "華南商業銀行西門分行 1094",
							"1108": "華南商業銀行南松山分行 1108",
							"1119": "華南商業銀行仁愛路分行 1119",
							"1120": "華南商業銀行南京東路分行 1120",
							"1131": "華南商業銀行新生分行 1131",
							"1142": "華南商業銀行大同分行 1142",
							"1153": "華南商業銀行松山分行 1153",
							"1164": "華南商業銀行中崙分行 1164",
							"1175": "華南商業銀行台北南門分行 1175",
							"1186": "華南商業銀行公館分行 1186",
							"1197": "華南商業銀行信義分行 1197",
							"1201": "華南商業銀行忠孝東路分行 1201",
							"1212": "華南商業銀行和平分行 1212",
							"1223": "華南商業銀行雙園分行 1223",
							"1234": "華南商業銀行士林分行 1234",
							"1245": "華南商業銀行東台北分行 1245",
							"1256": "華南商業銀行大安分行 1256",
							"1267": "華南商業銀行民生分行 1267",
							"1278": "華南商業銀行復興分行 1278",
							"1289": "華南商業銀行龍江分行 1289",
							"1290": "華南商業銀行永吉分行 1290",
							"1304": "華南商業銀行敦化分行 1304",
							"1326": "華南商業銀行大直分行 1326",
							"1337": "華南商業銀行敦和分行 1337",
							"1348": "華南商業銀行東湖分行 1348",
							"1360": "華南商業銀行東興分行 1360",
							"1371": "華南商業銀行北南港分行 1371",
							"1382": "華南商業銀行木柵分行 1382",
							"1393": "華南商業銀行板橋文化分行 1393",
							"1430": "華南商業銀行南內湖分行 1430",
							"1452": "華南商業銀行長安分行 1452",
							"1474": "華南商業銀行懷生分行 1474",
							"1485": "華南商業銀行中華路分行 1485",
							"1496": "華南商業銀行信維分行 1496",
							"1511": "華南商業銀行埔墘分行 1511",
							"1522": "華南商業銀行石牌分行 1522",
							"1533": "華南商業銀行瑞祥分行 1533",
							"1544": "華南商業銀行台大分行 1544",
							"1566": "華南商業銀行世貿分行 1566",
							"1577": "華南商業銀行萬華分行 1577",
							"1588": "華南商業銀行南港分行 1588",
							"1599": "華南商業銀行華江分行 1599",
							"1603": "華南商業銀行板橋分行 1603",
							"1614": "華南商業銀行三重分行 1614",
							"1625": "華南商業銀行北三重分行 1625",
							"1636": "華南商業銀行新莊分行 1636",
							"1647": "華南商業銀行永和分行 1647",
							"1658": "華南商業銀行中和分行 1658",
							"1669": "華南商業銀行新店分行 1669",
							"1670": "華南商業銀行淡水分行 1670",
							"1681": "華南商業銀行汐止分行 1681",
							"1692": "華南商業銀行南永和分行 1692",
							"1706": "華南商業銀行西三重分行 1706",
							"1717": "華南商業銀行南三重分行 1717",
							"1728": "華南商業銀行雙和分行 1728",
							"1739": "華南商業銀行新泰分行 1739",
							"1740": "華南商業銀行二重分行 1740",
							"1751": "華南商業銀行板新分行 1751",
							"1762": "華南商業銀行五股分行 1762",
							"1784": "華南商業銀行北投分行 1784",
							"1795": "華南商業銀行西湖分行 1795",
							"1809": "華南商業銀行積穗分行 1809",
							"1821": "華南商業銀行福和分行 1821",
							"1832": "華南商業銀行南勢角分行 1832",
							"1843": "華南商業銀行北蘆洲分行 1843",
							"1854": "華南商業銀行蘆洲分行 1854",
							"1865": "華南商業銀行土城分行 1865",
							"1876": "華南商業銀行北新分行 1876",
							"1898": "華南商業銀行天母分行 1898",
							"1902": "華南商業銀行內湖分行 1902",
							"1913": "華南商業銀行樹林分行 1913",
							"1924": "華南商業銀行樟樹灣分行 1924",
							"1935": "華南商業銀行泰山分行 1935",
							"1946": "華南商業銀行三峽分行 1946",
							"1957": "華南商業銀行文山分行 1957",
							"1968": "華南商業銀行鶯歌分行 1968",
							"1979": "華南商業銀行北新莊分行 1979",
							"1980": "華南商業銀行北土城分行 1980",
							"1991": "華南商業銀行林口站前分行 1991",
							"2002": "華南商業銀行基隆分行 2002",
							"2013": "華南商業銀行基隆港口分行 2013",
							"2116": "華南商業銀行七堵分行 2116",
							"2208": "華南商業銀行羅東分行 2208",
							"2219": "華南商業銀行宜蘭分行 2219",
							"2404": "華南商業銀行桃園分行 2404",
							"2415": "華南商業銀行中壢分行 2415",
							"2426": "華南商業銀行楊梅分行 2426",
							"2437": "華南商業銀行壢昌分行 2437",
							"2448": "華南商業銀行北桃園分行 2448",
							"2459": "華南商業銀行南崁分行 2459",
							"2460": "華南商業銀行平鎮分行 2460",
							"2471": "華南商業銀行八德分行 2471",
							"2482": "華南商業銀行龜山分行 2482",
							"2493": "華南商業銀行龍潭分行 2493",
							"2507": "華南商業銀行大溪分行 2507",
							"2518": "華南商業銀行內壢分行 2518",
							"2529": "華南商業銀行林口分行 2529",
							"2600": "華南商業銀行觀音分行 2600",
							"2622": "華南商業銀行大園分行 2622",
							"3009": "華南商業銀行新竹分行 3009",
							"3010": "華南商業銀行竹東分行 3010",
							"3021": "華南商業銀行竹科分行 3021",
							"3102": "華南商業銀行新豐分行 3102",
							"3135": "華南商業銀行六家分行 3135",
							"3205": "華南商業銀行竹南分行 3205",
							"3216": "華南商業銀行頭份分行 3216",
							"3227": "華南商業銀行苗栗分行 3227",
							"3238": "華南商業銀行竹北分行 3238",
							"3515": "華南商業銀行大眾分行 3515",
							"4006": "華南商業銀行豐原分行 4006",
							"4017": "華南商業銀行東勢分行 4017",
							"4028": "華南商業銀行清水分行 4028",
							"4039": "華南商業銀行西豐原分行 4039",
							"4202": "華南商業銀行台中分行 4202",
							"4224": "華南商業銀行南台中分行 4224",
							"4235": "華南商業銀行北台中分行 4235",
							"4246": "華南商業銀行台中港路分行 4246",
							"4257": "華南商業銀行大里分行 4257",
							"4268": "華南商業銀行水湳分行 4268",
							"4279": "華南商業銀行五權分行 4279",
							"4291": "華南商業銀行大甲分行 4291",
							"4305": "華南商業銀行太平分行 4305",
							"4316": "華南商業銀行中科分行 4316",
							"4512": "華南商業銀行沙鹿分行 4512",
							"5003": "華南商業銀行草屯分行 5003",
							"5014": "華南商業銀行南投分行 5014",
							"5209": "華南商業銀行彰化分行 5209",
							"5210": "華南商業銀行和美分行 5210",
							"5221": "華南商業銀行員林分行 5221",
							"5232": "華南商業銀行鹿港分行 5232",
							"5243": "華南商業銀行溪湖分行 5243",
							"5405": "華南商業銀行斗六分行 5405",
							"5416": "華南商業銀行虎尾分行 5416",
							"5427": "華南商業銀行西螺分行 5427",
							"6000": "華南商業銀行嘉義分行 6000",
							"6011": "華南商業銀行嘉南分行 6011",
							"6022": "華南商業銀行朴子分行 6022",
							"6206": "華南商業銀行新營分行 6206",
							"6217": "華南商業銀行麻豆分行 6217",
							"6228": "華南商業銀行永康分行 6228",
							"6402": "華南商業銀行台南分行 6402",
							"6424": "華南商業銀行東台南分行 6424",
							"6435": "華南商業銀行西台南分行 6435",
							"6446": "華南商業銀行北台南分行 6446",
							"6457": "華南商業銀行南都分行 6457",
							"6468": "華南商業銀行安南分行 6468",
							"6479": "華南商業銀行仁德分行 6479",
							"6480": "華南商業銀行新市分行 6480",
							"6815": "華南商業銀行金華分行 6815",
							"7007": "華南商業銀行高雄分行 7007",
							"7018": "華南商業銀行東苓分行 7018",
							"7029": "華南商業銀行新興分行 7029",
							"7030": "華南商業銀行高雄三民分行 7030",
							"7041": "華南商業銀行苓雅分行 7041",
							"7052": "華南商業銀行前鎮分行 7052",
							"7063": "華南商業銀行高雄博愛分行 7063",
							"7074": "華南商業銀行南高雄分行 7074",
							"7085": "華南商業銀行東高雄分行 7085",
							"7096": "華南商業銀行大昌分行 7096",
							"7100": "華南商業銀行北高雄分行 7100",
							"7111": "華南商業銀行楠梓分行 7111",
							"7122": "華南商業銀行左營分行 7122",
							"7199": "華南商業銀行岡山分行 7199",
							"7203": "華南商業銀行鳳山分行 7203",
							"7214": "華南商業銀行路竹分行 7214",
							"7225": "華南商業銀行仁武分行 7225",
							"7513": "華南商業銀行籬仔內分行 7513",
							"7524": "華南商業銀行五甲分行 7524",
							"7535": "華南商業銀行光華分行 7535",
							"7605": "華南商業銀行小港分行 7605",
							"7650": "華南商業銀行高雄桂林分行 7650",
							"8004": "華南商業銀行屏東分行 8004",
							"8015": "華南商業銀行內埔分行 8015",
							"8026": "華南商業銀行潮州分行 8026",
							"8130": "華南商業銀行佳冬分行 8130",
							"8200": "華南商業銀行花蓮分行 8200",
							"8303": "華南商業銀行台東分行 8303",
							"8886": "華南商業銀行營運總部分行 8886",
							"9012": "華南商業銀行洛杉磯分行 9012",
							"9023": "華南商業銀行紐約分行 9023",
							"9034": "華南商業銀行倫敦分行 9034",
							"9056": "華南商業銀行香港分行 9056",
							"9078": "華南商業銀行新加坡分行 9078",
							"9090": "華南商業銀行深圳分行 9090",
							"9104": "華南商業銀行胡志明市分行 9104",
							"9126": "華南商業銀行河內代表辦事處 9126",
							"9137": "華南商業銀行澳門分行 9137",
							"9148": "華南商業銀行雪梨分行 9148",
							"9159": "華南商業銀行深圳寶安支行 9159",
							"9160": "華南商業銀行上海分行 9160",
							"9171": "華南商業銀行福州分行 9171",
							"9182": "華南商業銀行菲律賓馬尼拉分行 9182",
							"9193": "華南商業銀行仰光代表人辦事處 9193"
						}
					},
					"009": {
						"one": "彰化商業銀行 009",
						"two": {
							"0888": "彰銀商業銀行有限公司 0888",
							"1094": "彰化商業銀行信託處 1094",
							"2026": "彰化商業銀行新加坡分行 2026",
							"2033": "彰銀商業銀行有限公司昆山分行 2033",
							"2040": "彰化商業銀行股份有限公司馬尼拉分行 2040",
							"2057": "彰銀商業銀行有限公司昆山花橋支行 2057",
							"2071": "彰銀商業銀行有限公司東莞分行 2071",
							"2088": "彰銀商業銀行有限公司福州分行 2088",
							"2095": "彰化商業銀行仰光代表人辦事處 2095",
							"2113": "彰化商業銀行國際營運處 2113",
							"2120": "彰化商業銀行國際金融業務分行 2120",
							"2144": "彰化商業銀行紐約分行 2144",
							"2151": "彰化商業銀行洛杉磯分行 2151",
							"2168": "彰化商業銀行東京分行 2168",
							"2175": "彰化商業銀行倫敦分行 2175",
							"2199": "彰化商業銀行香港分行 2199",
							"2200": "彰化商業銀行總行營業部 2200",
							"2606": "彰銀商業銀行有限公司南京分行 2606",
							"3003": "彰化商業銀行吉林分行 3003",
							"3010": "彰化商業銀行城內分行 3010",
							"4004": "彰化商業銀行北台中分行 4004",
							"4011": "彰化商業銀行南台中分行 4011",
							"4028": "彰化商業銀行北屯分行 4028",
							"4035": "彰化商業銀行水湳分行 4035",
							"4042": "彰化商業銀行南屯分行 4042",
							"4059": "彰化商業銀行台中分行 4059",
							"4108": "彰化商業銀行基隆分行 4108",
							"4115": "彰化商業銀行仁愛分行 4115",
							"4122": "彰化商業銀行東基隆分行 4122",
							"4202": "彰化商業銀行宜蘭分行 4202",
							"4219": "彰化商業銀行羅東分行 4219",
							"5005": "彰化商業銀行北門分行 5005",
							"5012": "彰化商業銀行台北分行 5012",
							"5029": "彰化商業銀行萬華分行 5029",
							"5036": "彰化商業銀行西門分行 5036",
							"5043": "彰化商業銀行永樂分行 5043",
							"5050": "彰化商業銀行建成分行 5050",
							"5067": "彰化商業銀行大同分行 5067",
							"5074": "彰化商業銀行承德分行 5074",
							"5081": "彰化商業銀行中山北路分行 5081",
							"5109": "彰化商業銀行東門分行 5109",
							"5116": "彰化商業銀行古亭分行 5116",
							"5123": "彰化商業銀行五分埔分行 5123",
							"5130": "彰化商業銀行大安分行 5130",
							"5147": "彰化商業銀行城東分行 5147",
							"5154": "彰化商業銀行中崙分行 5154",
							"5161": "彰化商業銀行雙園分行 5161",
							"5178": "彰化商業銀行士林分行 5178",
							"5185": "彰化商業銀行總部分行 5185",
							"5192": "彰化商業銀行松山分行 5192",
							"5203": "彰化商業銀行忠孝東路分行 5203",
							"5210": "彰化商業銀行信義分行 5210",
							"5227": "彰化商業銀行東台北分行 5227",
							"5234": "彰化商業銀行民生分行 5234",
							"5241": "彰化商業銀行西松分行 5241",
							"5258": "彰化商業銀行復興分行 5258",
							"5265": "彰化商業銀行台北世貿中心分行 5265",
							"5272": "彰化商業銀行敦化分行 5272",
							"5289": "彰化商業銀行建國分行 5289",
							"5296": "彰化商業銀行內湖分行 5296",
							"5307": "彰化商業銀行天母分行 5307",
							"5314": "彰化商業銀行中正分行 5314",
							"5321": "彰化商業銀行仁和分行 5321",
							"5338": "彰化商業銀行永春分行 5338",
							"5345": "彰化商業銀行光隆分行 5345",
							"5352": "彰化商業銀行木柵分行 5352",
							"5369": "彰化商業銀行新湖分行 5369",
							"5376": "彰化商業銀行東湖分行 5376",
							"5383": "彰化商業銀行南港科學園區分行 5383",
							"5390": "彰化商業銀行北投分行 5390",
							"5401": "彰化商業銀行和平分行 5401",
							"5418": "彰化商業銀行東興分行 5418",
							"5425": "彰化商業銀行龍潭分行 5425",
							"5432": "彰化商業銀行汐科分行 5432",
							"5456": "彰化商業銀行新樹分行 5456",
							"5463": "彰化商業銀行立德分行 5463",
							"5470": "彰化商業銀行泰山分行 5470",
							"5487": "彰化商業銀行五股工業區分行 5487",
							"5494": "彰化商業銀行南新莊分行 5494",
							"5505": "彰化商業銀行三重埔分行 5505",
							"5512": "彰化商業銀行北三重埔分行 5512",
							"5529": "彰化商業銀行新店分行 5529",
							"5536": "彰化商業銀行永和分行 5536",
							"5543": "彰化商業銀行瑞芳分行 5543",
							"5550": "彰化商業銀行新莊分行 5550",
							"5567": "彰化商業銀行樹林分行 5567",
							"5574": "彰化商業銀行板橋分行 5574",
							"5581": "彰化商業銀行三峽分行 5581",
							"5598": "彰化商業銀行福和分行 5598",
							"5609": "彰化商業銀行光復分行 5609",
							"5616": "彰化商業銀行東三重分行 5616",
							"5623": "彰化商業銀行北新分行 5623",
							"5630": "彰化商業銀行南三重分行 5630",
							"5647": "彰化商業銀行中和分行 5647",
							"5654": "彰化商業銀行西三重分行 5654",
							"5661": "彰化商業銀行汐止分行 5661",
							"5678": "彰化商業銀行雙和分行 5678",
							"5685": "彰化商業銀行淡水分行 5685",
							"5692": "彰化商業銀行楊梅分行 5692",
							"5703": "彰化商業銀行桃園分行 5703",
							"5710": "彰化商業銀行中壢分行 5710",
							"5727": "彰化商業銀行新竹分行 5727",
							"5734": "彰化商業銀行竹東分行 5734",
							"5741": "彰化商業銀行苗栗分行 5741",
							"5758": "彰化商業銀行新竹科學園區分行 5758",
							"5765": "彰化商業銀行北中壢分行 5765",
							"5772": "彰化商業銀行八德分行 5772",
							"5789": "彰化商業銀行竹南分行 5789",
							"5796": "彰化商業銀行南崁分行 5796",
							"5807": "彰化商業銀行苑裡分行 5807",
							"5814": "彰化商業銀行大甲分行 5814",
							"5821": "彰化商業銀行清水分行 5821",
							"5838": "彰化商業銀行豐原分行 5838",
							"5845": "彰化商業銀行東勢分行 5845",
							"5852": "彰化商業銀行霧峰分行 5852",
							"5869": "彰化商業銀行大雅分行 5869",
							"5876": "彰化商業銀行沙鹿分行 5876",
							"5890": "彰化商業銀行太平分行 5890",
							"5901": "彰化商業銀行草屯分行 5901",
							"5918": "彰化商業銀行南投分行 5918",
							"5925": "彰化商業銀行埔里分行 5925",
							"5932": "彰化商業銀行水裡坑分行 5932",
							"5963": "彰化商業銀行大肚分行 5963",
							"5987": "彰化商業銀行竹北分行 5987",
							"6006": "彰化商業銀行彰化分行 6006",
							"6013": "彰化商業銀行鹿港分行 6013",
							"6020": "彰化商業銀行員林分行 6020",
							"6037": "彰化商業銀行溪湖分行 6037",
							"6044": "彰化商業銀行北斗分行 6044",
							"6051": "彰化商業銀行西螺分行 6051",
							"6068": "彰化商業銀行和美分行 6068",
							"6075": "彰化商業銀行大里分行 6075",
							"6099": "彰化商業銀行二林分行 6099",
							"6100": "彰化商業銀行斗六分行 6100",
							"6117": "彰化商業銀行斗南分行 6117",
							"6124": "彰化商業銀行虎尾分行 6124",
							"6131": "彰化商業銀行北港分行 6131",
							"6204": "彰化商業銀行大林分行 6204",
							"6211": "彰化商業銀行嘉義分行 6211",
							"6228": "彰化商業銀行東嘉義分行 6228",
							"6235": "彰化商業銀行新營分行 6235",
							"6242": "彰化商業銀行永康分行 6242",
							"6266": "彰化商業銀行歸仁分行 6266",
							"6402": "彰化商業銀行台南分行 6402",
							"6419": "彰化商業銀行延平分行 6419",
							"6426": "彰化商業銀行西台南分行 6426",
							"6433": "彰化商業銀行東台南分行 6433",
							"6440": "彰化商業銀行南台南分行 6440",
							"6457": "彰化商業銀行安南分行 6457",
							"6506": "彰化商業銀行旗山分行 6506",
							"6513": "彰化商業銀行岡山分行 6513",
							"6520": "彰化商業銀行鳳山分行 6520",
							"8119": "彰化商業銀行高雄分行 8119",
							"8126": "彰化商業銀行七賢分行 8126",
							"8133": "彰化商業銀行鹽埕分行 8133",
							"8140": "彰化商業銀行東高雄分行 8140",
							"8157": "彰化商業銀行南高雄分行 8157",
							"8164": "彰化商業銀行北高雄分行 8164",
							"8171": "彰化商業銀行三民分行 8171",
							"8195": "彰化商業銀行前鎮分行 8195",
							"8206": "彰化商業銀行九如路分行 8206",
							"8213": "彰化商業銀行新興分行 8213",
							"8220": "彰化商業銀行苓雅分行 8220",
							"8237": "彰化商業銀行大順分行 8237",
							"8244": "彰化商業銀行博愛分行 8244",
							"8251": "彰化商業銀行左營分行 8251",
							"8300": "彰化商業銀行屏東分行 8300",
							"8317": "彰化商業銀行東港分行 8317",
							"8324": "彰化商業銀行潮州分行 8324",
							"8348": "彰化商業銀行恆春分行 8348",
							"8404": "彰化商業銀行花蓮分行 8404",
							"8508": "彰化商業銀行台東分行 8508",
							"9269": "彰化商業銀行思源分行 9269",
							"9283": "彰化商業銀行土城分行 9283",
							"9290": "彰化商業銀行北桃園分行 9290",
							"9301": "彰化商業銀行新明分行 9301",
							"9318": "彰化商業銀行埔心分行 9318",
							"9332": "彰化商業銀行西屯分行 9332",
							"9349": "彰化商業銀行大發分行 9349",
							"9356": "彰化商業銀行東林口分行 9356",
							"9363": "彰化商業銀行新林口分行 9363",
							"9523": "彰化商業銀行土庫分行 9523",
							"9547": "彰化商業銀行路竹分行 9547",
							"9554": "彰化商業銀行蘇澳分行 9554",
							"9561": "彰化商業銀行北台南分行 9561",
							"9603": "彰化商業銀行潭子分行 9603",
							"9610": "彰化商業銀行北嘉義分行 9610",
							"9627": "彰化商業銀行北新竹分行 9627",
							"9634": "彰化商業銀行建興分行 9634",
							"9641": "彰化商業銀行三和路分行 9641",
							"9658": "彰化商業銀行吉成分行 9658",
							"9689": "彰化商業銀行林口分行 9689",
							"9696": "彰化商業銀行江翠分行 9696",
							"9714": "彰化商業銀行長安東路分行 9714",
							"9721": "彰化商業銀行晴光分行 9721",
							"9738": "彰化商業銀行大直分行 9738",
							"9752": "彰化商業銀行松江分行 9752",
							"9790": "彰化商業銀行西內湖分行 9790",
							"9801": "彰化商業銀行南港分行 9801",
							"9818": "彰化商業銀行中港分行 9818",
							"9832": "彰化商業銀行蘆洲分行 9832",
							"9849": "彰化商業銀行中華路分行 9849"
						}
					},
					"011": {
						"one": "上海商業儲蓄銀行 011",
						"two": {
							"0026": "上海商業儲蓄銀行營業部 0026",
							"0037": "上海商業儲蓄銀行儲蓄部分行 0037",
							"0048": "上海商業儲蓄銀行高雄分行 0048",
							"0059": "上海商業儲蓄銀行國外部 0059",
							"0060": "上海商業儲蓄銀行城中分行 0060",
							"0082": "上海商業儲蓄銀行台中分行 0082",
							"0093": "上海商業儲蓄銀行東台北分行 0093",
							"0107": "上海商業儲蓄銀行台南分行 0107",
							"0118": "上海商業儲蓄銀行桃園分行 0118",
							"0129": "上海商業儲蓄銀行北高雄分行 0129",
							"0130": "上海商業儲蓄銀行三重分行 0130",
							"0141": "上海商業儲蓄銀行板橋分行 0141",
							"0152": "上海商業儲蓄銀行永和分行 0152",
							"0163": "上海商業儲蓄銀行員林分行 0163",
							"0174": "上海商業儲蓄銀行信託部 0174",
							"0185": "上海商業儲蓄銀行信義分行 0185",
							"0196": "上海商業儲蓄銀行民生分行 0196",
							"0200": "上海商業儲蓄銀行忠孝分行 0200",
							"0211": "上海商業儲蓄銀行龍山分行 0211",
							"0222": "上海商業儲蓄銀行內湖分行 0222",
							"0233": "上海商業儲蓄銀行中山分行 0233",
							"0244": "上海商業儲蓄銀行仁愛分行 0244",
							"0255": "上海商業儲蓄銀行新莊分行 0255",
							"0266": "上海商業儲蓄銀行中壢分行 0266",
							"0277": "上海商業儲蓄銀行國際金融業務分行 0277",
							"0288": "上海商業儲蓄銀行松山分行 0288",
							"0299": "上海商業儲蓄銀行新店分行 0299",
							"0303": "上海商業儲蓄銀行前金分行 0303",
							"0314": "上海商業儲蓄銀行松南分行 0314",
							"0325": "上海商業儲蓄銀行蘆洲分行 0325",
							"0336": "上海商業儲蓄銀行中和分行 0336",
							"0347": "上海商業儲蓄銀行新竹分行 0347",
							"0358": "上海商業儲蓄銀行中港分行 0358",
							"0369": "上海商業儲蓄銀行士林分行 0369",
							"0370": "上海商業儲蓄銀行東台南分行 0370",
							"0381": "上海商業儲蓄銀行永康分行 0381",
							"0392": "上海商業儲蓄銀行北三重分行 0392",
							"0406": "上海商業儲蓄銀行南京東路分行 0406",
							"0417": "上海商業儲蓄銀行大里分行 0417",
							"0428": "上海商業儲蓄銀行土城分行 0428",
							"0439": "上海商業儲蓄銀行世貿分行 0439",
							"0440": "上海商業儲蓄銀行承德分行 0440",
							"0451": "上海商業儲蓄銀行汐止分行 0451",
							"0462": "上海商業儲蓄銀行屏東分行 0462",
							"0473": "上海商業儲蓄銀行三民分行 0473",
							"0484": "上海商業儲蓄銀行華江分行 0484",
							"0495": "上海商業儲蓄銀行豐原分行 0495",
							"0509": "上海商業儲蓄銀行鳳山分行 0509",
							"0510": "上海商業儲蓄銀行天母分行 0510",
							"0521": "上海商業儲蓄銀行樹林分行 0521",
							"0532": "上海商業儲蓄銀行基隆分行 0532",
							"0543": "上海商業儲蓄銀行楊梅分行 0543",
							"0554": "上海商業儲蓄銀行內湖科技園區分行 0554",
							"0565": "上海商業儲蓄銀行北中和分行 0565",
							"0576": "上海商業儲蓄銀行西湖分行 0576",
							"0598": "上海商業儲蓄銀行二重分行 0598",
							"0602": "上海商業儲蓄銀行延平分行 0602",
							"0613": "上海商業儲蓄銀行南崁分行 0613",
							"0624": "上海商業儲蓄銀行南港分行 0624",
							"0635": "上海商業儲蓄銀行北新竹分行 0635",
							"0646": "上海商業儲蓄銀行香港分行 0646",
							"0657": "上海商業儲蓄銀行宜蘭分行 0657",
							"0668": "上海商業儲蓄銀行文山分行 0668",
							"0679": "上海商業儲蓄銀行越南同奈分行 0679",
							"0680": "上海商業儲蓄銀行敦北分行 0680",
							"0691": "上海商業儲蓄銀行東高雄分行 0691",
							"0705": "上海商業儲蓄銀行竹北分行 0705",
							"0716": "上海商業儲蓄銀行松江分行 0716",
							"0727": "上海商業儲蓄銀行市政分行 0727",
							"0738": "上海商業儲蓄銀行觀音分行 0738",
							"0749": "上海商業儲蓄銀行北桃園分行 0749",
							"0750": "上海商業儲蓄銀行丹鳳分行 0750",
							"0761": "上海商業儲蓄銀行北新莊分行 0761",
							"0772": "上海商業儲蓄銀行南屯分行 0772",
							"0783": "上海商業儲蓄銀行新加坡分行 0783",
							"0794": "上海商業儲蓄銀行林口分行 0794",
							"0808": "上海商業儲蓄銀行竹科分行 0808",
							"0819": "上海商業儲蓄銀行永吉分行 0819",
							"8712": "上海商業儲蓄銀行泰國曼谷代表人辦事處 8712",
							"8723": "上海商業儲蓄銀行柬埔寨代表人辦事處 8723",
							"8734": "上海商業儲蓄銀行印尼雅加達代表人辦事處 8734",
							"9007": "香港上海商業銀行有限公司 9007",
							"9281": "香港上海商業銀行中環總行 9281",
							"9292": "香港上海商業銀行旺角分行 9292",
							"9306": "香港上海商業銀行銅鑼灣分行 9306",
							"9317": "香港上海商業銀行西環分行 9317",
							"9328": "香港上海商業銀行總統分行 9328",
							"9339": "香港上海商業銀行荃灣分行 9339",
							"9340": "香港上海商業銀行深水埗分行 9340",
							"9351": "香港上海商業銀行尖沙咀分行 9351",
							"9362": "香港上海商業銀行美孚新邨(第一期)分行 9362",
							"9373": "香港上海商業銀行窩打老道分行 9373",
							"9384": "香港上海商業銀行北角分行 9384",
							"9395": "香港上海商業銀行坪石邨分行 9395",
							"9409": "香港上海商業銀行新蒲崗分行 9409",
							"9410": "香港上海商業銀行美孚新邨(第四期)分行 9410",
							"9421": "香港上海商業銀行佐敦道分行 9421",
							"9432": "香港上海商業銀行觀塘分行 9432",
							"9443": "香港上海商業銀行葵涌分行 9443",
							"9454": "香港上海商業銀行德士古道分行 9454",
							"9465": "香港上海商業銀行上環分行 9465",
							"9476": "香港上海商業銀行土瓜灣分行 9476",
							"9487": "香港上海商業銀行筲箕灣分行 9487",
							"9498": "香港上海商業銀行香港仔分行 9498",
							"9502": "香港上海商業銀行灣仔分行 9502",
							"9513": "香港上海商業銀行元朗分行 9513",
							"9524": "香港上海商業銀行太古城分行 9524",
							"9535": "香港上海商業銀行東尖沙咀分行 9535",
							"9546": "香港上海商業銀行九龍塘分行 9546",
							"9557": "香港上海商業銀行維多利中心分行 9557",
							"9579": "香港上海商業銀行軒尼詩道分行 9579",
							"9580": "香港上海商業銀行九龍灣分行 9580",
							"9591": "香港上海商業銀行黃埔花園分行 9591",
							"9605": "香港上海商業銀行荔枝角分行 9605",
							"9616": "香港上海商業銀行三藩市分行 9616",
							"9627": "香港上海商業銀行倫敦分行 9627",
							"9638": "香港上海商業銀行紐約分行 9638",
							"9649": "香港上海商業銀行洛杉磯分行 9649",
							"9661": "香港上海商業銀行深圳分行 9661",
							"9672": "香港上海商業銀行上海分行 9672",
							"9683": "香港上海商業銀行上海自貿試驗區支行 9683",
							"9719": "香港上海商業銀行沙田分行 9719",
							"9720": "香港上海商業銀行屯門分行 9720",
							"9731": "香港上海商業銀行上水分行 9731",
							"9742": "香港上海商業銀行馬鞍山分行 9742",
							"9764": "香港上海商業銀行小西灣分行 9764",
							"9775": "香港上海商業銀行嘉湖山莊分行 9775",
							"9812": "香港上海商業銀行將軍澳分行 9812",
							"9823": "香港上海商業銀行東涌分行 9823",
							"9834": "香港上海商業銀行大埔分行 9834",
							"9856": "香港上海商業銀行黃大仙分行 9856",
							"9867": "香港上海商業銀行麼地道分行 9867",
							"9889": "香港上海商業銀行干諾道分行 9889"
						}
					},
					"012": {
						"one": "台北富邦商業銀行 012",
						"two": {
							"2009": "台北富邦商業銀行營業部 2009",
							"2032": "台北富邦商業銀行長安東路分行 2032",
							"2102": "台北富邦商業銀行公庫處 2102",
							"2205": "台北富邦商業銀行城東分行 2205",
							"2504": "台北富邦商業銀行信託部 2504",
							"3006": "台北富邦商業銀行士林分行 3006",
							"3017": "台北富邦商業銀行士東分行 3017",
							"3039": "台北富邦商業銀行玉成分行 3039",
							"3040": "台北富邦商業銀行福港分行 3040",
							"3051": "台北富邦商業銀行忠孝分行 3051",
							"3109": "台北富邦商業銀行延平分行 3109",
							"3202": "台北富邦商業銀行木柵分行 3202",
							"3408": "台北富邦商業銀行八德分行 3408",
							"3419": "台北富邦商業銀行松南分行 3419",
							"3420": "台北富邦商業銀行永吉分行 3420",
							"3501": "台北富邦商業銀行中山分行 3501",
							"3604": "台北富邦商業銀行北投分行 3604",
							"3615": "台北富邦商業銀行石牌分行 3615",
							"3707": "台北富邦商業銀行大安分行 3707",
							"3800": "台北富邦商業銀行大同分行 3800",
							"3903": "台北富邦商業銀行古亭分行 3903",
							"4003": "台北富邦商業銀行雙園分行 4003",
							"4014": "台北富邦商業銀行萬華分行 4014",
							"4106": "台北富邦商業銀行建成分行 4106",
							"4117": "台北富邦商業銀行市府分行 4117",
							"4209": "台北富邦商業銀行南港分行 4209",
							"4302": "台北富邦商業銀行景美分行 4302",
							"4313": "台北富邦商業銀行興隆分行 4313",
							"4405": "台北富邦商業銀行內湖分行 4405",
							"4427": "台北富邦商業銀行文德分行 4427",
							"4508": "台北富邦商業銀行敦化分行 4508",
							"4542": "台北富邦商業銀行民生分行 4542",
							"4601": "台北富邦商業銀行信義分行 4601",
							"4612": "台北富邦商業銀行莊敬分行 4612",
							"4623": "台北富邦商業銀行東門分行 4623",
							"4704": "台北富邦商業銀行松江分行 4704",
							"4807": "台北富邦商業銀行和平分行 4807",
							"5103": "台北富邦商業銀行南門分行 5103",
							"5309": "台北富邦商業銀行西松分行 5309",
							"5505": "台北富邦商業銀行桂林分行 5505",
							"5608": "台北富邦商業銀行國際金融業務分行 5608",
							"5701": "台北富邦商業銀行敦和分行 5701",
							"5804": "台北富邦商業銀行臨沂分行 5804",
							"5907": "台北富邦商業銀行中崙分行 5907",
							"6007": "台北富邦商業銀行基隆路分行 6007",
							"6100": "台北富邦商業銀行師大分行 6100",
							"6203": "台北富邦商業銀行永春分行 6203",
							"6214": "台北富邦商業銀行懷生分行 6214",
							"6306": "台北富邦商業銀行民權分行 6306",
							"6502": "台北富邦商業銀行社子分行 6502",
							"6605": "台北富邦商業銀行港都分行 6605",
							"6683": "台北富邦商業銀行西湖分行 6683",
							"6719": "台北富邦商業銀行中港分行 6719",
							"6720": "台北富邦商業銀行新莊分行 6720",
							"6731": "台北富邦商業銀行桃園分行 6731",
							"6742": "台北富邦商業銀行台南分行 6742",
							"6775": "台北富邦商業銀行埔墘分行 6775",
							"6786": "台北富邦商業銀行北中壢分行 6786",
							"6797": "台北富邦商業銀行三重分行 6797",
							"6801": "台北富邦商業銀行豐原分行 6801",
							"6812": "台北富邦商業銀行中和分行 6812",
							"6823": "台北富邦商業銀行鼓山分行 6823",
							"6845": "台北富邦商業銀行風城分行 6845",
							"6856": "台北富邦商業銀行彰化分行 6856",
							"6867": "台北富邦商業銀行東湖分行 6867",
							"6878": "台北富邦商業銀行永和分行 6878",
							"6889": "台北富邦商業銀行岡山簡易型分行 6889",
							"6890": "台北富邦商業銀行台北101分行 6890",
							"7026": "台北富邦商業銀行南京東路分行 7026",
							"7037": "台北富邦商業銀行敦北分行 7037",
							"7048": "台北富邦商業銀行仁愛分行 7048",
							"7059": "台北富邦商業銀行高雄分行 7059",
							"7060": "台北富邦商業銀行中正分行 7060",
							"7071": "台北富邦商業銀行台中分行 7071",
							"7093": "台北富邦商業銀行松山分行 7093",
							"7107": "台北富邦商業銀行土城分行 7107",
							"7118": "台北富邦商業銀行東寧分行 7118",
							"7129": "台北富邦商業銀行鳳山分行 7129",
							"7130": "台北富邦商業銀行中壢分行 7130",
							"7152": "台北富邦商業銀行安和分行 7152",
							"7163": "台北富邦商業銀行正義分行 7163",
							"7174": "台北富邦商業銀行大湳分行 7174",
							"7185": "台北富邦商業銀行嘉義分行 7185",
							"7211": "台北富邦商業銀行板橋分行 7211",
							"7222": "台北富邦商業銀行北台中分行 7222",
							"7233": "台北富邦商業銀行三民分行 7233",
							"7244": "台北富邦商業銀行建國分行 7244",
							"7255": "台北富邦商業銀行新竹分行 7255",
							"7266": "台北富邦商業銀行新店分行 7266",
							"7277": "台北富邦商業銀行天母分行 7277",
							"7288": "台北富邦商業銀行汐止分行 7288",
							"7303": "台北富邦商業銀行永康分行 7303",
							"7314": "台北富邦商業銀行城中分行 7314",
							"7336": "台北富邦商業銀行五股分行 7336",
							"7347": "台北富邦商業銀行新營分行 7347",
							"7358": "台北富邦商業銀行屏東分行 7358",
							"7369": "台北富邦商業銀行前鎮分行 7369",
							"7370": "台北富邦商業銀行敦南分行 7370",
							"7381": "台北富邦商業銀行保生分行 7381",
							"7392": "台北富邦商業銀行員林分行 7392",
							"7406": "台北富邦商業銀行羅東分行 7406",
							"7417": "台北富邦商業銀行瑞湖分行 7417",
							"7451": "台北富邦商業銀行花蓮分行 7451",
							"7462": "台北富邦商業銀行竹北分行 7462",
							"7473": "台北富邦商業銀行南台中分行 7473",
							"7484": "台北富邦商業銀行博愛分行 7484",
							"7495": "台北富邦商業銀行蘆洲分行 7495",
							"7509": "台北富邦商業銀行華江分行 7509",
							"7510": "台北富邦商業銀行大直分行 7510",
							"7521": "台北富邦商業銀行樹林分行 7521",
							"7532": "台北富邦商業銀行基隆分行 7532",
							"7543": "台北富邦商業銀行竹科分行 7543",
							"7554": "台北富邦商業銀行林口簡易型分行 7554",
							"7565": "台北富邦商業銀行新板分行 7565",
							"7576": "台北富邦商業銀行三峽分行 7576",
							"7587": "台北富邦商業銀行南崁分行 7587",
							"7598": "台北富邦商業銀行東台南分行 7598",
							"7602": "台北富邦商業銀行左營分行 7602",
							"7613": "台北富邦商業銀行大里分行 7613",
							"7624": "台北富邦商業銀行得和分行 7624",
							"7635": "台北富邦商業銀行斗六分行 7635",
							"7646": "台北富邦商業銀行國美分行 7646",
							"7657": "台北富邦商業銀行南勢角分行 7657",
							"7668": "台北富邦商業銀行北屯分行 7668",
							"7679": "台北富邦商業銀行淡水分行 7679",
							"7680": "台北富邦商業銀行西屯分行 7680",
							"7691": "台北富邦商業銀行北新分行 7691",
							"7705": "台北富邦商業銀行市政分行 7705",
							"7716": "台北富邦商業銀行北新莊分行 7716",
							"7727": "台北富邦商業銀行大雅簡易型分行 7727",
							"9307": "台北富邦商業銀行新加坡分行 9307",
							"9503": "台北富邦商業銀行香港分行 9503",
							"9606": "台北富邦商業銀行平陽分行 9606",
							"9628": "台北富邦商業銀行河內分行 9628",
							"9639": "台北富邦商業銀行胡志明市分行 9639",
							"9721": "台北富邦商業銀行子行富邦華一銀行廣州分行 9721",
							"9732": "台北富邦商業銀行子行富邦華一銀行西安分行 9732",
							"9743": "台北富邦商業銀行子行富邦華一銀行武漢分行 9743",
							"9754": "台北富邦商業銀行子行富邦華一銀行蘇州昆山支行 9754",
							"9765": "台北富邦商業銀行子行富邦華一銀行成都分行 9765",
							"9776": "台北富邦商業銀行子行富邦華一銀行北京分行 9776",
							"9787": "台北富邦商業銀行子行富邦華一銀行上海外灘支行 9787",
							"9798": "台北富邦商業銀行子行富邦華一銀行深圳前海支行 9798",
							"9802": "台北富邦商業銀行子行富邦華一銀行 9802",
							"9813": "台北富邦商業銀行子行富邦華一銀行上海虹橋支行 9813",
							"9824": "台北富邦商業銀行子行富邦華一銀行上海徐匯支行 9824",
							"9835": "台北富邦商業銀行子行富邦華一銀行上海世紀大道支行 9835",
							"9846": "台北富邦商業銀行子行富邦華一銀行上海松江支行 9846",
							"9857": "台北富邦商業銀行子行富邦華一銀行深圳分行 9857",
							"9868": "台北富邦商業銀行子行富邦華一銀行上海閔行支行 9868",
							"9879": "台北富邦商業銀行子行富邦華一銀行天津分行 9879",
							"9880": "台北富邦商業銀行子行富邦華一銀行上海陸家嘴支行 9880",
							"9891": "台北富邦商業銀行子行富邦華一銀行上海新天地支行 9891",
							"9916": "台北富邦商業銀行子行富邦華一銀行上海靜安支行 9916",
							"9927": "台北富邦商業銀行子行富邦華一銀行天津自貿試驗區支行 9927",
							"9938": "台北富邦商業銀行子行富邦華一銀行蘇州分行 9938",
							"9949": "台北富邦商業銀行子行富邦華一銀行上海長寧支行 9949",
							"9950": "台北富邦商業銀行子行富邦華一銀行上海自由貿易試驗區支行 9950",
							"9961": "台北富邦商業銀行子行富邦華一銀行上海日月光支行 9961",
							"9972": "台北富邦商業銀行子行富邦華一銀行南京分行 9972"
						}
					},
					"013": {
						"one": "國泰世華商業銀行 013",
						"two": {
							"0017": "國泰世華商業銀行館前分行 0017",
							"0028": "國泰世華商業銀行環球交易服務部 0028",
							"0039": "國泰世華商業銀行南京東路分行 0039",
							"0040": "國泰世華商業銀行信託部 0040",
							"0051": "國泰世華商業銀行高雄分行 0051",
							"0062": "國泰世華商業銀行台中分行 0062",
							"0073": "國泰世華商業銀行台北分行 0073",
							"0095": "國泰世華商業銀行永和分行 0095",
							"0109": "國泰世華商業銀行台南分行 0109",
							"0110": "國泰世華商業銀行忠孝分行 0110",
							"0121": "國泰世華商業銀行天母分行 0121",
							"0132": "國泰世華商業銀行西台中分行 0132",
							"0143": "國泰世華商業銀行東高雄分行 0143",
							"0154": "國泰世華商業銀行信義分行 0154",
							"0165": "國泰世華商業銀行光復分行 0165",
							"0176": "國泰世華商業銀行板橋分行 0176",
							"0187": "國泰世華商業銀行復興分行 0187",
							"0198": "國泰世華商業銀行民權分行 0198",
							"0202": "國泰世華商業銀行大安分行 0202",
							"0213": "國泰世華商業銀行三重分行 0213",
							"0224": "國泰世華商業銀行中壢分行 0224",
							"0235": "國泰世華商業銀行員林分行 0235",
							"0246": "國泰世華商業銀行新店分行 0246",
							"0257": "國泰世華商業銀行新莊分行 0257",
							"0268": "國泰世華商業銀行鳳山分行 0268",
							"0279": "國泰世華商業銀行安和分行 0279",
							"0280": "國泰世華商業銀行松江分行 0280",
							"0291": "國泰世華商業銀行苓雅分行 0291",
							"0305": "國泰世華商業銀行古亭分行 0305",
							"0316": "國泰世華商業銀行建成分行 0316",
							"0327": "國泰世華商業銀行東門分行 0327",
							"0338": "國泰世華商業銀行國際金融業務分行 0338",
							"0349": "國泰世華商業銀行桃園分行 0349",
							"0350": "國泰世華商業銀行豐原分行 0350",
							"0361": "國泰世華商業銀行嘉義分行 0361",
							"0372": "國泰世華商業銀行松山分行 0372",
							"0383": "國泰世華商業銀行前金分行 0383",
							"0394": "國泰世華商業銀行北三重分行 0394",
							"0408": "國泰世華商業銀行新竹分行 0408",
							"0419": "國泰世華商業銀行永康分行 0419",
							"0420": "國泰世華商業銀行中山分行 0420",
							"0431": "國泰世華商業銀行埔墘分行 0431",
							"0442": "國泰世華商業銀行新生分行 0442",
							"0453": "國泰世華商業銀行中和分行 0453",
							"0464": "國泰世華商業銀行清水分行 0464",
							"0475": "國泰世華商業銀行彰化分行 0475",
							"0486": "國泰世華商業銀行敦北分行 0486",
							"0497": "國泰世華商業銀行中正分行 0497",
							"0501": "國泰世華商業銀行五權分行 0501",
							"0512": "國泰世華商業銀行東台南分行 0512",
							"0523": "國泰世華商業銀行新興分行 0523",
							"0534": "國泰世華商業銀行敦南分行 0534",
							"0545": "國泰世華商業銀行後埔分行 0545",
							"0556": "國泰世華商業銀行蘆洲分行 0556",
							"0567": "國泰世華商業銀行西門分行 0567",
							"0578": "國泰世華商業銀行三民分行 0578",
							"0590": "國泰世華商業銀行前鎮分行 0590",
							"0604": "國泰世華商業銀行土城分行 0604",
							"0615": "國泰世華商業銀行南高雄分行 0615",
							"0626": "國泰世華商業銀行大同分行 0626",
							"0637": "國泰世華商業銀行成功分行 0637",
							"0648": "國泰世華商業銀行中港分行 0648",
							"0659": "國泰世華商業銀行世貿分行 0659",
							"0660": "國泰世華商業銀行北桃園分行 0660",
							"0671": "國泰世華商業銀行善化分行 0671",
							"0682": "國泰世華商業銀行士林分行 0682",
							"0693": "國泰世華商業銀行雙和分行 0693",
							"0707": "國泰世華商業銀行二重分行 0707",
							"0729": "國泰世華商業銀行花蓮分行 0729",
							"0730": "國泰世華商業銀行內湖分行 0730",
							"0741": "國泰世華商業銀行華江分行 0741",
							"0752": "國泰世華商業銀行竹科分行 0752",
							"0763": "國泰世華商業銀行南門分行 0763",
							"0774": "國泰世華商業銀行八德分行 0774",
							"0785": "國泰世華商業銀行永春分行 0785",
							"0796": "國泰世華商業銀行萬華分行 0796",
							"1014": "國泰世華商業銀行屏東分行 1014",
							"1025": "國泰世華商業銀行台東分行 1025",
							"1036": "國泰世華商業銀行文山分行 1036",
							"1047": "國泰世華商業銀行新樹分行 1047",
							"1058": "國泰世華商業銀行宜蘭分行 1058",
							"1069": "國泰世華商業銀行南港分行 1069",
							"1070": "國泰世華商業銀行斗六分行 1070",
							"1081": "國泰世華商業銀行南投分行 1081",
							"1092": "國泰世華商業銀行汐止分行 1092",
							"1106": "國泰世華商業銀行大直分行 1106",
							"1117": "國泰世華商業銀行左營分行 1117",
							"1128": "國泰世華商業銀行新營分行 1128",
							"1139": "國泰世華商業銀行大甲分行 1139",
							"1140": "國泰世華商業銀行苗栗分行 1140",
							"1151": "國泰世華商業銀行北投分行 1151",
							"1162": "國泰世華商業銀行臨安分行 1162",
							"1173": "國泰世華商業銀行幸福分行 1173",
							"1184": "國泰世華商業銀行華山分行 1184",
							"1195": "國泰世華商業銀行東湖分行 1195",
							"1209": "國泰世華商業銀行岡山分行 1209",
							"1210": "國泰世華商業銀行臨沂分行 1210",
							"1221": "國泰世華商業銀行新湖分行 1221",
							"1232": "國泰世華商業銀行中崙分行 1232",
							"1243": "國泰世華商業銀行基隆分行 1243",
							"1254": "國泰世華商業銀行樹林分行 1254",
							"1276": "國泰世華商業銀行淡水分行 1276",
							"1287": "國泰世華商業銀行連城分行 1287",
							"1298": "國泰世華商業銀行石牌分行 1298",
							"1302": "國泰世華商業銀行南內湖分行 1302",
							"1313": "國泰世華商業銀行景美分行 1313",
							"1324": "國泰世華商業銀行大坪林分行 1324",
							"1335": "國泰世華商業銀行丹鳳分行 1335",
							"1346": "國泰世華商業銀行林口分行 1346",
							"1357": "國泰世華商業銀行南崁分行 1357",
							"2011": "國泰世華商業銀行仁愛分行 2011",
							"2022": "國泰世華商業銀行大昌分行 2022",
							"2033": "國泰世華商業銀行民生分行 2033",
							"2044": "國泰世華商業銀行篤行分行 2044",
							"2055": "國泰世華商業銀行板東分行 2055",
							"2066": "國泰世華商業銀行桃興分行 2066",
							"2088": "國泰世華商業銀行彰泰分行 2088",
							"2099": "國泰世華商業銀行嘉泰分行 2099",
							"2103": "國泰世華商業銀行竹城分行 2103",
							"2114": "國泰世華商業銀行忠誠分行 2114",
							"2125": "國泰世華商業銀行敦化分行 2125",
							"2147": "國泰世華商業銀行新泰分行 2147",
							"2158": "國泰世華商業銀行文心分行 2158",
							"2169": "國泰世華商業銀行福和分行 2169",
							"2170": "國泰世華商業銀行四維分行 2170",
							"2181": "國泰世華商業銀行營業部 2181",
							"2192": "國泰世華商業銀行豐北分行 2192",
							"2206": "國泰世華商業銀行重新分行 2206",
							"2217": "國泰世華商業銀行北中壢分行 2217",
							"2228": "國泰世華商業銀行城東分行 2228",
							"2239": "國泰世華商業銀行建國分行 2239",
							"2251": "國泰世華商業銀行學府分行 2251",
							"2262": "國泰世華商業銀行北新分行 2262",
							"2273": "國泰世華商業銀行信安分行 2273",
							"2295": "國泰世華商業銀行文德分行 2295",
							"2321": "國泰世華商業銀行中台中分行 2321",
							"2332": "國泰世華商業銀行水湳分行 2332",
							"2343": "國泰世華商業銀行市政分行 2343",
							"2354": "國泰世華商業銀行東台中分行 2354",
							"2365": "國泰世華商業銀行昌平分行 2365",
							"2376": "國泰世華商業銀行健行分行 2376",
							"2398": "國泰世華商業銀行西屯分行 2398",
							"2402": "國泰世華商業銀行南屯分行 2402",
							"2413": "國泰世華商業銀行崇德分行 2413",
							"2457": "國泰世華商業銀行香山分行 2457",
							"2468": "國泰世華商業銀行竹北分行 2468",
							"2480": "國泰世華商業銀行同德分行 2480",
							"2527": "國泰世華商業銀行秀水分行 2527",
							"2549": "國泰世華商業銀行彰美分行 2549",
							"2550": "國泰世華商業銀行太平分行 2550",
							"2561": "國泰世華商業銀行沙鹿分行 2561",
							"2583": "國泰世華商業銀行大里分行 2583",
							"2608": "國泰世華商業銀行逢甲分行 2608",
							"2619": "國泰世華商業銀行大雅分行 2619",
							"2620": "國泰世華商業銀行潭子分行 2620",
							"2631": "國泰世華商業銀行光華分行 2631",
							"2642": "國泰世華商業銀行西松分行 2642",
							"2653": "國泰世華商業銀行蘭雅分行 2653",
							"2664": "國泰世華商業銀行永平分行 2664",
							"2675": "國泰世華商業銀行和平分行 2675",
							"2686": "國泰世華商業銀行慶城分行 2686",
							"2697": "國泰世華商業銀行瑞湖分行 2697",
							"2701": "國泰世華商業銀行文昌分行 2701",
							"2712": "國泰世華商業銀行正義分行 2712",
							"2723": "國泰世華商業銀行新板分行 2723",
							"2734": "國泰世華商業銀行永貞分行 2734",
							"2778": "國泰世華商業銀行明誠分行 2778",
							"9010": "國泰世華商業銀行納閩島分行 9010",
							"9021": "國泰世華商業銀行馬尼拉分行 9021",
							"9032": "國泰世華商業銀行曼谷代表人辦事處 9032",
							"9043": "國泰世華商業銀行新加坡分行 9043",
							"9054": "世越銀行 9054",
							"9065": "國泰世華銀行(中國)有限公司上海分行 9065",
							"9205": "國泰世華商業銀行香港分行 9205",
							"9249": "國泰世華銀行(柬埔寨)股份有限公司森速分行 9249",
							"9250": "國泰世華銀行(中國)有限公司 9250",
							"9261": "國泰世華銀行(柬埔寨)股份有限公司宋仁芷分行 9261",
							"9272": "國泰世華銀行(柬埔寨)股份有限公司舊運動場分行 9272",
							"9283": "國泰世華銀行(中國)有限公司深圳分行 9283",
							"9294": "國泰世華銀行(柬埔寨)股份有限公司鐵橋頭分行 9294",
							"9308": "國泰世華銀行(柬埔寨)股份有限公司中洲分行 9308",
							"9319": "國泰世華銀行(柬埔寨)股份有限公司興利分行 9319",
							"9320": "國泰世華銀行(中國)有限公司上海嘉定支行 9320",
							"9331": "世越銀行會安分行 9331",
							"9342": "國泰世華銀行(柬埔寨)股份有限公司巴域分行 9342",
							"9353": "國泰世華銀行(柬埔寨)股份有限公司磅針分行 9353",
							"9364": "國泰世華銀行(柬埔寨)股份有限公司馬德望分行 9364",
							"9375": "國泰世華商業銀行印尼雅加達代表人辦事處 9375",
							"9386": "國泰世華商業銀行永珍分行 9386",
							"9397": "國泰世華銀行(中國)有限公司青島分行 9397",
							"9401": "國泰世華商業銀行緬甸仰光代表人辦事處 9401",
							"9412": "國泰世華銀行(中國)有限公司上海自貿試驗區支行 9412",
							"9423": "國泰世華銀行(中國)有限公司上海閔行支行 9423",
							"9526": "國泰世華銀行(柬埔寨)股份有限公司Monivong 9526",
							"9537": "國泰世華銀行(柬埔寨)股份有限公司暹粒分行 9537",
							"9548": "國泰世華銀行(柬埔寨)股份有限公司西哈努克市分行 9548",
							"9559": "國泰世華銀行(柬埔寨)股份有限公司朱德奔分行 9559",
							"9560": "國泰世華銀行(柬埔寨)股份有限公司尼赫魯分行 9560",
							"9571": "國泰世華銀行(柬埔寨)股份有限公司毛澤東分行 9571",
							"9582": "世越銀行濱城分行 9582",
							"9593": "國泰世華銀行(柬埔寨)股份有限公司 9593",
							"9607": "世越銀行河內分行CIPUTRA 9607",
							"9618": "世越銀行峴港分行黃耀支行 9618",
							"9629": "世越銀行海防分行鴻龐支行 9629",
							"9630": "世越銀行棟多分行安和支行 9630",
							"9641": "世越銀行棟多分行吳權支行 9641",
							"9652": "世越銀行河內分行陳仁宗支行 9652",
							"9685": "世越銀行新平分行李常傑支行 9685",
							"9700": "世越銀行同奈分行展鵬支行 9700",
							"9711": "世越銀行河內分行黎仲晉支行 9711",
							"9733": "世越銀行天龍分行 9733",
							"9744": "世越銀行芹苴分行興利支行 9744",
							"9755": "世越銀行堤岸分行平新支行 9755",
							"9777": "世越銀行河內分行李太祖支行 9777",
							"9788": "世越銀行棟多分行黎鴻鋒支行 9788",
							"9799": "世越銀行峴港分行雄王支行 9799",
							"9803": "世越銀行美亭分行 9803",
							"9814": "世越銀行平陽分行美福支行 9814",
							"9825": "世越銀行新平分行 9825",
							"9847": "世越銀行堤岸分行 9847",
							"9858": "世越銀行堤岸分行富美興支行 9858",
							"9869": "世越銀行峴港分行 9869",
							"9870": "世越銀行海防分行Nomura支行 9870",
							"9881": "世越銀行河內分行CIPUTRA 9881",
							"9892": "世越銀行同奈分行仁澤支行 9892",
							"9906": "國泰世華商業銀行吉隆坡行銷服務處 9906",
							"9917": "世越銀行棟多分行 9917",
							"9928": "世越銀行同奈分行 9928",
							"9939": "世越銀行海防分行 9939",
							"9940": "世越銀行芹苴分行 9940",
							"9951": "世越銀行平陽分行 9951",
							"9962": "世越銀行河內分行 9962",
							"9973": "國泰世華商業銀行茱萊分行 9973",
							"9984": "國泰世華商業銀行胡志明市代表人辦事處 9984",
							"9995": "國泰世華商業銀行河內代表人辦事處 9995"
						}
					},
					"016": {
						"one": "高雄銀行 016",
						"two": {
							"1017": "高雄銀行營業部 1017",
							"1028": "高雄銀行公庫部 1028",
							"1039": "高雄銀行岡山本洲分行 1039",
							"1040": "高雄銀行國外部 1040",
							"1051": "高雄銀行信託部 1051",
							"2003": "高雄銀行鳳山分行 2003",
							"2025": "高雄銀行前金分行 2025",
							"2036": "高雄銀行三民分行 2036",
							"2081": "高雄銀行左營分行 2081",
							"2106": "高雄銀行小港分行 2106",
							"2117": "高雄銀行桃園分行 2117",
							"2128": "高雄銀行前鎮分行 2128",
							"2139": "高雄銀行右昌分行 2139",
							"2140": "高雄銀行灣內分行 2140",
							"2151": "高雄銀行屏東分行 2151",
							"2162": "高雄銀行桂林分行 2162",
							"2173": "高雄銀行北屯分行 2173",
							"2184": "高雄銀行楠梓分行 2184",
							"2195": "高雄銀行鼓山分行 2195",
							"2209": "高雄銀行建國分行 2209",
							"2210": "高雄銀行九如分行 2210",
							"2221": "高雄銀行中壢分行 2221",
							"2232": "高雄銀行草衙分行 2232",
							"2243": "高雄銀行板橋分行 2243",
							"2254": "高雄銀行台南分行 2254",
							"2265": "高雄銀行三多分行 2265",
							"2276": "高雄銀行大發分行 2276",
							"2287": "高雄銀行大直分行 2287",
							"2298": "高雄銀行台中分行 2298",
							"2302": "高雄銀行國際金融業務分行 2302",
							"2313": "高雄銀行旗津簡易型分行 2313",
							"2324": "高雄銀行南高雄分行 2324",
							"2335": "高雄銀行大里分行 2335",
							"2346": "高雄銀行新竹分行 2346",
							"2357": "高雄銀行市府分行 2357",
							"2379": "高雄銀行中和分行 2379",
							"2380": "高雄銀行台北分行 2380",
							"2405": "高雄銀行明誠分行 2405",
							"2416": "高雄銀行北高雄分行 2416",
							"2450": "高雄銀行博愛分行 2450"
						}
					},
					"017": {
						"one": "兆豐國際商業銀行 017",
						"two": {
							"0022": "兆豐國際商業銀行港都分行 0022",
							"0033": "兆豐國際商業銀行楠梓分行 0033",
							"0044": "兆豐國際商業銀行台中分行 0044",
							"0055": "兆豐國際商業銀行忠孝分行 0055",
							"0066": "兆豐國際商業銀行府城分行 0066",
							"0077": "兆豐國際商業銀行國外部 0077",
							"0088": "兆豐國際商業銀行台北復興分行 0088",
							"0103": "兆豐國際商業銀行蘭雅分行 0103",
							"0125": "兆豐國際商業銀行三重分行 0125",
							"0136": "兆豐國際商業銀行新興分行 0136",
							"0147": "兆豐國際商業銀行桃園分行 0147",
							"0158": "兆豐國際商業銀行中山分行 0158",
							"0169": "兆豐國際商銀高雄加工出口區分行 0169",
							"0170": "兆豐國際商業銀行城中分行 0170",
							"0181": "兆豐國際商業銀行北彰化分行 0181",
							"0192": "兆豐國際商業銀行安和分行 0192",
							"0206": "兆豐國際商業銀行竹科新安分行 0206",
							"0217": "兆豐國際商業銀行天母分行 0217",
							"0228": "兆豐國際商業銀行嘉義分行 0228",
							"0239": "兆豐國際商業銀行花蓮分行 0239",
							"0240": "兆豐國際商業銀行信託處 0240",
							"0251": "兆豐國際商銀國際金融業務分行 0251",
							"0262": "兆豐國際商業銀行北新竹分行 0262",
							"0273": "兆豐國際商業銀行板南分行 0273",
							"0284": "兆豐國際商業銀行潭子分行 0284",
							"0295": "兆豐國際商銀桃園國際機場分行 0295",
							"0309": "兆豐國際商業銀行南台北分行 0309",
							"0310": "兆豐國際商業銀行敦南分行 0310",
							"0321": "兆豐國際商業銀行員林分行 0321",
							"0343": "兆豐國際商業銀行永和分行 0343",
							"0354": "兆豐國際商業銀行豐原分行 0354",
							"0365": "兆豐國際商業銀行民生分行 0365",
							"0376": "兆豐國際商業銀行北台中分行 0376",
							"0387": "兆豐國際商業銀行三多分行 0387",
							"0398": "兆豐國際商業銀行中壢分行 0398",
							"0402": "兆豐國際商業銀行三民分行 0402",
							"0413": "兆豐國際商業銀行新莊分行 0413",
							"0424": "兆豐國際商業銀行松南分行 0424",
							"0435": "兆豐國際商業銀行大同分行 0435",
							"0446": "兆豐國際商業銀行南台中分行 0446",
							"0457": "兆豐國際商業銀行鳳山分行 0457",
							"0468": "兆豐國際商業銀行新店分行 0468",
							"0479": "兆豐國際商業銀行東高雄分行 0479",
							"0480": "兆豐國際商業銀行信義分行 0480",
							"0491": "兆豐國際商業銀行基隆分行 0491",
							"0505": "兆豐國際商業銀行永康分行 0505",
							"0516": "兆豐國際商業銀行內湖分行 0516",
							"0527": "兆豐國際商業銀行岡山分行 0527",
							"0538": "兆豐國際商業銀行屏東分行 0538",
							"0550": "兆豐國際商業銀行松山機場分行 0550",
							"0561": "兆豐國際商業銀行土城分行 0561",
							"0572": "兆豐國際商業銀行大稻埕分行 0572",
							"0583": "兆豐國際商業銀行頭份分行 0583",
							"0594": "兆豐國際商業銀行苓雅分行 0594",
							"0608": "兆豐國際商業銀行沙鹿分行 0608",
							"0619": "兆豐國際商業銀行八德分行 0619",
							"0620": "兆豐國際商業銀行宜蘭分行 0620",
							"0631": "兆豐國際商業銀行斗六分行 0631",
							"0642": "兆豐國際商業銀行南投分行 0642",
							"0653": "兆豐國際商業銀行東台南分行 0653",
							"0664": "兆豐國際商銀高雄國際機場分行 0664",
							"0675": "兆豐國際商業銀行東內湖分行 0675",
							"0686": "兆豐國際商業銀行太平分行 0686",
							"0697": "兆豐國際商業銀行中和分行 0697",
							"0701": "兆豐國際商業銀行南京東路分行 0701",
							"0712": "兆豐國際商業銀行東台中分行 0712",
							"0723": "兆豐國際商業銀行北高雄分行 0723",
							"0745": "兆豐國際商業銀行南港分行 0745",
							"0756": "兆豐國際商業銀行竹南科學園區分行 0756",
							"0767": "兆豐國際商業銀行中科分行 0767",
							"0778": "兆豐國際商業銀行大甲分行 0778",
							"0789": "兆豐國際商業銀行成功簡易型分行 0789",
							"0790": "兆豐國際商業銀行金門分行 0790",
							"0804": "兆豐國際商業銀行南崁分行 0804",
							"0815": "兆豐國際商業銀行中鋼簡易型分行 0815",
							"0837": "兆豐國際商業銀行榮總分行 0837",
							"0860": "兆豐國際商銀駐外交部簡易型分行 0860",
							"1030": "兆豐國際商業銀行仁武分行 1030",
							"1166": "兆豐國際商銀高雄漁港簡易型分行 1166",
							"2015": "兆豐國際商業銀行金控總部分行 2015",
							"2026": "兆豐國際商業銀行台北分行 2026",
							"2037": "兆豐國際商業銀行新竹分行 2037",
							"2048": "兆豐國際商業銀行中台中分行 2048",
							"2059": "兆豐國際商業銀行高雄分行 2059",
							"2060": "兆豐國際商業銀行板橋分行 2060",
							"2071": "兆豐國際商業銀行桃興分行 2071",
							"2082": "兆豐國際商業銀行竹北分行 2082",
							"2107": "兆豐國際商業銀行敦化分行 2107",
							"2129": "兆豐國際商業銀行嘉興分行 2129",
							"2130": "兆豐國際商業銀行台南分行 2130",
							"2141": "兆豐國際商業銀行寶成分行 2141",
							"2152": "兆豐國際商業銀行竹科竹村分行 2152",
							"2163": "兆豐國際商業銀行世貿分行 2163",
							"2196": "兆豐國際商業銀行南三重分行 2196",
							"2200": "兆豐國際商業銀行南彰化分行 2200",
							"2266": "兆豐國際商業銀行城東分行 2266",
							"2277": "兆豐國際商業銀行五福分行 2277",
							"2288": "兆豐國際商業銀行羅東分行 2288",
							"2299": "兆豐國際商業銀行大安分行 2299",
							"2314": "兆豐國際商業銀行城北分行 2314",
							"2325": "兆豐國際商業銀行后里分行 2325",
							"2336": "兆豐國際商業銀行鹿港分行 2336",
							"2347": "兆豐國際商業銀行圓山分行 2347",
							"2358": "兆豐國際商業銀行思源分行 2358",
							"2369": "兆豐國際商業銀行北中壢分行 2369",
							"2370": "兆豐國際商業銀行內湖科學園區分行 2370",
							"2381": "兆豐國際商業銀行雙和分行 2381",
							"2406": "兆豐國際商業銀行衡陽分行 2406",
							"2417": "兆豐國際商業銀行大里分行 2417",
							"2428": "兆豐國際商業銀行台南科學園區分行 2428",
							"8006": "兆豐國際商業銀行紐約分行 8006",
							"8017": "兆豐國際商業銀行芝加哥分行 8017",
							"8028": "兆豐國際商業銀行洛杉磯分行 8028",
							"8039": "兆豐國際商業銀行巴拿馬分行 8039",
							"8213": "兆豐國際商業銀行大眾股份有限公司曼谷總行 8213",
							"8224": "兆豐國際商業銀行東京分行 8224",
							"8235": "兆豐國際商業銀行大阪分行 8235",
							"8246": "兆豐國際商業銀行新加坡分行 8246",
							"8257": "兆豐國際商業銀行馬尼拉分行 8257",
							"8280": "兆豐國際商業銀行胡志明市分行 8280",
							"8291": "兆豐國際商業銀行納閩分行 8291",
							"8305": "兆豐國際商業銀行 8305",
							"8327": "兆豐國際商業銀行金邊分行 8327",
							"8338": "兆豐國際商業銀行金邊機場支行 8338",
							"8349": "兆豐國際商業銀行蘇州吳江支行 8349",
							"8350": "兆豐國際商業銀行金邊奧林匹克支行 8350",
							"8361": "兆豐國際商業銀行寧波分行 8361",
							"8372": "兆豐國際商業銀行金邊堆谷支行 8372",
							"8383": "兆豐國際商業銀行昆山支行 8383",
							"8408": "兆豐國際商業銀行緬甸仰光代表處 8408",
							"8464": "兆豐國際商業銀行雪梨分行 8464",
							"8475": "兆豐國際商業銀行布里斯本分行 8475",
							"8486": "兆豐國際商業銀行墨爾本分行 8486",
							"8497": "兆豐國際商業銀行倫敦分行 8497",
							"8615": "兆豐國際商業銀行巴黎分行 8615",
							"8626": "兆豐國際商業銀行阿姆斯特丹分行 8626",
							"8763": "兆豐國際商業銀行多倫多分行 8763",
							"8774": "兆豐國際商業銀行溫哥華分行 8774",
							"8822": "兆豐國際商業銀行大眾股份有限公司春武里分行 8822",
							"8833": "兆豐國際商業銀行大眾股份有限公司 8833",
							"8844": "兆豐國際商業銀行大眾股份有限公司羅勇分行 8844",
							"8947": "兆豐國際商銀吉隆坡行銷辦事處 8947",
							"8958": "兆豐國際商業銀行香港分行 8958",
							"8981": "兆豐國際商業銀行矽谷分行 8981",
							"8992": "兆豐國際商業銀行孟買代表人辦事處 8992",
							"9014": "兆豐國際商業銀行大眾股份有限公司萬磅分行 9014"
						}
					},
					"018": {
						"one": "全國農業金庫 018"
					},
					"020": {
						"one": "日商瑞穗銀行台北分行 020",
						"two": {
							"0017": "日商瑞穗銀行台北分行 0017",
							"0028": "日商瑞穗銀行高雄分行 0028",
							"0039": "日商瑞穗銀行國際金融業務分行 0039",
							"0040": "日商瑞穗銀行台中分行 0040"
						}
					},
					"021": {
						"one": "花旗(台灣)商業銀行 021",
						"two": {
							"0018": "花旗(台灣)商業銀行營業部 0018",
							"0030": "花旗(台灣)商業銀行高雄分行 0030",
							"0041": "花旗(台灣)商業銀行台中分行 0041",
							"0052": "花旗(台灣)商業銀行新竹分行 0052",
							"0063": "花旗(台灣)商業銀行台南分行 0063",
							"0074": "花旗(台灣)商業銀行桃園分行 0074",
							"0085": "花旗(台灣)商業銀行松江分行 0085",
							"0096": "花旗(台灣)商業銀行板橋分行 0096",
							"0100": "花旗(台灣)商業銀行文心分行 0100",
							"0111": "花旗(台灣)商業銀行信義分行 0111",
							"0122": "花旗(台灣)商業銀行天母分行 0122",
							"0133": "花旗(台灣)商業銀行建成分行 0133",
							"0144": "花旗(台灣)商業銀行中山分行 0144",
							"0166": "花旗(台灣)商業銀行永福分行 0166",
							"0177": "花旗(台灣)商業銀行港都分行 0177",
							"0188": "花旗(台灣)商業銀行中港分行 0188",
							"0199": "花旗(台灣)商業銀行襄陽分行 0199",
							"0203": "花旗(台灣)商業銀行復興分行 0203",
							"0214": "花旗(台灣)商業銀行新興分行 0214",
							"0225": "花旗(台灣)商業銀行基隆分行 0225",
							"0236": "花旗(台灣)商業銀行北桃園分行 0236",
							"0247": "花旗(台灣)商業銀行永和分行 0247",
							"0258": "花旗(台灣)商業銀行豐原分行 0258",
							"0269": "花旗(台灣)商業銀行民權分行 0269",
							"0281": "花旗(台灣)商業銀行苓雅分行 0281",
							"0292": "花旗(台灣)商業銀行松山分行 0292",
							"0306": "花旗(台灣)商業銀行三重分行 0306",
							"0317": "花旗(台灣)商業銀行員林分行 0317",
							"0328": "花旗(台灣)商業銀行士林分行 0328",
							"0340": "花旗(台灣)商業銀行中壢分行 0340",
							"0351": "花旗(台灣)商業銀行大安分行 0351",
							"0362": "花旗(台灣)商業銀行竹城分行 0362",
							"0373": "花旗(台灣)商業銀行嘉義分行 0373",
							"0384": "花旗(台灣)商業銀行北台中分行 0384",
							"0395": "花旗(台灣)商業銀行北高雄分行 0395",
							"0409": "花旗(台灣)商業銀行新莊分行 0409",
							"0410": "花旗(台灣)商業銀行民生分行 0410",
							"0421": "花旗(台灣)商業銀行彰化分行 0421",
							"0443": "花旗(台灣)商業銀行新店分行 0443",
							"0465": "花旗(台灣)商業銀行高美館分行 0465",
							"0476": "花旗(台灣)商業銀行南京分行 0476",
							"0502": "花旗(台灣)商業銀行中正分行 0502",
							"0513": "花旗(台灣)商業銀行永康分行 0513",
							"0524": "花旗(台灣)商業銀行羅東分行 0524",
							"0535": "花旗(台灣)商業銀行敦化分行 0535",
							"0579": "花旗(台灣)商業銀行內湖分行 0579",
							"0580": "花旗(台灣)商業銀行南港分行 0580",
							"0627": "花旗(台灣)商業銀行斗六分行 0627",
							"0650": "花旗(台灣)商業銀行土城分行 0650",
							"0683": "花旗(台灣)商業銀行國際金融業務分行 0683",
							"0694": "花旗(台灣)商業銀行信託業務專責部門 0694"
						}
					},
					"022": {
						"one": "美國銀行台北分行 022",
						"two": {
							"0019": "美商美國銀行台北分行 0019",
							"0031": "美商美國銀行國際金融業務分行 0031"
						}
					},
					"023": {
						"one": "泰國盤谷銀行台北分行 023",
						"two": {
							"0010": "泰國盤谷銀行台北分行 0010",
							"0021": "泰國盤谷銀行國際金融業務分行 0021",
							"0032": "泰國盤谷銀行高雄分行 0032",
							"0043": "泰國盤谷銀行台中分行 0043"
						}
					},
					"025": {
						"one": "菲律賓首都銀行台北分行 025",
						"two": {
							"0012": "菲商菲律賓首都銀行台北分行 0012",
							"0056": "菲商菲律賓首都銀行國際金融業務分行 0056"
						}
					},
					"029": {
						"one": "新加坡商大華銀行台北分行 029",
						"two": {
							"0005": "新加坡商大華銀行台北分行 0005",
							"0016": "新加坡商大華銀行國際金融業務分行 0016"
						}
					},
					"030": {
						"one": "美商道富銀行台北分行 030",
						"two": {
							"0010": "美商道富銀行台北分行 0010"
						}
					},
					"037": {
						"one": "法商法國興業銀行台北分行 037",
						"two": {
							"0017": "法國興業銀行股份有限公司台北分行 0017",
							"0028": "法國興業銀行國際金融業務分行 0028"
						}
					},
					"039": {
						"one": "澳盛(台灣)商業銀行 039",
						"two": {
							"0019": "澳商澳盛銀行台北分行 0019",
							"0031": "澳商澳盛銀行國際金融業務分行 0031"
						}
					},
					"048": {
						"one": "王道商業銀行 048",
						"two": {
							"0011": "王道商業銀行股份有限公司總行營業部 0011",
							"0022": "王道商業銀行股份有限公司信義威秀分行 0022",
							"0033": "王道商業銀行股份有限公司高雄分行 0033",
							"0055": "王道商業銀行股份有限公司台中分行 0055",
							"0066": "王道商業銀行股份有限公司新竹分行 0066",
							"0077": "王道商業銀行股份有限公司忠孝敦化分行 0077",
							"0088": "王道商業銀行股份有限公司國際金融業務分行 0088",
							"9896": "王道商業銀行股份有限公司美國華信銀行Milpitas分行 9896",
							"9900": "王道商業銀行股份有限公司美國華信銀行Pasadena分行 9900",
							"9911": "王道商業銀行股份有限公司天津代表處 9911",
							"9922": "王道商業銀行股份有限公司美國華信銀行Industry分行 9922",
							"9933": "王道商業銀行股份有限公司美國華信銀行Arcadia分行 9933",
							"9944": "王道商業銀行股份有限公司美國華信銀行Cupertino分行 9944",
							"9955": "王道商業銀行股份有限公司美國華信銀行Cerritos分行 9955",
							"9966": "王道商業銀行股份有限公司美國華信銀行Irvine分行 9966",
							"9977": "王道商業銀行股份有限公司美國華信銀行Alhambra分行 9977",
							"9988": "王道商業銀行股份有限公司香港分行 9988",
							"9999": "王道商業銀行股份有限公司美國華信銀行(EverTrust Bank) 9999"
						}
					},
					"050": {
						"one": "臺灣中小企業銀行 050",
						"two": {
							"0016": "臺灣中小企業銀行吉林分行 0016",
							"0027": "臺灣中小企業銀行中和分行 0027",
							"0038": "臺灣中小企業銀行博愛分行 0038",
							"0049": "臺灣中小企業銀行北桃園分行 0049",
							"0050": "臺灣中小企業銀行南崁分行 0050",
							"0061": "臺灣中小企業銀行西屯分行 0061",
							"0072": "臺灣中小企業銀行忠明分行 0072",
							"0094": "臺灣中小企業銀行金門分行 0094",
							"0108": "臺灣中小企業銀行營業部 0108",
							"0119": "臺灣中小企業銀行大雅分行 0119",
							"0120": "臺灣中小企業銀行仁大分行 0120",
							"0201": "臺灣中小企業銀行仁愛分行 0201",
							"0212": "臺灣中小企業銀行松山分行 0212",
							"0223": "臺灣中小企業銀行建成分行 0223",
							"0234": "臺灣中小企業銀行士林分行 0234",
							"0245": "臺灣中小企業銀行永和分行 0245",
							"0256": "臺灣中小企業銀行新店分行 0256",
							"0267": "臺灣中小企業銀行新莊分行 0267",
							"0278": "臺灣中小企業銀行化成分行 0278",
							"0304": "臺灣中小企業銀行信託部 0304",
							"0359": "臺灣中小企業銀行證券部 0359",
							"0407": "臺灣中小企業銀行松江分行 0407",
							"0418": "臺灣中小企業銀行國際部 0418",
							"0500": "臺灣中小企業銀行台北分行 0500",
							"0603": "臺灣中小企業銀行萬華分行 0603",
							"0614": "臺灣中小企業銀行南台北分行 0614",
							"0706": "臺灣中小企業銀行復興分行 0706",
							"0809": "臺灣中小企業銀行中山分行 0809",
							"0810": "臺灣中小企業銀行建國分行 0810",
							"0821": "臺灣中小企業銀行內湖分行 0821",
							"0902": "臺灣中小企業銀行南京東路分行 0902",
							"1002": "臺灣中小企業銀行忠孝分行 1002",
							"1024": "臺灣中小企業銀行世貿分行 1024",
							"1035": "臺灣中小企業銀行永春分行 1035",
							"1057": "臺灣中小企業銀行南港分行 1057",
							"1105": "臺灣中小企業銀行松南分行 1105",
							"1116": "臺灣中小企業銀行東湖分行 1116",
							"1208": "臺灣中小企業銀行大安分行 1208",
							"1219": "臺灣中小企業銀行雙和分行 1219",
							"1220": "臺灣中小企業銀行錦和分行 1220",
							"1301": "臺灣中小企業銀行五股分行 1301",
							"1312": "臺灣中小企業銀行林口分行 1312",
							"1404": "臺灣中小企業銀行板橋分行 1404",
							"1415": "臺灣中小企業銀行樹林分行 1415",
							"1426": "臺灣中小企業銀行土城分行 1426",
							"1437": "臺灣中小企業銀行迴龍分行 1437",
							"1448": "臺灣中小企業銀行汐止分行 1448",
							"1482": "臺灣中小企業銀行三峽分行 1482",
							"1507": "臺灣中小企業銀行基隆分行 1507",
							"1518": "臺灣中小企業銀行埔墘分行 1518",
							"1529": "臺灣中小企業銀行北三重分行 1529",
							"1530": "臺灣中小企業銀行南三重分行 1530",
							"1541": "臺灣中小企業銀行蘆洲分行 1541",
							"1600": "臺灣中小企業銀行宜蘭分行 1600",
							"1703": "臺灣中小企業銀行羅東分行 1703",
							"1714": "臺灣中小企業銀行蘇澳分行 1714",
							"2906": "臺灣中小企業銀行楊梅分行 2906",
							"2917": "臺灣中小企業銀行湖口分行 2917",
							"3006": "臺灣中小企業銀行桃園分行 3006",
							"3017": "臺灣中小企業銀行大園分行 3017",
							"3028": "臺灣中小企業銀行大溪分行 3028",
							"3109": "臺灣中小企業銀行中壢分行 3109",
							"3110": "臺灣中小企業銀行內壢分行 3110",
							"3121": "臺灣中小企業銀行新明分行 3121",
							"3132": "臺灣中小企業銀行東桃園分行 3132",
							"3154": "臺灣中小企業銀行新屋分行 3154",
							"3202": "臺灣中小企業銀行新竹分行 3202",
							"3213": "臺灣中小企業銀行竹北分行 3213",
							"3224": "臺灣中小企業銀行竹科分行 3224",
							"3305": "臺灣中小企業銀行八德分行 3305",
							"3327": "臺灣中小企業銀行龍潭分行 3327",
							"3408": "臺灣中小企業銀行竹東分行 3408",
							"3501": "臺灣中小企業銀行竹南分行 3501",
							"3512": "臺灣中小企業銀行頭份分行 3512",
							"3604": "臺灣中小企業銀行苗栗分行 3604",
							"4601": "臺灣中小企業銀行豐原分行 4601",
							"4704": "臺灣中小企業銀行太平分行 4704",
							"4807": "臺灣中小企業銀行大甲分行 4807",
							"4829": "臺灣中小企業銀行沙鹿分行 4829",
							"4830": "臺灣中小企業銀行烏日分行 4830",
							"4900": "臺灣中小企業銀行台中分行 4900",
							"4911": "臺灣中小企業銀行民權分行 4911",
							"5000": "臺灣中小企業銀行興中分行 5000",
							"5011": "臺灣中小企業銀行北屯分行 5011",
							"5103": "臺灣中小企業銀行南投分行 5103",
							"5114": "臺灣中小企業銀行草屯分行 5114",
							"5206": "臺灣中小企業銀行埔里分行 5206",
							"5217": "臺灣中小企業銀行潭子分行 5217",
							"5309": "臺灣中小企業銀行竹山分行 5309",
							"5402": "臺灣中小企業銀行彰化分行 5402",
							"5413": "臺灣中小企業銀行和美分行 5413",
							"5505": "臺灣中小企業銀行員林分行 5505",
							"5608": "臺灣中小企業銀行北斗分行 5608",
							"5619": "臺灣中小企業銀行二林分行 5619",
							"6605": "臺灣中小企業銀行斗六分行 6605",
							"6708": "臺灣中小企業銀行北港分行 6708",
							"6719": "臺灣中小企業銀行虎尾分行 6719",
							"6801": "臺灣中小企業銀行嘉義分行 6801",
							"6812": "臺灣中小企業銀行民雄分行 6812",
							"6867": "臺灣中小企業銀行嘉新分行 6867",
							"6904": "臺灣中小企業銀行新營分行 6904",
							"6915": "臺灣中小企業銀行開元分行 6915",
							"7004": "臺灣中小企業銀行永康分行 7004",
							"7015": "臺灣中小企業銀行學甲分行 7015",
							"7026": "臺灣中小企業銀行善化分行 7026",
							"7037": "臺灣中小企業銀行永大分行 7037",
							"7107": "臺灣中小企業銀行台南分行 7107",
							"7118": "臺灣中小企業銀行仁德分行 7118",
							"7200": "臺灣中小企業銀行成功分行 7200",
							"7211": "臺灣中小企業銀行東台南分行 7211",
							"7303": "臺灣中小企業銀行安平分行 7303",
							"7602": "臺灣中小企業銀行花蓮分行 7602",
							"7705": "臺灣中小企業銀行台東分行 7705",
							"8207": "臺灣中小企業銀行東高雄分行 8207",
							"8300": "臺灣中小企業銀行岡山分行 8300",
							"8403": "臺灣中小企業銀行北鳳山分行 8403",
							"8414": "臺灣中小企業銀行苓雅分行 8414",
							"8506": "臺灣中小企業銀行高雄分行 8506",
							"8517": "臺灣中小企業銀行北高雄分行 8517",
							"8528": "臺灣中小企業銀行大昌分行 8528",
							"8539": "臺灣中小企業銀行前鎮分行 8539",
							"8609": "臺灣中小企業銀行九如分行 8609",
							"8702": "臺灣中小企業銀行三民分行 8702",
							"8805": "臺灣中小企業銀行鳳山分行 8805",
							"8816": "臺灣中小企業銀行大發分行 8816",
							"8908": "臺灣中小企業銀行屏東分行 8908",
							"8919": "臺灣中小企業銀行小港分行 8919",
							"8920": "臺灣中小企業銀行潮州分行 8920",
							"8931": "臺灣中小企業銀行國際金融業務分行 8931",
							"9008": "臺灣中小企業銀行洛杉磯分行 9008",
							"9019": "臺灣中小企業銀行香港分行 9019",
							"9020": "臺灣中小企業銀行雪梨分行 9020",
							"9053": "臺灣中小企業銀行上海分行 9053",
							"9064": "臺灣中小企業銀行布里斯本分行 9064",
							"9075": "臺灣中小企業銀行紐約分行 9075",
							"9086": "臺灣中小企業銀行武漢分行 9086",
							"9101": "臺灣中小企業銀行東京分行 9101",
							"9503": "臺灣中小企業銀行仰光代表人辦事處 9503"
						}
					},
					"052": {
						"one": "渣打國際商業銀行 052",
						"two": {
							"0041": "渣打國際商業銀行中壢分行 0041",
							"0052": "渣打國際商業銀行竹東分行 0052",
							"0063": "渣打國際商業銀行竹南分行 0063",
							"0074": "渣打國際商業銀行苗栗分行 0074",
							"0096": "渣打國際商業銀行頭份分行 0096",
							"0111": "渣打國際商業銀行楊梅分行 0111",
							"0122": "渣打國際商業銀行新屋分行 0122",
							"0133": "渣打國際商業銀行湖口分行 0133",
							"0144": "渣打國際商業銀行苑裡分行 0144",
							"0166": "渣打國際商業銀行龍潭分行 0166",
							"0177": "渣打國際商業銀行竹北分行 0177",
							"0199": "渣打國際商業銀行三民分行 0199",
							"0203": "渣打國際商業銀行內壢分行 0203",
							"0214": "渣打國際商業銀行八德分行 0214",
							"0225": "渣打國際商業銀行新明分行 0225",
							"0247": "渣打國際商業銀行公館分行 0247",
							"0269": "渣打國際商業銀行後龍分行 0269",
							"0270": "渣打國際商業銀行龜山分行 0270",
							"0281": "渣打國際商業銀行南崁分行 0281",
							"0317": "渣打國際商業銀行大樹林分行 0317",
							"0328": "渣打國際商業銀行光復分行 0328",
							"0351": "渣打國際商業銀行龍岡分行 0351",
							"0362": "渣打國際商業銀行山子頂分行 0362",
							"0373": "渣打國際商業銀行埔心分行 0373",
							"0384": "渣打國際商業銀行新豐分行 0384",
							"0454": "渣打國際商業銀行中正分行 0454",
							"0476": "渣打國際商業銀行環北分行 0476",
							"0513": "渣打國際商業銀行新興分行 0513",
							"0524": "渣打國際商業銀行新社分行 0524",
							"0546": "渣打國際商業銀行科學園區分行 0546",
							"0579": "渣打國際商業銀行北新竹分行 0579",
							"0591": "渣打國際商業銀行平鎮分行 0591",
							"0649": "渣打國際商業銀行東內壢分行 0649",
							"0650": "渣打國際商業銀行信託部 0650",
							"0661": "渣打國際商業銀行國際金融業務分行 0661",
							"0672": "渣打國際商業銀行101分行 0672",
							"0683": "渣打國際商業銀行公西分行 0683",
							"0708": "渣打國際商業銀行莊敬分行 0708",
							"0719": "渣打國際商業銀行板橋分行 0719",
							"0731": "渣打國際商業銀行豐原分行 0731",
							"0742": "渣打國際商業銀行文心分行 0742",
							"0753": "渣打國際商業銀行內湖分行 0753",
							"0764": "渣打國際商業銀行九如分行 0764",
							"0775": "渣打國際商業銀行台南分行 0775",
							"0797": "渣打國際商業銀行南屯分行 0797",
							"0812": "渣打國際商業銀行東寧分行 0812",
							"0823": "渣打國際商業銀行東海分行 0823",
							"0878": "渣打國際商業銀行北屯分行 0878",
							"0889": "渣打國際商業銀行西屯分行 0889",
							"0926": "渣打國際商業銀行彰化分行 0926",
							"0959": "渣打國際商業銀行營業部 0959",
							"0960": "渣打國際商業銀行北高雄分行 0960",
							"0971": "渣打國際商業銀行台中分行 0971",
							"0982": "渣打國際商業銀行高雄分行 0982",
							"1015": "渣打國際商業銀行復興分行 1015",
							"1037": "渣打國際商業銀行中清分行 1037",
							"1060": "渣打國際商業銀三多分行 1060",
							"1071": "渣打國際商業銀行東台南分行 1071",
							"1093": "渣打國際商業銀行南京分行 1093",
							"1118": "渣打國際商業銀行信義分行 1118",
							"1129": "渣打國際商業銀行東台北分行 1129",
							"1141": "渣打國際商業銀行敦化分行 1141",
							"1152": "渣打國際商業銀行天母分行 1152",
							"1163": "渣打國際商業銀行仁愛分行 1163",
							"1185": "渣打國際商業銀行中山分行 1185",
							"1196": "渣打國際商業銀行古亭分行 1196",
							"1200": "渣打國際商業銀行大直分行 1200",
							"1211": "渣打國際商業銀行金山分行 1211"
						}
					},
					"053": {
						"one": "台中商業銀行 053",
						"two": {
							"0019": "台中商業銀行中正分行 0019",
							"0020": "台中商業銀行營業部 0020",
							"0042": "台中商業銀行南台中分行 0042",
							"0053": "台中商業銀行霧峰分行 0053",
							"0064": "台中商業銀行大甲分行 0064",
							"0075": "台中商業銀行沙鹿分行 0075",
							"0086": "台中商業銀行豐原分行 0086",
							"0097": "台中商業銀行東勢分行 0097",
							"0101": "台中商業銀行彰化分行 0101",
							"0112": "台中商業銀行溪湖分行 0112",
							"0123": "台中商業銀行員林分行 0123",
							"0134": "台中商業銀行田中分行 0134",
							"0145": "台中商業銀行北斗分行 0145",
							"0156": "台中商業銀行二林分行 0156",
							"0167": "台中商業銀行南投分行 0167",
							"0189": "台中商業銀行草屯分行 0189",
							"0190": "台中商業銀行竹山分行 0190",
							"0204": "台中商業銀行埔里分行 0204",
							"0215": "台中商業銀行鹿港分行 0215",
							"0226": "台中商業銀行西台中分行 0226",
							"0237": "台中商業銀行清水分行 0237",
							"0248": "台中商業銀行東豐原分行 0248",
							"0259": "台中商業銀行烏日分行 0259",
							"0271": "台中商業銀行北台中分行 0271",
							"0318": "台中商業銀行和美分行 0318",
							"0330": "台中商業銀行西屯分行 0330",
							"0341": "台中商業銀行太平分行 0341",
							"0363": "台中商業銀行大雅分行 0363",
							"0374": "台中商業銀行后里分行 0374",
							"0385": "台中商業銀行潭子分行 0385",
							"0396": "台中商業銀行社頭分行 0396",
							"0400": "台中商業銀行永靖分行 0400",
							"0411": "台中商業銀行花壇分行 0411",
							"0422": "台中商業銀行秀水分行 0422",
							"0444": "台中商業銀行南屯分行 0444",
							"0455": "台中商業銀行大肚分行 0455",
							"0466": "台中商業銀行神岡分行 0466",
							"0477": "台中商業銀行內新分行 0477",
							"0488": "台中商業銀行伸港分行 0488",
							"0499": "台中商業銀行北太平分行 0499",
							"0503": "台中商業銀行台中港分行 0503",
							"0514": "台中商業銀行北員林分行 0514",
							"0525": "台中商業銀行南陽分行 0525",
							"0536": "台中商業銀行左營分行 0536",
							"0570": "台中商業銀行埤頭分行 0570",
							"0581": "台中商業銀行四民分行 0581",
							"0592": "台中商業銀行軍功分行 0592",
							"0628": "台中商業銀行信託部 0628",
							"0639": "台中商業銀行北屯分行 0639",
							"0662": "台中商業銀行埔心分行 0662",
							"0673": "台中商業銀行國外部 0673",
							"0684": "台中商業銀行台北分行 0684",
							"0710": "台中商業銀行松山分行 0710",
							"0721": "台中商業銀行三重分行 0721",
							"0732": "台中商業銀行高雄分行 0732",
							"0754": "台中商業銀行龍井分行 0754",
							"0776": "台中商業銀行林口分行 0776",
							"0787": "台中商業銀行虎尾分行 0787",
							"0798": "台中商業銀行苑裡分行 0798",
							"0802": "台中商業銀行國際金融業務分行 0802",
							"0813": "台中商業銀行斗南分行 0813",
							"0824": "台中商業銀行竹南分行 0824",
							"0846": "台中商業銀行內湖分行 0846",
							"0857": "台中商業銀行鳳山分行 0857",
							"0868": "台中商業銀行板橋分行 0868",
							"0880": "台中商業銀行新莊分行 0880",
							"0891": "台中商業銀行民雄分行 0891",
							"0905": "台中商業銀行桃園分行 0905",
							"0916": "台中商業銀行永康分行 0916",
							"0927": "台中商業銀行竹北分行 0927",
							"0938": "台中商業銀行南崁分行 0938",
							"0949": "台中商業銀行新竹分行 0949",
							"0950": "台中商業銀行內壢分行 0950",
							"0961": "台中商業銀行新豐分行 0961",
							"0972": "台中商業銀行大園分行 0972",
							"0983": "台中商業銀行中壢分行 0983",
							"1005": "台中商業銀行楊梅分行 1005",
							"1016": "台中商業銀行土城分行 1016",
							"1027": "台中商業銀行財富管理部 1027",
							"1038": "台中商業銀行復興分行 1038",
							"1050": "台中商業銀行中山分行 1050",
							"1061": "台中商業銀行大同分行 1061",
							"1072": "台中商業銀行台南分行 1072",
							"1083": "台中商業銀行新港分行 1083",
							"1094": "台中商業銀行新店分行 1094",
							"1108": "台中商業銀行燕巢分行 1108",
							"9986": "台中商業銀行馬來西亞納閩分行吉隆坡行銷服務處 9986",
							"9997": "台中商業銀行馬來西亞納閩分行 9997"
						}
					},
					"054": {
						"one": "京城商業銀行 054",
						"two": {
							"0010": "京城商業銀行營業部 0010",
							"0032": "京城商業銀行台南分行 0032",
							"0043": "京城商業銀行嘉義分行 0043",
							"0054": "京城商業銀行新營分行 0054",
							"0065": "京城商業銀行鹽水分行 0065",
							"0076": "京城商業銀行虎尾分行 0076",
							"0087": "京城商業銀行斗六分行 0087",
							"0098": "京城商業銀行民雄分行 0098",
							"0102": "京城商業銀行北港分行 0102",
							"0113": "京城商業銀行麻豆分行 0113",
							"0124": "京城商業銀行朴子分行 0124",
							"0135": "京城商業銀行佳里分行 0135",
							"0146": "京城商業銀行梅山分行 0146",
							"0157": "京城商業銀行斗南分行 0157",
							"0180": "京城商業銀行東台南分行 0180",
							"0227": "京城商業銀行西螺分行 0227",
							"0249": "京城商業銀行善化分行 0249",
							"0250": "京城商業銀行學甲分行 0250",
							"0272": "京城商業銀行開元分行 0272",
							"0283": "京城商業銀行永康分行 0283",
							"0294": "京城商業銀行新市分行 0294",
							"0308": "京城商業銀行仁德分行 0308",
							"0319": "京城商業銀行六甲分行 0319",
							"0320": "京城商業銀行安南分行 0320",
							"0331": "京城商業銀行中埔分行 0331",
							"0342": "京城商業銀行崙背分行 0342",
							"0353": "京城商業銀行西港分行 0353",
							"0364": "京城商業銀行新化分行 0364",
							"0375": "京城商業銀行竹崎分行 0375",
							"0386": "京城商業銀行信託部 0386",
							"0397": "京城商業銀行安和分行 0397",
							"0401": "京城商業銀行新興分行 0401",
							"0412": "京城商業銀行中華分行 0412",
							"0434": "京城商業銀行白河分行 0434",
							"0445": "京城商業銀行興業分行 0445",
							"0467": "京城商業銀行水上分行 0467",
							"0489": "京城商業銀行府城分行 0489",
							"0504": "京城商業銀行歸仁分行 0504",
							"0515": "京城商業銀行鹽行分行 0515",
							"0537": "京城商業銀行台北分行 0537",
							"0548": "京城商業銀行大林分行 0548",
							"0607": "京城商業銀行關廟分行 0607",
							"0641": "京城商業銀行太保分行 0641",
							"0652": "京城商業銀行蘆洲分行 0652",
							"0663": "京城商業銀行玉井分行 0663",
							"0674": "京城商業銀行國外部 0674",
							"0685": "京城商業銀行國際金融業務分行 0685",
							"0696": "京城商業銀行高雄分行 0696",
							"0700": "京城商業銀行台中分行 0700",
							"0711": "京城商業銀行內湖分行 0711",
							"0744": "京城商業銀行桃園分行 0744",
							"0755": "京城商業銀行雙和分行 0755",
							"0766": "京城商業銀行岡山分行 0766",
							"0777": "京城商業銀行中正分行 0777",
							"0788": "京城商業銀行忠孝分行 0788",
							"0799": "京城商業銀行北高雄分行 0799",
							"0814": "京城商業銀行板橋分行 0814",
							"0825": "京城商業銀行文心分行 0825",
							"0836": "京城商業銀行松山分行 0836",
							"0847": "京城商業銀行新莊分行 0847",
							"0858": "京城商業銀行新竹分行 0858",
							"0869": "京城商業銀行中壢分行 0869",
							"0870": "京城商業銀行新店分行 0870",
							"0881": "京城商業銀行南崁分行 0881",
							"0892": "京城商業銀行大里分行 0892",
							"0906": "京城商業銀行楠梓分行 0906",
							"0917": "京城商業銀行彰化分行 0917",
							"0928": "京城商業銀行東新竹分行 0928",
							"0939": "京城商業銀行裕農分行 0939"
						}
					},
					"060": {
						"one": "兆豐票券金融股份有限公司 060",
						"two": {
							"0020": "兆豐票券金融公司高雄分公司 0020",
							"0031": "兆豐票券金融公司台中分公司 0031",
							"0042": "兆豐票券金融公司新竹分公司 0042",
							"0053": "兆豐票券金融公司台南分公司 0053",
							"0064": "兆豐票券金融公司板橋分公司 0064",
							"0075": "兆豐票券金融公司桃園分公司 0075",
							"0086": "兆豐票券金融公司三重分公司 0086",
							"0097": "兆豐票券金融公司台北分公司 0097"
						}
					},
					"061": {
						"one": "中華票券金融股份有限公司 061",
						"two": {
							"0021": "中華票券金融公司高雄分公司 0021",
							"0032": "中華票券金融公司台中分公司 0032",
							"0043": "中華票券金融公司台南分公司 0043",
							"0054": "中華票券金融公司桃園分公司 0054",
							"0065": "中華票券金融公司板橋分公司 0065"
						}
					},
					"062": {
						"one": "國際票券金融股份有限公司 062",
						"two": {
							"0022": "國際票券金融公司台中分公司 0022",
							"0033": "國際票券金融公司台南分公司 0033",
							"0044": "國際票券金融公司高雄分公司 0044",
							"0055": "國際票券金融公司臺北分公司 0055",
							"0066": "國際票券金融公司桃園分公司 0066",
							"0077": "國際票券金融公司板橋分公司 0077",
							"0088": "國際票券金融公司中山分公司 0088",
							"0099": "國際票券金融公司新竹分公司 0099"
						}
					},
					"066": {
						"one": "萬通票券金融股份有限公司 066",
						"two": {
							"0026": "萬通票券金融公司高雄分公司 0026"
						}
					},
					"072": {
						"one": "德商德意志銀行台北分行 072",
						"two": {
							"0014": "德商德意志銀行台北分行 0014",
							"0025": "德商德意志銀行國際金融業務分行 0025"
						}
					},
					"075": {
						"one": "香港商東亞銀行台北分行 075",
						"two": {
							"0006": "香港商東亞銀行有限公司台北分行 0006",
							"0017": "香港商東亞銀行有限公司國際金融業務分行 0017"
						}
					},
					"076": {
						"one": "美商摩根大通銀行台北分行 076",
						"two": {
							"0018": "美商摩根大通銀行台北分行 0018",
							"0029": "美商摩根大通銀行國際金融業務分行 0029"
						}
					},
					"081": {
						"one": "匯豐(台灣)商業銀行 081",
						"two": {
							"0016": "滙豐(台灣)商業銀行台北分行 0016",
							"0027": "滙豐(台灣)商業銀行高雄分行 0027",
							"0038": "滙豐(台灣)商業銀行國際金融業務分行 0038",
							"0049": "滙豐(台灣)商業銀行台中分行 0049",
							"0050": "滙豐(台灣)商業銀行台南分行 0050",
							"0061": "滙豐(台灣)商業銀行板橋分行 0061",
							"0072": "滙豐(台灣)商業銀行桃園分行 0072",
							"0083": "滙豐(台灣)商業銀行建國分行 0083",
							"0094": "滙豐(台灣)商業銀行天母分行 0094",
							"0108": "滙豐(台灣)商業銀行東門分行 0108",
							"0120": "滙豐(台灣)商業銀行光復分行 0120",
							"0164": "滙豐(台灣)商業銀行新板分行 0164",
							"0186": "滙豐(台灣)商業銀行古亭分行 0186",
							"0197": "滙豐(台灣)商業銀行民生分行 0197",
							"0201": "滙豐(台灣)商業銀行南港分行 0201",
							"0212": "滙豐(台灣)商業銀行林口分行 0212",
							"0223": "滙豐(台灣)商業銀行新竹分行 0223",
							"0234": "滙豐(台灣)商業銀行松江分行 0234",
							"0304": "滙豐(台灣)商業銀行安和分行 0304",
							"0315": "滙豐(台灣)商業銀行中壢分行 0315",
							"0326": "滙豐(台灣)商業銀行仁愛分行 0326",
							"0337": "滙豐(台灣)商業銀行敦北分行 0337",
							"0360": "滙豐(台灣)商業銀行內湖分行 0360",
							"0382": "滙豐(台灣)商業銀行復興分行 0382",
							"0511": "滙豐(台灣)商業銀行國美分行 0511",
							"0522": "滙豐(台灣)商業銀行敦南分行 0522",
							"0533": "滙豐(台灣)商業銀行大興分行 0533",
							"0566": "滙豐(台灣)商業銀行大直分行 0566",
							"0577": "滙豐(台灣)商業銀行士林分行 0577",
							"0588": "滙豐(台灣)商業銀行蘆洲分行 0588",
							"0599": "滙豐(台灣)商業銀行崇德分行 0599"
						}
					},
					"082": {
						"one": "法國巴黎銀行台北分行 082",
						"two": {
							"0017": "法商法國巴黎銀行台北分行 0017",
							"0028": "法商法國巴黎銀行國際金融業務分行 0028",
							"0039": "法商法國巴黎銀行高雄分行 0039",
							"0051": "法商法國巴黎銀行台中分行 0051"
						}
					},
					"085": {
						"one": "新加坡商新加坡華僑銀行台北分行 085",
						"two": {
							"0009": "新加坡商新加坡華僑銀行台北分行 0009",
							"0010": "新加坡商新加坡華僑銀行國際金融業務分行 0010"
						}
					},
					"086": {
						"one": "法商東方匯理銀行台北分行 086",
						"two": {
							"0011": "法商東方匯理銀行台北分行 0011",
							"0022": "法商東方匯理銀行國際金融業務分行 0022"
						}
					},
					"092": {
						"one": "瑞士商瑞士銀行台北分行 092",
						"two": {
							"0010": "瑞士商瑞士銀行台北分行 0010",
							"0021": "瑞士銀行國際金融業務分行 0021",
							"0032": "瑞士商瑞士銀行台中分行 0032",
							"0043": "瑞士商瑞士銀行高雄分行 0043"
						}
					},
					"093": {
						"one": "荷商安智銀行台北分行 093",
						"two": {
							"0011": "荷蘭商安智銀行台北分行 0011",
							"0022": "荷蘭商安智銀行國際金融業務分行 0022"
						}
					},
					"098": {
						"one": "日商三菱東京日聯銀行台北分行 098",
						"two": {
							"0016": "日商三菱日聯銀行台北分行 0016",
							"0027": "日商三菱日聯銀行國際金融業務分行 0027",
							"1688": "日商三菱日聯銀行高雄分行 1688"
						}
					},
					"101": {
						"one": "瑞興商業銀行 101",
						"two": {
							"0011": "瑞興商業銀行營業部 0011",
							"0020": "瑞興商業銀行民生分行 0020",
							"0039": "瑞興商業銀行建成分行 0039",
							"0048": "瑞興商業銀行大橋分行 0048",
							"0057": "瑞興商業銀行南京東路分行 0057",
							"0066": "瑞興商業銀行昆明分行 0066",
							"0075": "瑞興商業銀行長安分行 0075",
							"0084": "瑞興商業銀行永吉分行 0084",
							"0093": "瑞興商業銀行和平東路分行 0093",
							"0109": "瑞興商業銀行石牌分行 0109",
							"0118": "瑞興商業銀行內湖分行 0118",
							"0127": "瑞興商業銀行成功簡易型分行 0127",
							"0136": "瑞興商業銀行古亭分行 0136",
							"0145": "瑞興商業銀行景美分行 0145",
							"0154": "瑞興商業銀行南港分行 0154",
							"0163": "瑞興商業銀行信義簡易型分行 0163",
							"0172": "瑞興商業銀行萬華分行 0172",
							"0181": "瑞興商業銀行士林分行 0181",
							"0190": "瑞興商業銀行松山簡易型分行 0190",
							"0206": "瑞興商業銀行城內分行 0206",
							"0215": "瑞興商業銀行桃園分行 0215",
							"0224": "瑞興商業銀行中和分行 0224",
							"0242": "瑞興商業銀行信託部 0242",
							"0251": "瑞興商業銀行國外部 0251",
							"0260": "瑞興商業銀行國際金融業務分行 0260"
						}
					},
					"102": {
						"one": "華泰商業銀行 102",
						"two": {
							"0010": "華泰商業銀行營業部 0010",
							"0029": "華泰商業銀行迪化街分行 0029",
							"0038": "華泰商業銀行建成分行 0038",
							"0047": "華泰商業銀行大同分行 0047",
							"0056": "華泰商業銀行中山分行 0056",
							"0065": "華泰商業銀行大安分行 0065",
							"0074": "華泰商業銀行松山分行 0074",
							"0083": "華泰商業銀行古亭分行 0083",
							"0092": "華泰商業銀行士林分行 0092",
							"0108": "華泰商業銀行內湖分行 0108",
							"0117": "華泰商業銀行信義分行 0117",
							"0126": "華泰商業銀行永吉分行 0126",
							"0135": "華泰商業銀行和平分行 0135",
							"0144": "華泰商業銀行光復分行 0144",
							"0153": "華泰商業銀行文山分行 0153",
							"0171": "華泰商業銀行石牌分行 0171",
							"0180": "華泰商業銀行萬華分行 0180",
							"0199": "華泰商業銀行桃園分行 0199",
							"0205": "華泰商業銀行松德分行 0205",
							"0214": "華泰商業銀行新莊分行 0214",
							"0223": "華泰商業銀行中和分行 0223",
							"0232": "華泰商業銀行板橋分行 0232",
							"0241": "華泰商業銀行南京東路分行 0241",
							"0250": "華泰商業銀行敦化分行 0250",
							"0269": "華泰商業銀行新店分行 0269",
							"0278": "華泰商業銀行中壢分行 0278",
							"0287": "華泰商業銀行高雄分行 0287",
							"0296": "華泰商業銀行三重分行 0296",
							"0302": "華泰商業銀行總部分行 0302",
							"0311": "華泰商業銀行國外部 0311",
							"0320": "華泰商業銀行信託部 0320",
							"0339": "華泰商業銀行國際金融業務分行 0339",
							"0348": "華泰商業銀行台南分行 0348",
							"0357": "華泰商業銀行北高雄分行 0357",
							"0366": "華泰商業銀行台中分行 0366",
							"0375": "華泰商業銀行彰化分行 0375",
							"0384": "華泰商業銀行北台中分行 0384"
						}
					},
					"103": {
						"one": "臺灣新光商業銀行 103",
						"two": {
							"0019": "臺灣新光商業銀行中正分行 0019",
							"0028": "臺灣新光商業銀行東台北分行 0028",
							"0037": "臺灣新光商業銀行龍山分行 0037",
							"0046": "臺灣新光商業銀行西園分行 0046",
							"0055": "臺灣新光商業銀行西門分行 0055",
							"0064": "臺灣新光商業銀行大同分行 0064",
							"0073": "臺灣新光商業銀行復興分行 0073",
							"0082": "臺灣新光商業銀行忠孝分行 0082",
							"0091": "臺灣新光商業銀行五常分行 0091",
							"0107": "臺灣新光商業銀行城北分行 0107",
							"0116": "臺灣新光商業銀行城內分行 0116",
							"0125": "臺灣新光商業銀行館前簡易型分行 0125",
							"0134": "臺灣新光商業銀行新金湖分行 0134",
							"0143": "臺灣新光商業銀行慶城分行 0143",
							"0152": "臺灣新光商業銀行內湖分行 0152",
							"0161": "臺灣新光商業銀行世貿分行 0161",
							"0170": "臺灣新光商業銀行松山分行 0170",
							"0189": "臺灣新光商業銀行南港分行 0189",
							"0198": "臺灣新光商業銀行林森北路分行 0198",
							"0204": "臺灣新光商業銀行大安分行 0204",
							"0213": "臺光新光商業銀行新竹分行 0213",
							"0222": "臺灣新光商業銀行中壢分行 0222",
							"0231": "臺灣新光商業銀行桃園分行 0231",
							"0240": "臺灣新光商業銀行東三重分行 0240",
							"0259": "臺灣新光商業銀行竹北分行 0259",
							"0268": "臺灣新光商業銀行連城路分行 0268",
							"0277": "臺灣新光商業銀行竹科分行 0277",
							"0286": "臺灣新光商業銀行土城分行 0286",
							"0295": "臺灣新光商業銀行蘆洲分行 0295",
							"0301": "臺灣新光商業銀行建成分行 0301",
							"0310": "臺灣新光商業銀行北三重分行 0310",
							"0329": "臺灣新光商業銀行永和分行 0329",
							"0338": "臺灣新光商業銀行新埔分行 0338",
							"0347": "臺灣新光商業銀行台中分行 0347",
							"0356": "臺灣新光商業銀行中港分行 0356",
							"0365": "臺灣新光商業銀行左營華夏路分行 0365",
							"0374": "臺灣新光商業銀行大甲分行 0374",
							"0383": "臺灣新光商業銀行大墩分行 0383",
							"0392": "臺灣新光商業銀行員林分行 0392",
							"0408": "臺灣新光商業銀行南屯分行 0408",
							"0417": "臺灣新光商業銀行東台南分行 0417",
							"0426": "臺灣新光商業銀行大里分行 0426",
							"0435": "臺灣新光商業銀行松竹分行 0435",
							"0444": "臺灣新光商業銀行彰化分行 0444",
							"0453": "臺灣新光商業銀行樹林分行 0453",
							"0462": "臺灣新光商業銀行新板分行 0462",
							"0471": "臺灣新光商業銀行古亭分行 0471",
							"0480": "臺灣新光商業銀行士林分行 0480",
							"0499": "臺灣新光商業銀行營業部 0499",
							"0505": "臺灣新光商業銀行丹鳳分行 0505",
							"0514": "臺灣新光商業銀行北投復興崗分行 0514",
							"0523": "臺灣新光商業銀行新生南路分行 0523",
							"0532": "臺灣新光商業銀行國外部 0532",
							"0541": "臺灣新光商業銀行新營分行 0541",
							"0550": "臺灣新光商業銀行天母簡易型分行 0550",
							"0569": "臺灣新光商業銀行新店分行 0569",
							"0578": "臺灣新光商業銀行大直分行 0578",
							"0587": "臺灣新光商業銀行興隆簡易型分行 0587",
							"0596": "臺灣新光商業銀行八德分行 0596",
							"0611": "臺灣新光商業銀行長安分行 0611",
							"0620": "臺灣新光商業銀行嘉義分行 0620",
							"0648": "臺灣新光商業銀行鳳山分行 0648",
							"0657": "臺灣新光商業銀行台南分行 0657",
							"0666": "臺灣新光商業銀行北嘉義分行 0666",
							"0675": "臺灣新光商業銀行斗六分行 0675",
							"0684": "臺灣新光商業銀行竹南分行 0684",
							"0693": "臺灣新光商業銀行花蓮分行 0693",
							"0709": "臺灣新光商業銀行基隆分行 0709",
							"0718": "臺灣新光商業銀行宜蘭分行 0718",
							"0727": "臺灣新光商業銀行三峽分行 0727",
							"0736": "臺灣新光商業銀行路竹分行 0736",
							"0745": "臺灣新光商業銀行高雄分行 0745",
							"0754": "臺灣新光商業銀行新莊分行 0754",
							"0763": "臺灣新光商業銀行江子翠分行 0763",
							"0772": "臺灣新光商業銀行林口分行 0772",
							"0781": "臺灣新光商業銀行彌陀簡易型分行 0781",
							"0790": "臺灣新光商業銀行岡山分行 0790",
							"0806": "臺灣新光商業銀行北高雄分行 0806",
							"0815": "臺灣新光商業銀行國際金融業務分行 0815",
							"0824": "臺灣新光商業銀行小港分行 0824",
							"0833": "臺灣新光商業銀行中華分行 0833",
							"0842": "臺灣新光商業銀行承德分行 0842",
							"0851": "臺灣新光商業銀行敦南分行 0851",
							"0860": "臺灣新光商業銀行中和分行 0860",
							"0879": "臺灣新光商業銀行南台中分行 0879",
							"0888": "臺灣新光商業銀行水湳分行 0888",
							"0897": "臺灣新光商業銀行北屯分行 0897",
							"0903": "臺灣新光商業銀行西屯分行 0903",
							"0912": "臺灣新光商業銀行向上分行 0912",
							"0921": "臺灣新光商業銀行十甲分行 0921",
							"0930": "臺灣新光商業銀行豐原分行 0930",
							"0949": "臺灣新光商業銀行永安分行 0949",
							"0958": "臺灣新光商業銀行屏東分行 0958",
							"0967": "臺灣新光商業銀行東園分行 0967",
							"0976": "臺灣新光商業銀行萬丹分行 0976",
							"0985": "臺灣新光商業銀行七賢分行 0985",
							"1003": "臺灣新光商業銀行汐止分行 1003",
							"1012": "臺灣新光商業銀行桃北分行 1012",
							"1021": "臺灣新光商業銀行東新竹分行 1021",
							"1030": "臺灣新光商業銀行九如分行 1030",
							"1049": "臺灣新光商業銀行永康分行 1049",
							"1058": "臺灣新光商業銀行壢新分行 1058",
							"1067": "臺灣新光商業銀行沙鹿分行 1067",
							"1076": "臺灣新光商業銀行大雅分行 1076",
							"1094": "臺灣新光商業銀行草屯分行 1094",
							"1100": "臺灣新光商業銀行南東分行 1100",
							"3249": "臺灣新光商業銀行信託部 3249",
							"3425": "臺灣新光商業銀行緬甸仰光代表人辦事處 3425",
							"9025": "臺灣新光商業銀行越南胡志明市代表人辦事處 9025",
							"9036": "臺灣新光商業銀行香港分行 9036"
						}
					},
					"108": {
						"one": "陽信商業銀行 108",
						"two": {
							"0014": "陽信商業銀行營業部 0014",
							"0023": "陽信商業銀行石牌分行 0023",
							"0032": "陽信商業銀行北投分行 0032",
							"0041": "陽信商業銀行社子分行 0041",
							"0050": "陽信商業銀行士林分行 0050",
							"0069": "陽信商業銀行大屯分行 0069",
							"0078": "陽信商業銀行劍潭分行 0078",
							"0087": "陽信商業銀行蘭雅分行 0087",
							"0096": "陽信商業銀行天母分行 0096",
							"0102": "陽信商業銀行社中分行 0102",
							"0111": "陽信商業銀行吉林分行 0111",
							"0120": "陽信商業銀行成功分行 0120",
							"0139": "陽信商業銀行民生分行 0139",
							"0148": "陽信商業銀行延吉分行 0148",
							"0157": "陽信商業銀行木柵分行 0157",
							"0166": "陽信商業銀行龍江分行 0166",
							"0175": "陽信商業銀行南京分行 0175",
							"0184": "陽信商業銀行景美分行 0184",
							"0193": "陽信商業銀行中興分行 0193",
							"0209": "陽信商業銀行信義分行 0209",
							"0218": "陽信商業銀行中和分行 0218",
							"0227": "陽信商業銀行永和分行 0227",
							"0236": "陽信商業銀行蘆洲分行 0236",
							"0245": "陽信商業銀行板橋分行 0245",
							"0254": "陽信商業銀行信託部 0254",
							"0263": "陽信商業銀行新和分行 0263",
							"0272": "陽信商業銀行溪洲分行 0272",
							"0281": "陽信商業銀行泰山分行 0281",
							"0290": "陽信商業銀行新莊分行 0290",
							"0306": "陽信商業銀行古亭分行 0306",
							"0315": "陽信商業銀行三重分行 0315",
							"0324": "陽信商業銀行大業分行 0324",
							"0333": "陽信商業銀行雙和分行 0333",
							"0342": "陽信商業銀行復興分行 0342",
							"0351": "陽信商業銀行大安分行 0351",
							"0360": "陽信商業銀行桃園分行 0360",
							"0379": "陽信商業銀行新店分行 0379",
							"0388": "陽信商業銀行國外部 0388",
							"0397": "陽信商業銀行新福分行 0397",
							"0403": "陽信商業銀行新竹分行 0403",
							"0412": "陽信商業銀行員林分行 0412",
							"0421": "陽信商業銀行花蓮分行 0421",
							"0430": "陽信商業銀行精武分行 0430",
							"0449": "陽信商業銀行社頭分行 0449",
							"0458": "陽信商業銀行屏東分行 0458",
							"0467": "陽信商業銀行和平分行 0467",
							"0476": "陽信商業銀行高雄分行 0476",
							"0485": "陽信商業銀行大同分行 0485",
							"0494": "陽信商業銀行北屯分行 0494",
							"0500": "陽信商業銀行嘉義分行 0500",
							"0519": "陽信商業銀行新埔分行 0519",
							"0528": "陽信商業銀行台南分行 0528",
							"0555": "陽信商業銀行東寧分行 0555",
							"0564": "陽信商業銀行中華分行 0564",
							"0573": "陽信商業銀行健康分行 0573",
							"0582": "陽信商業銀行台中分行 0582",
							"0607": "陽信商業銀行西華分行 0607",
							"0616": "陽信商業銀行安順分行 0616",
							"0625": "陽信商業銀行國際金融業務分行 0625",
							"0634": "陽信商業銀行左營分行 0634",
							"0643": "陽信商業銀行向上分行 0643",
							"0652": "陽信商業銀行內湖分行 0652",
							"0661": "陽信商業銀行中壢分行 0661",
							"0670": "陽信商業銀行五股分行 0670",
							"0689": "陽信商業銀行林森分行 0689",
							"0698": "陽信商業銀行立文分行 0698",
							"0704": "陽信商業銀行新興分行 0704",
							"0713": "陽信商業銀行青年分行 0713",
							"0722": "陽信商業銀行三鳳分行 0722",
							"0731": "陽信商業銀行四維分行 0731",
							"0740": "陽信商業銀行大公分行 0740",
							"0759": "陽信商業銀行大順分行 0759",
							"0768": "陽信商業銀行海光分行 0768",
							"0777": "陽信商業銀行前鎮分行 0777",
							"0786": "陽信商業銀行平等分行 0786",
							"0795": "陽信商業銀行基隆分行 0795",
							"0801": "陽信商業銀行小港分行 0801",
							"0810": "陽信商業銀行右昌分行 0810",
							"0829": "陽信商業銀行汐止分行 0829",
							"0838": "陽信商業銀行五甲分行 0838",
							"0847": "陽信商業銀行鼎力分行 0847",
							"0856": "陽信商業銀行楠梓分行 0856",
							"0865": "陽信商業銀行旗山分行 0865",
							"0874": "陽信商業銀行土城分行 0874",
							"0883": "陽信商業銀行南桃園分行 0883",
							"0917": "陽信商業銀行林園簡易型分行 0917",
							"0926": "陽信商業銀行岡山分行 0926",
							"0935": "陽信商業銀行仁德分行 0935",
							"0944": "陽信商業銀行東桃園分行 0944",
							"0953": "陽信商業銀行永康分行 0953",
							"0971": "陽信商業銀行南港分行 0971",
							"0980": "陽信商業銀行里港簡易型分行 0980",
							"0999": "陽信商業銀行大里分行 0999",
							"1017": "陽信商業銀行萬華分行 1017",
							"1026": "陽信商業銀行台北分行 1026",
							"1035": "陽信商業銀行長安分行 1035",
							"1053": "陽信商業銀行羅東分行 1053",
							"1062": "陽信商業銀行竹北分行 1062",
							"1071": "陽信商業銀行重新分行 1071",
							"1080": "陽信商業銀行彰化分行 1080",
							"1336": "陽信商業銀行苗栗分行 1336",
							"1354": "陽信商業銀行龍井分行 1354",
							"1363": "陽信商業銀行雲林分行 1363",
							"1372": "陽信商業銀行南投分行 1372",
							"1503": "陽信商業銀行臺東分行 1503",
							"1512": "陽信商業銀行宜蘭分行 1512",
							"1567": "陽信商業銀行林口分行 1567"
						}
					},
					"114": {
						"one": "基隆第一信用合作社 114",
						"two": {
							"0015": "基隆第一信用合作社營業部 0015",
							"0024": "基隆第一信用合作社仁一路分社 0024",
							"0033": "基隆第一信用合作社愛三路分社 0033",
							"0042": "基隆第一信用合作社忠二路分社 0042",
							"0051": "基隆第一信用合作社安一路分社 0051",
							"0060": "基隆第一信用合作社信二路分社 0060",
							"0079": "基隆第一信用合作社中華路分社 0079",
							"0088": "基隆第一信用合作社八斗子分社 0088",
							"0097": "基隆第一信用合作社南興路分社 0097",
							"0103": "基隆第一信用合作社大武崙分社 0103",
							"0112": "基隆第一信用合作社碇內分社 0112",
							"0121": "基隆第一信用合作社仁二路分社 0121",
							"0130": "基隆第一信用合作社百福分社 0130",
							"0149": "基隆第一信用合作社松山分社 0149",
							"0158": "基隆第一信用合作社永春分社 0158"
						}
					},
					"115": {
						"one": "基隆市第二信用合作社 115",
						"two": {
							"0014": "基隆市第二信用合作社營業部 0014",
							"0023": "基隆市第二信用合作社廟口分社 0023",
							"0032": "基隆市第二信用合作社中正區分社 0032",
							"0041": "基隆市第二信用合作社新店分社 0041",
							"0050": "基隆市第二信用合作社七堵分社 0050",
							"0069": "基隆市第二信用合作社安樂分社 0069",
							"0078": "基隆市第二信用合作社信義分社 0078",
							"0087": "基隆市第二信用合作社港東分社 0087",
							"0096": "基隆市第二信用合作社暖暖分社 0096",
							"0102": "基隆市第二信用合作社安和分社 0102",
							"0111": "基隆市第二信用合作社臺北分社 0111",
							"0120": "基隆市第二信用合作社百福分社 0120",
							"0139": "基隆市第二信用合作社基金分社 0139",
							"0148": "基隆市第二信用合作社新豐分社 0148",
							"0157": "基隆市第二信用合作社復興分社 0157"
						}
					},
					"118": {
						"one": "板信商業銀行 118",
						"two": {
							"0011": "板信商業銀行板橋分行 0011",
							"0020": "板信商業銀行後埔分行 0020",
							"0039": "板信商業銀行永和分行 0039",
							"0048": "板信商業銀行埔墘分行 0048",
							"0057": "板信商業銀行華江分行 0057",
							"0066": "板信商業銀行民族分行 0066",
							"0075": "板信商業銀行中和分行 0075",
							"0084": "板信商業銀行土城分行 0084",
							"0093": "板信商業銀行文化分行 0093",
							"0109": "板信商業銀行大觀分行 0109",
							"0118": "板信商業銀行興南分行 0118",
							"0145": "板信商業銀行小港分行 0145",
							"0163": "板信商業銀行新興分行 0163",
							"0181": "板信商業銀行前鎮分行 0181",
							"0206": "板信商業銀行陽明分行 0206",
							"0215": "板信商業銀行高新莊分行 0215",
							"0260": "板信商業銀行松江分行 0260",
							"0279": "板信商業銀行信義分行 0279",
							"0288": "板信商業銀行新莊分行 0288",
							"0297": "板信商業銀行秀朗分行 0297",
							"0303": "板信商業銀行桃園分行 0303",
							"0312": "板信商業銀行三重分行 0312",
							"0330": "板信商業銀行員山分行 0330",
							"0349": "板信商業銀行桃鶯分行 0349",
							"0358": "板信商業銀行民生分行 0358",
							"0367": "板信商業銀行龍岡分行 0367",
							"0376": "板信商業銀行信託部 0376",
							"0385": "板信商業銀行樹林分行 0385",
							"0394": "板信商業銀行金城分行 0394",
							"0400": "板信商業銀行新竹分行 0400",
							"0419": "板信商業銀行八德分行 0419",
							"0428": "板信商業銀行台中分行 0428",
							"0437": "板信商業銀行台南分行 0437",
							"0446": "板信商業銀行新店分行 0446",
							"0455": "板信商業銀行內湖分行 0455",
							"0473": "板信商業銀行國外部 0473",
							"0482": "板信商業銀行中正分行 0482",
							"0491": "板信商業銀行國際金融業務分行 0491",
							"0507": "板信商業銀行嘉義分行 0507",
							"0598": "板信商業銀行蘆洲分行 0598",
							"0604": "板信商業銀行羅東分行 0604",
							"0613": "板信商業銀行北台中分行 0613",
							"0622": "板信商業銀行成功分行 0622",
							"0631": "板信商業銀行福和分行 0631",
							"0659": "板信商業銀行營業部 0659",
							"0668": "板信商業銀行瑞光分行 0668",
							"0677": "板信商業銀行丹鳳分行 0677",
							"0686": "板信商業銀行北新分行 0686",
							"0695": "板信商業銀行艋舺分行 0695",
							"0701": "板信商業銀行興隆分行 0701",
							"0710": "板信商業銀行雙園分行 0710",
							"0729": "板信商業銀行西門分行 0729",
							"0738": "板信商業銀行古亭分行 0738",
							"0747": "板信商業銀行安東分行 0747",
							"0756": "板信商業銀行松山分行 0756",
							"0765": "板信商業銀行士林分行 0765",
							"0774": "板信商業銀行東湖分行 0774",
							"0792": "板信商業銀行復興分行 0792",
							"0808": "板信商業銀行民權分行 0808",
							"0817": "板信商業銀行重慶分行 0817",
							"0826": "板信商業銀行木柵分行 0826",
							"0844": "板信商業銀行大直分行 0844",
							"0853": "板信商業銀行萬大分行 0853",
							"0871": "板信商業銀行保險代理部 0871",
							"0880": "板信商業銀行南京東路分行 0880",
							"0899": "板信商業銀行北桃園分行 0899",
							"0905": "板信商業銀行環東分行 0905",
							"0914": "板信商業銀行汐止分行 0914",
							"0923": "板信商業銀行燕巢分行 0923"
						}
					},
					"119": {
						"one": "淡水第一信用合作社 119",
						"two": {
							"0010": "淡水第一信用合作社營業部 0010",
							"0029": "淡水第一信用合作社三重分社 0029",
							"0038": "淡水第一信用合作社三芝分社 0038",
							"0047": "淡水第一信用合作社八里分社 0047",
							"0056": "淡水第一信用合作社石門分社 0056",
							"0065": "淡水第一信用合作社竹圍分社 0065",
							"0074": "淡水第一信用合作社水碓分社 0074",
							"0083": "淡水第一信用合作社英專分社 0083",
							"0092": "淡水第一信用合作社新市分社 0092",
							"0108": "淡水第一信用合作社龍形分社 0108",
							"0117": "淡水第一信用合作社金山分社 0117",
							"0126": "淡水第一信用合作社萬里分社 0126",
							"0135": "淡水第一信用合作社板橋分社 0135",
							"0153": "淡水第一信用合作社林口分社 0153",
							"0162": "淡水第一信用合作社中和分社 0162",
							"0171": "淡水第一信用合作社信託課 0171",
							"0180": "淡水第一信用合作社北投分社 0180"
						}
					},
					"130": {
						"one": "新竹第一信用合作社 130",
						"two": {
							"0013": "新竹第一信用合作社營業部 0013",
							"0022": "新竹第一信用合作社城中分社 0022",
							"0031": "新竹第一信用合作社武昌分社 0031",
							"0040": "新竹第一信用合作社新社分社 0040",
							"0059": "新竹第一信用合作社竹北分社 0059",
							"0068": "新竹第一信用合作社三民分社 0068",
							"0077": "新竹第一信用合作社香山分社 0077",
							"0086": "新竹第一信用合作社東南分社 0086",
							"0095": "新竹第一信用合作社光復分社 0095",
							"0101": "新竹第一信用合作社南寮分社 0101",
							"0110": "新竹第一信用合作社南香山分社 0110",
							"0129": "新竹第一信用合作社武陵分社 0129",
							"0138": "新竹第一信用合作社延平分社 0138",
							"0147": "新竹第一信用合作社建功分社 0147",
							"0156": "新竹第一信用合作社芎林分社 0156",
							"0165": "新竹第一信用合作社寶山分社 0165",
							"0174": "新竹第一信用合作社平鎮分社 0174",
							"0183": "新竹第一信用合作社楊梅分社 0183",
							"0192": "新竹第一信用合作社八德分社 0192"
						}
					},
					"132": {
						"one": "新竹第三信用合作社 132",
						"two": {
							"0011": "新竹第三信用合作社市中分社 0011",
							"0020": "新竹第三信用合作社民生分社 0020",
							"0039": "新竹第三信用合作社營業部 0039",
							"0048": "新竹第三信用合作社中正分社 0048",
							"0057": "新竹第三信用合作社東南分社 0057",
							"0066": "新竹第三信用合作社西門分社 0066",
							"0075": "新竹第三信用合作社東光分社 0075",
							"0084": "新竹第三信用合作社香山分社 0084",
							"0093": "新竹第三信用合作社竹南分社 0093",
							"0109": "新竹第三信用合作社延平分社 0109",
							"0118": "新竹第三信用合作光華簡易型分社 0118",
							"0127": "新竹第三信用合作社新豐分社 0127",
							"0136": "新竹第三信用合作社竹北分社 0136",
							"0145": "新竹第三信用合作六家簡易型分社 0145",
							"0154": "新竹第三信用合作社頭份分社 0154"
						}
					},
					"146": {
						"one": "台中市第二信用合作社 146",
						"two": {
							"0014": "營業部 0014",
							"0023": "文昌分社 0023",
							"0032": "南屯分社 0032",
							"0041": "五權分社 0041",
							"0050": "東南分社 0050",
							"0069": "大智分社 0069",
							"0078": "港路分社 0078",
							"0087": "精進分社 0087",
							"0096": "中興分社 0096",
							"0102": "水湳分社 0102",
							"0111": "中和分社 0111",
							"0120": "松竹分社 0120",
							"0139": "向上分社 0139",
							"0148": "大雅分社 0148",
							"0157": "西屯分社 0157",
							"0166": "太平分社 0166",
							"0175": "大里分社 0175",
							"0184": "潭子分社 0184",
							"0193": "文山分社 0193",
							"0209": "軍功分社 0209",
							"0218": "高工分社 0218",
							"0227": "敦化分社 0227"
						}
					},
					"147": {
						"one": "三信商業銀行 147",
						"two": {
							"0013": "三信商業銀行台中分行 0013",
							"0022": "三信商業銀行營業部 0022",
							"0040": "三信商業銀行成功分行 0040",
							"0059": "三信商業銀行西屯分行 0059",
							"0068": "三信商業銀行國光分行 0068",
							"0077": "三信商業銀行大智分行 0077",
							"0086": "三信商業銀行林森分行 0086",
							"0095": "三信商業銀行南門分行 0095",
							"0101": "三信商業銀行進化分行 0101",
							"0110": "三信商業銀行南屯分行 0110",
							"0138": "三信商業銀行北屯分行 0138",
							"0147": "三信商業銀行豐原分行 0147",
							"0156": "三信商業銀行彰化分行 0156",
							"0165": "三信商業銀行員林分行 0165",
							"0183": "三信商業銀行台北分行 0183",
							"0192": "三信商業銀行桃園分行 0192",
							"0208": "三信商業銀行板橋分行 0208",
							"0253": "三信商業銀行豐信分行 0253",
							"0262": "三信商業銀行中山分行 0262",
							"0299": "三信商業銀行台南分行 0299",
							"0305": "三信商業銀行高雄分行 0305",
							"0314": "三信商業銀行新莊分行 0314",
							"0323": "三信商業銀行新竹分行 0323",
							"0332": "三信商業銀行鳳山分行 0332",
							"0341": "三信商業銀行大雅分行 0341",
							"0350": "三信商業銀行橋頭分行 0350",
							"0369": "三信商業銀行大肚分行 0369",
							"0378": "三信商業銀行龍井分行 0378",
							"0387": "三信商業銀行田中分行 0387",
							"0396": "三信商業銀行太平分行 0396",
							"0907": "三信商業銀行信託部 0907",
							"0925": "三信商業銀行國外部 0925",
							"0934": "三信商業銀行國際金融業務分行 0934"
						}
					},
					"162": {
						"one": "彰化第六信用合作社 162",
						"two": {
							"0012": "彰化第六信用合作社車路口分社 0012",
							"0021": "彰化第六信用合作社營業部 0021",
							"0030": "彰化第六信合社觀音亭口分社 0030",
							"0049": "彰化第六信用合作社華陽分社 0049",
							"0058": "彰化第六信用合作社和美分社 0058",
							"0067": "彰化第六信用合作社花壇分社 0067",
							"0076": "彰化第六信用合作社曉陽分社 0076",
							"0085": "彰化第六信用合作社伸港分社 0085",
							"0094": "彰化第六信用合作社秀水分社 0094",
							"0100": "彰化第六信用合作社福興分社 0100",
							"0119": "彰化第六信用合作社永靖分社 0119",
							"0128": "彰化第六信用合作社埔心分社 0128",
							"0137": "彰化第六信用合作社員林分社 0137",
							"0146": "彰化第六信用合作社東興分社 0146"
						}
					},
					"165": {
						"one": "彰化縣鹿港信用合作社 165",
						"two": {
							"0019": "鹿港信用合作社營業部 0019",
							"0028": "鹿港信用合作社彰鹿分社 0028",
							"0037": "鹿港信用合作社頂番分社 0037",
							"0046": "鹿港信用合作社埔鹽分社 0046",
							"0055": "鹿港信用合作社彰濱分社 0055",
							"0064": "鹿港信用合作社管嶼分社 0064",
							"0073": "鹿港信用合作社王功分社 0073",
							"0082": "鹿港信用合作社草港分社 0082",
							"0091": "鹿港信用合作社溪湖分社 0091",
							"0107": "鹿港信用合作社員林分社 0107"
						}
					},
					"204": {
						"one": "高雄市第三信用合作社 204",
						"two": {
							"0011": "高雄市第三信用合作社營業部 0011",
							"0020": "高雄市第三信用合作社八德分社 0020",
							"0039": "高雄市第三信用合作社苓雅分社 0039",
							"0048": "高雄市第三信用合作社新興分社 0048",
							"0057": "高雄市第三信用合作社三民分社 0057",
							"0066": "高雄市第三信用合作社鼓山分社 0066",
							"0075": "高雄市第三信用合作社臨海分社 0075",
							"0084": "高雄市第三信用合作社前鎮分社 0084",
							"0093": "高雄市第三信用合作社前金分社 0093",
							"0109": "高雄市第三信用合作社左營分社 0109",
							"0118": "高雄市第三信用合作社青年分社 0118",
							"0127": "高雄市第三信用合作社楠梓分社 0127",
							"0136": "高雄市第三信用合作社三多分社 0136",
							"0145": "高雄市第三信用合作社灣子分社 0145",
							"0154": "高雄市第三信用合作社天祥分社 0154",
							"0163": "高雄市第三信用合作社陽明分社 0163",
							"0172": "高雄市第三信用合作社武廟分社 0172",
							"0181": "高雄市第三信用合作社瑞祥分社 0181",
							"0190": "高雄市第三信用合作社右昌分社 0190",
							"0206": "高雄市第三信用合作社一心分社 0206",
							"0215": "高雄市第亖信用合作社文川分社 0215"
						}
					},
					"215": {
						"one": "花蓮第一信用合作社 215",
						"two": {
							"0017": "花蓮第一信用合作社復興分社 0017",
							"0026": "花蓮第一信用合作社自由分社 0026",
							"0035": "花蓮第一信用合作社中華分社 0035",
							"0044": "花蓮第一信用合作社營業部 0044",
							"0053": "花蓮第一信用合作社美崙分社 0053",
							"0062": "花蓮第一信用合作社信義簡易型分社 0062",
							"0071": "花蓮第一信用合作社自強分社 0071",
							"0080": "花蓮第一信用合作社國光簡易型分社 0080",
							"0099": "花蓮第一信用合作社鳳山分社 0099",
							"0105": "花蓮第一信用合作社建國簡易型分社 0105",
							"0114": "花蓮第一信用合社永康分社 0114",
							"0123": "花蓮第一信用合作社慶豐簡易型分社 0123",
							"0132": "花蓮第一信用合作社台東分社 0132",
							"0141": "花蓮第一信用合作社仁武分社 0141",
							"0150": "花蓮第一信用合作社橋頭分社 0150"
						}
					},
					"216": {
						"one": "花蓮第二信用合作社 216",
						"two": {
							"0016": "花蓮第二信用合作社營業部 0016",
							"0025": "花蓮第二信用合作社中山分社 0025",
							"0034": "花蓮第二信用合作社主里分社 0034",
							"0043": "花蓮第二信用合作社美崙分社 0043",
							"0052": "花蓮第二信用合作社中正分社 0052",
							"0061": "花蓮第二信用合作社富國分社 0061",
							"0070": "花蓮第二信用合作社田蒲分社 0070",
							"0089": "花蓮第二信用合作社建國分社 0089",
							"0098": "花蓮第二信用合作社壽豐分社 0098",
							"0104": "花蓮第二信用合作社玉里分社 0104",
							"0122": "花蓮第二信用合作社台東分社 0122",
							"0131": "花蓮第二信用合作社大里分社 0131",
							"0140": "花蓮第二信用合作社太平分社 0140",
							"0159": "花蓮第二信用合作社大雅分社 0159",
							"0168": "花蓮第二信用合作社烏日分社 0168",
							"0177": "花蓮第二信用合作社公益分社 0177",
							"0186": "花蓮第二信用合作社西屯分社 0186",
							"0195": "花蓮第二信用合作社羅東分社 0195"
						}
					},
					"321": {
						"one": "日商三井住友銀行台北分行 321",
						"two": {
							"0019": "日商三井住友銀行台北分行 0019",
							"0020": "日商三井住友銀行國際金融業務分行 0020"
						}
					},
					"326": {
						"one": "西班牙商西班牙對外銀行臺北分行 326",
						"two": {
							"8881": "西班牙商西班牙對外銀行台北分行 8881"
						}
					},
					"372": {
						"one": "大慶票券金融股份有限公司 372",
						"two": {
							"0026": "大慶票券金融公司桃園分公司 0026",
							"0037": "大慶票券金融公司台中分公司 0037",
							"0048": "大慶票券金融公司高雄分公司 0048"
						}
					},
					"380": {
						"one": "大陸商中國銀行臺北分行 380"
					},
					"381": {
						"one": "大陸商交通銀行臺北分行 381"
					},
					"382": {
						"one": "大陸商中國建設銀行臺北分行 382"
					},
					"600": {
						"one": "財團法人全國農漁業及金融資訊中心 600"
					},
					"605": {
						"one": "高雄市高雄地區農會 605"
					},
					"625": {
						"one": "臺中市臺中地區農會 625"
					},
					"700": {
						"one": "中華郵政股份有限公司 700"
					},
					"803": {
						"one": "聯邦商業銀行 803",
						"two": {
							"0010": "聯邦商業銀行台北分行 0010",
							"0021": "聯邦商業銀行營業部 0021",
							"0032": "聯邦商業銀行桃園分行 0032",
							"0043": "聯邦商業銀行台中分行 0043",
							"0054": "聯邦商業銀行南京東路分行 0054",
							"0065": "聯邦商業銀行中壢分行 0065",
							"0076": "聯邦商業銀行三重分行 0076",
							"0087": "聯邦商業銀行信託部 0087",
							"0098": "聯邦商業銀行東台北分行 0098",
							"0102": "聯邦商業銀行高雄分行 0102",
							"0113": "聯邦商業銀行板橋分行 0113",
							"0124": "聯邦商業銀行台南分行 0124",
							"0135": "聯邦商業銀行員林分行 0135",
							"0146": "聯邦商業銀行國外部 0146",
							"0157": "聯邦商業銀行仁愛分行 0157",
							"0168": "聯邦商業銀行南崁分行 0168",
							"0179": "聯邦商業銀行新竹分行 0179",
							"0180": "聯邦商業銀行蘆洲分行 0180",
							"0191": "聯邦商業銀行國際金融業務分行 0191",
							"0205": "聯邦商業銀行九如分行 0205",
							"0216": "聯邦商業銀行雙和分行 0216",
							"0227": "聯邦商業銀行迴龍分行 0227",
							"0238": "聯邦商業銀行嘉義分行 0238",
							"0249": "聯邦商業銀行公館分行 0249",
							"0250": "聯邦商業銀行內壢分行 0250",
							"0261": "聯邦商業銀行忠孝分行 0261",
							"0272": "聯邦商業銀行新莊分行 0272",
							"0283": "聯邦商業銀行鳳山分行 0283",
							"0294": "聯邦商業銀行桃鶯分行 0294",
							"0308": "聯邦商業銀行龍潭分行 0308",
							"0319": "聯邦商業銀行新店分行 0319",
							"0320": "聯邦商業銀行大直分行 0320",
							"0331": "聯邦商業銀行中山簡易型分行 0331",
							"0342": "聯邦商業銀行文心分行 0342",
							"0353": "聯邦商業銀行健行分行 0353",
							"0364": "聯邦商業銀行中和分行 0364",
							"0375": "聯邦商業銀行內湖分行 0375",
							"0386": "聯邦商業銀行大園分行 0386",
							"0397": "聯邦商業銀行永和分行 0397",
							"0401": "聯邦商業銀行中港簡易型分行 0401",
							"0412": "聯邦商業銀行通化簡易型分行 0412",
							"0423": "聯邦商業銀行士東分行 0423",
							"0434": "聯邦商業銀行微風簡易型分行 0434",
							"0445": "聯邦商業銀行長春分行 0445",
							"0456": "聯邦商業銀行松江分行 0456",
							"0467": "聯邦商業銀行大安分行 0467",
							"0478": "聯邦商業銀行永吉分行 0478",
							"0489": "聯邦商業銀行文林分行 0489",
							"0490": "聯邦商業銀行東門分行 0490",
							"0504": "聯邦商業銀行敦化分行 0504",
							"0515": "聯邦商業銀行西湖分行 0515",
							"0526": "聯邦商業銀行北投簡易型分行 0526",
							"0537": "聯邦商業銀行北三重分行 0537",
							"0548": "聯邦商業銀行後埔分行 0548",
							"0559": "聯邦商業銀行北中和簡易型分行 0559",
							"0560": "聯邦商業銀行富國分行 0560",
							"0571": "聯邦商業銀行樹林分行 0571",
							"0582": "聯邦商業銀行汐止分行 0582",
							"0593": "聯邦商業銀行北桃園分行 0593",
							"0607": "聯邦商業銀行北中壢分行 0607",
							"0618": "聯邦商業銀行北台中分行 0618",
							"0629": "聯邦商業銀行民權分行 0629",
							"0630": "聯邦商業銀行西屯分行 0630",
							"0641": "聯邦商業銀行興中分行 0641",
							"0652": "聯邦商業銀行北屯分行 0652",
							"0663": "聯邦商業銀行南員林分行 0663",
							"0674": "聯邦商業銀行東嘉義分行 0674",
							"0685": "聯邦商業銀行府城分行 0685",
							"0696": "聯邦商業銀行豐原分行 0696",
							"0700": "聯邦商業銀行富強分行 0700",
							"0711": "聯邦商業銀行開元分行 0711",
							"0722": "聯邦商業銀行南台南分行 0722",
							"0733": "聯邦商業銀行苓雅分行 0733",
							"0744": "聯邦商業銀行北高雄分行 0744",
							"0755": "聯邦商業銀行三民分行 0755",
							"0766": "聯邦商業銀行五甲分行 0766",
							"0777": "聯邦商業銀行屏東分行 0777",
							"0788": "聯邦商業銀行和平分行 0788",
							"0799": "聯邦商業銀行永春分行 0799",
							"0803": "聯邦商業銀行田心分行 0803",
							"0814": "聯邦商業銀行安康分行 0814",
							"0825": "聯邦商業銀行大竹分行 0825",
							"0836": "聯邦商業銀行龜山分行 0836",
							"0847": "聯邦商業銀行林口分行 0847",
							"0858": "聯邦商業銀行五股分行 0858",
							"0869": "聯邦商業銀行高榮分行 0869",
							"0870": "聯邦商業銀行大業分行 0870",
							"0881": "聯邦商業銀行蘆竹分行 0881",
							"0892": "聯邦商業銀行土城分行 0892",
							"0906": "聯邦商業銀行南桃園分行 0906",
							"0917": "聯邦商業銀行集賢分行 0917",
							"0928": "聯邦商業銀行三峽分行 0928",
							"0939": "聯邦商業銀行東湖分行 0939",
							"7019": "聯邦商業銀行越南胡志明市代表人辦事處 7019",
							"7020": "聯邦商業銀行香港代表人辦事處 7020",
							"9002": "聯邦商業銀行(香港)聯邦財務有限公司 9002"
						}
					},
					"805": {
						"one": "遠東國際商業銀行 805",
						"two": {
							"0012": "遠東國際商業銀行營業部 0012",
							"0023": "遠東國際商業銀行台北襄陽分行 0023",
							"0034": "遠東國際商業銀行台北逸仙分行 0034",
							"0045": "遠東國際商業銀行桃園分行 0045",
							"0056": "遠東國際商業銀行台中公益分行 0056",
							"0067": "遠東國際商業銀行台南分行 0067",
							"0078": "遠東國際商業銀行高雄五福分行 0078",
							"0090": "遠東國際商業銀行板橋南雅分行 0090",
							"0104": "遠東國際商業銀行新竹巨城分行 0104",
							"0115": "遠東國際商業銀行高雄中正分行 0115",
							"0126": "遠東國際商業銀行信託部 0126",
							"0137": "遠東國際商業銀行國外部 0137",
							"0148": "遠東國際商業銀行三重分行 0148",
							"0159": "遠東國際商業銀行台北松江分行 0159",
							"0160": "遠東國際商業銀行永康分行 0160",
							"0171": "遠東國際商業銀行中壢分行 0171",
							"0182": "遠東國際商業銀行國際金融分行 0182",
							"0193": "遠東國際商業銀行永和分行 0193",
							"0207": "遠東國際商業銀行台北東門分行 0207",
							"0218": "遠東國際商業銀行高雄文化中心分行 0218",
							"0229": "遠東國際商業銀行台中文心分行 0229",
							"0230": "遠東國際商業銀行新竹科學園區分行 0230",
							"0241": "遠東國際商業銀行桃園大興分行 0241",
							"0252": "遠東國際商業銀行台北南門分行 0252",
							"0263": "遠東國際商業銀行台北新莊分行 0263",
							"0274": "遠東國際商業銀行台北松山分行 0274",
							"0285": "遠東國際商業銀行新店分行 0285",
							"0296": "遠東國際商業銀行台北重慶分行 0296",
							"0300": "遠東國際商業銀行竹北分行 0300",
							"0311": "遠東國際商業銀行台北忠孝分行 0311",
							"0322": "遠東國際商業銀行林口分行 0322",
							"0333": "遠東國際商業銀行板橋文化分行 0333",
							"0344": "遠東國際商業銀行台中自由分行 0344",
							"0355": "遠東國際商業銀行新莊富國分行 0355",
							"0366": "遠東國際商業銀行台北永吉分行 0366",
							"0388": "遠東國際商業銀行桃園大有分行 0388",
							"0399": "遠東國際商業銀行台北金湖簡易型分行 0399",
							"0403": "遠東國際商業銀行台北農安簡易型分行 0403",
							"0414": "遠東國際商業銀行台北中山分行 0414",
							"0425": "遠東國際商業銀行台北古亭分行 0425",
							"0436": "遠東國際商業銀行台北信義分行 0436",
							"0458": "遠東國際商業銀行蘆洲分行 0458",
							"0469": "遠東國際商業銀行中和分行 0469",
							"0470": "遠東國際商業銀行板橋中正分行 0470",
							"0481": "遠東國際商業銀行新竹經國分行 0481",
							"0492": "遠東國際商業銀行台中大雅分行 0492",
							"0506": "遠東國際商業銀行彰化分行 0506",
							"0517": "遠東國際商業銀行南投分行 0517",
							"0528": "遠東國際商業銀行嘉義分行 0528",
							"0540": "遠東國際商業銀行鳳山分行 0540",
							"0562": "遠東國際商業銀行大里分行 0562",
							"0573": "遠東國際商業銀行崇德分行 0573",
							"0584": "遠東國際商業銀行板橋大遠百分行 0584",
							"0595": "遠東國際商業銀行台北敦南分行 0595",
							"0609": "遠東國際商業銀行雙和分行 0609",
							"0610": "遠東國際商業銀行台北南京東路分行 0610",
							"0621": "遠東國際商業銀行台北大稻埕分行 0621",
							"0632": "遠東國際商業銀行石牌分行 0632",
							"0643": "遠東國際商業銀行台北101簡易型分行 0643",
							"9004": "遠東商銀香港分行 9004"
						}
					},
					"806": {
						"one": "元大商業銀行 806",
						"two": {
							"0013": "元大商業銀行台中分行 0013",
							"0024": "元大商業銀行文心分行 0024",
							"0035": "元大商業銀行台北分行 0035",
							"0046": "元大商業銀行沙鹿分行 0046",
							"0057": "元大商業銀行豐原分行 0057",
							"0068": "元大商業銀行彰化分行 0068",
							"0079": "元大商業銀行員林分行 0079",
							"0080": "元大商業銀行三重分行 0080",
							"0091": "元大商業銀行平鎮分行 0091",
							"0105": "元大商業銀行草屯分行 0105",
							"0116": "元大商業銀行永康分行 0116",
							"0138": "元大商業銀行信託部 0138",
							"0149": "元大商業銀行國外部 0149",
							"0150": "元大商業銀行景美分行 0150",
							"0161": "元大商業銀行新竹分行 0161",
							"0172": "元大商業銀行鹿港分行 0172",
							"0183": "元大商業銀行斗信分行 0183",
							"0194": "元大商業銀行嘉義分行 0194",
							"0208": "元大商業銀行國際金融業務分行 0208",
							"0219": "元大商業銀行南京東路分行 0219",
							"0220": "元大商業銀行永和分行 0220",
							"0231": "元大商業銀行復興分行 0231",
							"0242": "元大商業銀行大里分行 0242",
							"0253": "元大商業銀行博愛分行 0253",
							"0264": "元大商業銀行苗栗分行 0264",
							"0275": "元大商業銀行崇德分行 0275",
							"0286": "元大商業銀行北斗分行 0286",
							"0297": "元大商業銀行佳里分行 0297",
							"0301": "元大商業銀行大甲分行 0301",
							"0312": "元大商業銀行虎尾分行 0312",
							"0334": "元大商業銀行士林分行 0334",
							"0345": "元大商業銀行南崁分行 0345",
							"0367": "元大商業銀行古亭分行 0367",
							"0378": "元大商業銀行新莊分行 0378",
							"0389": "元大商業銀行中壢分行 0389",
							"0404": "元大商業銀行三民分行 0404",
							"0415": "元大商業銀行城中分行 0415",
							"0426": "元大商業銀行屏東分行 0426",
							"0448": "元大商業銀行斗南分行 0448",
							"0482": "元大商業銀行板橋分行 0482",
							"0493": "元大商業銀行桃園分行 0493",
							"0518": "元大商業銀行三多分行 0518",
							"0529": "元大商業銀行東信分行 0529",
							"0585": "元大商業銀行內湖分行 0585",
							"0596": "元大商業銀行羅東分行 0596",
							"0600": "元大商業銀行金門分行 0600",
							"0611": "元大商業銀行台南分行 0611",
							"0622": "元大商業銀行林口分行 0622",
							"0633": "元大商業銀行竹北分行 0633",
							"0688": "元大商業銀行府城分行 0688",
							"0699": "元大商業銀行府東分行 0699",
							"0806": "元大商業銀行開元分行 0806",
							"0828": "元大商業銀行安和分行 0828",
							"0839": "元大商業銀行中和分行 0839",
							"0840": "元大商業銀行松江分行 0840",
							"0851": "元大商業銀行竹科分行 0851",
							"0862": "元大商業銀行天母分行 0862",
							"0873": "元大商業銀行蘆洲分行 0873",
							"0884": "元大商業銀行信義分行 0884",
							"0895": "元大商業銀行中山北路分行 0895",
							"0909": "元大商業銀行民生分行 0909",
							"0910": "元大商業銀行新店分行 0910",
							"0932": "元大商業銀行忠孝分行 0932",
							"0943": "元大商業銀行桃興分行 0943",
							"0954": "元大商業銀行中港分行 0954",
							"0965": "元大商業銀行花蓮分行 0965",
							"0976": "元大商業銀行承德分行 0976",
							"0987": "元大商業銀行太平分行 0987",
							"0998": "元大商業銀行營業部 0998",
							"1009": "元大商業銀行土城分行 1009",
							"1021": "元大商業銀行大同分行 1021",
							"1032": "元大商業銀行松山分行 1032",
							"1043": "元大商業銀行大安分行 1043",
							"1076": "元大商業銀行北三重分行 1076",
							"1087": "元大商業銀行上新莊分行 1087",
							"1102": "元大商業銀行高雄分行 1102",
							"1191": "元大商業銀行大統分行 1191",
							"1205": "元大商業銀行雙和分行 1205",
							"1216": "元大商業銀行北投分行 1216",
							"1227": "元大商業銀行延平分行 1227",
							"1238": "元大商業銀行文德分行 1238",
							"1250": "元大商業銀行左營分行 1250",
							"1261": "元大商業銀行埔墘分行 1261",
							"1272": "元大商業銀行公館分行 1272",
							"1283": "元大商業銀行新店中正分行 1283",
							"1308": "元大商業銀行西門分行 1308",
							"1319": "元大商業銀行樹林分行 1319",
							"1320": "元大商業銀行光復分行 1320",
							"1331": "元大商業銀行南港分行 1331",
							"1342": "元大商業銀行苓雅分行 1342",
							"1353": "元大商業銀行敦化分行 1353",
							"1364": "元大商業銀行屏榮分行 1364",
							"1375": "元大商業銀行前鎮中山分行 1375",
							"1386": "元大商業銀行高鳳分行 1386",
							"1397": "元大商業銀行北府分行 1397",
							"1401": "元大商業銀行南嘉義分行 1401",
							"1412": "元大商業銀行東台北分行 1412",
							"1423": "元大商業銀行南新莊分行 1423",
							"1434": "元大商業銀行新壢分行 1434",
							"1445": "元大商業銀行水湳分行 1445",
							"1456": "元大商業銀行大昌分行 1456",
							"1467": "元大商業銀行華山分行 1467",
							"1478": "元大商業銀行東板橋分行 1478",
							"1489": "元大商業銀行沙鹿中山分行 1489",
							"1490": "元大商業銀行十全分行 1490",
							"1504": "元大商業銀行延吉分行 1504",
							"1526": "元大商業銀行成功分行 1526",
							"1548": "元大商業銀行右昌分行 1548",
							"1559": "元大商業銀行前金分行 1559",
							"1560": "元大商業銀行五甲分行 1560",
							"1571": "元大商業銀行連城分行 1571",
							"1582": "元大商業銀行新營分行 1582",
							"1593": "元大商業銀行大和平分行 1593",
							"1607": "元大商業銀行金華分行 1607",
							"1618": "元大商業銀行瑞光分行 1618",
							"1629": "元大商業銀行灣裡分行 1629",
							"1630": "元大商業銀行安南分行 1630",
							"1641": "元大商業銀行江翠分行 1641",
							"1652": "元大商業銀行長庚分行 1652",
							"1674": "元大商業銀行世貿分行 1674",
							"1685": "元大商業銀行東新竹分行 1685",
							"1696": "元大商業銀行汐止分行 1696",
							"1700": "元大商業銀行忠誠分行 1700",
							"1722": "元大商業銀行澄清分行 1722",
							"1733": "元大商業銀行秀朗分行 1733",
							"1744": "元大商業銀行小港分行 1744",
							"1755": "元大商業銀行北桃園分行 1755",
							"1766": "元大商業銀行永春分行 1766",
							"1777": "元大商業銀行圓山分行 1777",
							"1788": "元大商業銀行豐仁分行 1788",
							"1799": "元大商業銀行彰興分行 1799",
							"1814": "元大商業銀行大里德芳分行 1814",
							"1825": "元大商業銀行北台中分行 1825",
							"1836": "元大商業銀行旗津分行 1836",
							"1858": "元大商業銀行鼓山分行 1858",
							"1869": "元大商業銀行前鎮分行 1869",
							"1870": "元大商業銀行明誠分行 1870",
							"1881": "元大商業銀行中正分行 1881",
							"1892": "元大商業銀行石牌分行 1892",
							"1928": "元大商業銀行南門分行 1928",
							"1939": "元大商業銀行新板分行 1939",
							"1940": "元大商業銀行北新分行 1940",
							"1951": "元大商業銀行南屯分行 1951",
							"1962": "元大商業銀行中山分行 1962",
							"1973": "元大商業銀行東門分行 1973",
							"1984": "元大商業銀行金城分行 1984",
							"1995": "元大商業銀行民族分行 1995",
							"2006": "元大商業銀行頭份分行 2006",
							"9016": "Yuanta Savings Bank(Philippines)元大儲蓄銀行(菲律賓) 9016",
							"9027": "Yuanta Savings 9027",
							"9038": "Yuanta Savings Bank(Philippines)-Ortigas Branch 9038",
							"9049": "元大商業銀行緬甸仰光代表人辦事處 9049",
							"9050": "Yuanta Savings Bank (Korea)元大儲蓄銀行(韓國) 9050",
							"9061": "Yuanta Savings Bank -Euljiro Branch 9061",
							"9072": "元大商業銀行香港分行 9072"
						}
					},
					"807": {
						"one": "永豐商業銀行 807",
						"two": {
							"0014": "永豐商業銀行世貿分行 0014",
							"0025": "永豐商業銀行敦北分行 0025",
							"0036": "永豐商業銀行台中分行 0036",
							"0047": "永豐商業銀行高雄分行 0047",
							"0058": "永豐商業銀行忠孝分行 0058",
							"0069": "永豐商業銀行西松分行 0069",
							"0070": "永豐商業銀行板新分行 0070",
							"0081": "永豐商業銀行信託部 0081",
							"0092": "永豐商業銀行敦南分行 0092",
							"0106": "永豐商業銀行新泰分行 0106",
							"0117": "永豐商業銀行桃園分行 0117",
							"0128": "永豐商業銀行北台中分行 0128",
							"0139": "永豐商業銀行台南分行 0139",
							"0140": "永豐商業銀行國外部 0140",
							"0151": "永豐商業銀行松江分行 0151",
							"0162": "永豐商業銀行嘉義分行 0162",
							"0173": "永豐商業銀行三民分行 0173",
							"0184": "永豐商業銀行新竹分行 0184",
							"0195": "永豐商業銀行三重分行 0195",
							"0209": "永豐商業銀行國際金融業務分行 0209",
							"0210": "永豐商業銀行台北分行 0210",
							"0221": "永豐商業銀行彰化分行 0221",
							"0232": "永豐商業銀行岡山分行 0232",
							"0243": "永豐商業銀行中壢分行 0243",
							"0254": "永豐商業銀行鳳山分行 0254",
							"0276": "永豐商業銀行北新分行 0276",
							"0287": "永豐商業銀行屏東分行 0287",
							"0298": "永豐商業銀行北桃園分行 0298",
							"0302": "永豐商業銀行學府分行 0302",
							"0313": "永豐商業銀行南高雄分行 0313",
							"0324": "永豐商業銀行光華分行 0324",
							"0335": "永豐商業銀行東門分行 0335",
							"0346": "永豐商業銀行天母分行 0346",
							"0357": "永豐商業銀行東板橋分行 0357",
							"0368": "永豐商業銀行東台南分行 0368",
							"0379": "永豐商業銀行竹南分行 0379",
							"0380": "永豐商業銀行南台中分行 0380",
							"0391": "永豐商業銀行竹北自強分行 0391",
							"0405": "永豐商業銀行永康分行 0405",
							"0416": "永豐商業銀行中科分行 0416",
							"0427": "永豐商業銀行北高雄分行 0427",
							"0438": "永豐商業銀行金門分行 0438",
							"0449": "永豐商業銀行興大分行 0449",
							"0450": "永豐商業銀行中崙分行 0450",
							"0461": "永豐商業銀行西湖分行 0461",
							"0472": "永豐商業銀行豐原分行 0472",
							"0483": "永豐商業銀行大里分行 0483",
							"1011": "永豐商業銀行忠孝東路分行 1011",
							"1033": "永豐商業銀行建成分行 1033",
							"1044": "永豐商業銀行西門分行 1044",
							"1055": "永豐商業銀行萬華分行 1055",
							"1066": "永豐商業銀行興隆分行 1066",
							"1077": "永豐商業銀行南門分行 1077",
							"1088": "永豐商業銀行長安分行 1088",
							"1099": "永豐商業銀行延平分行 1099",
							"1103": "永豐商業銀行北投分行 1103",
							"1114": "永豐商業銀行松山分行 1114",
							"1125": "永豐商業銀行中山分行 1125",
							"1136": "永豐商業銀行士林分行 1136",
							"1158": "永豐商業銀行雙園分行 1158",
							"1169": "永豐商業銀行永和分行 1169",
							"1170": "永豐商業銀行板橋分行 1170",
							"1181": "永豐商業銀行基隆分行 1181",
							"1192": "永豐商業銀行羅東分行 1192",
							"1206": "永豐商業銀行宜蘭分行 1206",
							"1217": "永豐商業銀行營業部 1217",
							"1228": "永豐商業銀行景美分行 1228",
							"1239": "永豐商業銀行新莊分行 1239",
							"1251": "永豐商業銀行汐止分行 1251",
							"1262": "永豐商業銀行城中分行 1262",
							"1273": "永豐商業銀行光復分行 1273",
							"1284": "永豐商業銀行正義分行 1284",
							"1295": "永豐商業銀行中和分行 1295",
							"1310": "永豐商業銀行士東分行 1310",
							"1321": "永豐商業銀行中港分行 1321",
							"1332": "永豐商業銀行蘆洲分行 1332",
							"1343": "永豐商業銀行內湖分行 1343",
							"1354": "永豐商業銀行社子分行 1354",
							"1365": "永豐商業銀行信義分行 1365",
							"1376": "永豐商業銀行永春分行 1376",
							"1387": "永豐商業銀行南三重分行 1387",
							"1398": "永豐商業銀行積穗分行 1398",
							"1402": "永豐商業銀行鶯歌分行 1402",
							"1413": "永豐商業銀行新店分行 1413",
							"1435": "永豐商業銀行西盛分行 1435",
							"1446": "永豐商業銀行板橋忠孝分行 1446",
							"1457": "永豐商業銀行思源分行 1457",
							"1468": "永豐商業銀行土城分行 1468",
							"1479": "永豐商業銀行三興分行 1479",
							"1480": "永豐商業銀行龍江分行 1480",
							"1491": "永豐商業銀行樹林分行 1491",
							"1505": "永豐商業銀行五股分行 1505",
							"1538": "永豐商業銀行松德分行 1538",
							"1549": "永豐商業銀行東湖分行 1549",
							"1550": "永豐商業銀行華江分行 1550",
							"1561": "永豐商業銀行北三重分行 1561",
							"1572": "永豐商業銀行蘭雅分行 1572",
							"1583": "永豐商業銀行德惠分行 1583",
							"1594": "永豐商業銀行迴龍分行 1594",
							"1608": "永豐商業銀行仁愛分行 1608",
							"1620": "永豐商業銀行和平分行 1620",
							"1642": "永豐商業銀行重新分行 1642",
							"1653": "永豐商業銀行中興分行 1653",
							"1664": "永豐商業銀行海山分行 1664",
							"1697": "永豐商業銀行南蘆洲分行 1697",
							"1701": "永豐商業銀行江子翠分行 1701",
							"1712": "永豐商業銀行民安分行 1712",
							"1723": "永豐商業銀行苓雅分行 1723",
							"1734": "永豐商業銀行林口忠孝分行 1734",
							"1745": "永豐商業銀行板橋民族分行 1745",
							"1756": "永豐商業銀行泰山分行 1756",
							"1767": "永豐商業銀行花蓮分行 1767",
							"1778": "永豐商業銀行南港分行 1778",
							"1789": "永豐商業銀行深坑分行 1789",
							"1790": "永豐商業銀行南崁分行 1790",
							"1804": "永豐商業銀行北台南分行 1804",
							"1815": "永豐商業銀行西屯分行 1815",
							"1826": "永豐商業銀行汐止樟樹分行 1826",
							"1837": "永豐商業銀行濟南路分行 1837",
							"1859": "永豐商業銀行南桃園分行 1859",
							"1860": "永豐商業銀行竹科分行 1860",
							"1871": "永豐商業銀行員林分行 1871",
							"1882": "永豐商業銀行楊梅分行 1882",
							"1893": "永豐商業銀行內壢分行 1893",
							"1907": "永豐商業銀行重慶北路分行 1907",
							"1929": "永豐商業銀行大園分行 1929",
							"1930": "永豐商業銀行竹北光明分行 1930",
							"1963": "永豐商業銀行竹圍分行 1963",
							"9017": "永豐商業銀行香港分行 9017",
							"9028": "永豐商業銀行越南代表人辦事處 9028",
							"9040": "永豐商業銀行洛杉磯分行 9040",
							"9051": "永豐金(香港)財務有限公司 9051",
							"9660": "永豐(香港)保險經紀有限公司 9660",
							"9671": "永豐銀行(中國)有限公司 9671",
							"9718": "永豐銀行（中國）有限公司廣州分行 9718",
							"9729": "永豐銀行（中國）有限公司上海分行 9729",
							"9800": "永豐商業銀行澳門分行 9800",
							"9811": "永豐商業銀行九龍分行 9811",
							"9844": "永豐商業銀行胡志明市分行 9844"
						}
					},
					"808": {
						"one": "玉山商業銀行 808",
						"two": {
							"0015": "玉山商業銀行營業部 0015",
							"0026": "玉山商業銀行南京東路分行 0026",
							"0048": "玉山商業銀行城東分行 0048",
							"0059": "玉山商業銀行新莊分行 0059",
							"0060": "玉山商業銀行新竹分行 0060",
							"0071": "玉山商業銀行嘉義分行 0071",
							"0082": "玉山商業銀行高雄分行 0082",
							"0093": "玉山商業銀行信託部 0093",
							"0107": "玉山商業銀行國際事務部 0107",
							"0118": "玉山商業銀行基隆路分行 0118",
							"0129": "玉山商業銀行雙和分行 0129",
							"0130": "玉山商業銀行中壢分行 0130",
							"0141": "玉山商業銀行文心分行 0141",
							"0152": "玉山商業銀行台南分行 0152",
							"0163": "玉山商業銀行天母分行 0163",
							"0174": "玉山商業銀行埔墘分行 0174",
							"0185": "玉山商業銀行桃園分行 0185",
							"0196": "玉山商業銀行前鎮分行 0196",
							"0200": "玉山銀行國際金融業務分行 0200",
							"0211": "玉山商業銀行民生分行 0211",
							"0222": "玉山商業銀行大里分行 0222",
							"0233": "玉山商業銀行永康分行 0233",
							"0244": "玉山商業銀行鳳山分行 0244",
							"0255": "玉山商業銀行三和分行 0255",
							"0266": "玉山商業銀行土城分行 0266",
							"0277": "玉山商業銀行八德分行 0277",
							"0288": "玉山商業銀行大墩分行 0288",
							"0299": "玉山商業銀行七賢分行 0299",
							"0303": "玉山商業銀行復興分行 0303",
							"0314": "玉山商業銀行敦南分行 0314",
							"0325": "玉山商業銀行三重分行 0325",
							"0336": "玉山商業銀行彰化分行 0336",
							"0347": "玉山商業銀行北高雄分行 0347",
							"0358": "玉山商業銀行大雅分行 0358",
							"0369": "玉山商業銀行楊梅分行 0369",
							"0370": "玉山商業銀行樹林分行 0370",
							"0381": "玉山商業銀行豐原分行 0381",
							"0392": "玉山商業銀行斗六分行 0392",
							"0406": "玉山商業銀行長春分行 0406",
							"0417": "玉山商業銀行中山分行 0417",
							"0428": "玉山商業銀行佳里分行 0428",
							"0439": "玉山商業銀行中和分行 0439",
							"0440": "玉山商業銀行竹南分行 0440",
							"0451": "玉山商業銀行羅東分行 0451",
							"0462": "玉山商業銀行內湖分行 0462",
							"0473": "玉山商業銀行壢新分行 0473",
							"0484": "玉山商業銀行板新分行 0484",
							"0495": "玉山商業銀行光華分行 0495",
							"0509": "玉山商業銀行東嘉義分行 0509",
							"0510": "玉山商業銀行成功分行 0510",
							"0521": "玉山商業銀行永和分行 0521",
							"0532": "玉山商業銀行城中分行 0532",
							"0543": "玉山商業銀行五股分行 0543",
							"0554": "玉山商業銀行新店分行 0554",
							"0565": "玉山商業銀行松山分行 0565",
							"0576": "玉山商業銀行和平分行 0576",
							"0587": "玉山商業銀行新板特區分行 0587",
							"0598": "玉山商業銀行民權分行 0598",
							"0602": "玉山商業銀行泰山分行 0602",
							"0613": "玉山商業銀行南崁分行 0613",
							"0624": "玉山商業銀行大順分行 0624",
							"0635": "玉山商業銀行左營分行 0635",
							"0646": "玉山商業銀行楠梓分行 0646",
							"0657": "玉山商業銀行士林分行 0657",
							"0668": "玉山商業銀行苓雅分行 0668",
							"0679": "玉山商業銀行仁愛分行 0679",
							"0680": "玉山商業銀行南屯分行 0680",
							"0691": "玉山商業銀行木柵分行 0691",
							"0705": "玉山商業銀行大昌分行 0705",
							"0716": "玉山商業銀行台東分行 0716",
							"0727": "玉山商業銀行澄清分行 0727",
							"0738": "玉山商業銀行小港分行 0738",
							"0749": "玉山商業銀行北新莊分行 0749",
							"0750": "玉山商業銀行竹北分行 0750",
							"0761": "玉山商業銀行東台南分行 0761",
							"0772": "玉山商業銀行集賢分行 0772",
							"0783": "玉山商業銀行基隆分行 0783",
							"0794": "玉山商業銀行岡山分行 0794",
							"0808": "玉山商業銀行連城分行 0808",
							"0819": "玉山商業銀行林園分行 0819",
							"0820": "玉山商業銀行蘆洲分行 0820",
							"0831": "玉山商業銀行後庄分行 0831",
							"0842": "玉山商業銀行南桃園分行 0842",
							"0853": "玉山商業銀行東三重分行 0853",
							"0864": "玉山商業銀行北投分行 0864",
							"0875": "玉山商業銀行忠孝分行 0875",
							"0886": "玉山商業銀行林口分行 0886",
							"0897": "玉山商業銀行東湖分行 0897",
							"0901": "玉山商業銀行北新分行 0901",
							"0912": "玉山商業銀行中崙分行 0912",
							"0923": "玉山商業銀行建成分行 0923",
							"0934": "玉山商業銀行屏東分行 0934",
							"0945": "玉山商業銀行二重分行 0945",
							"0956": "玉山商業銀行台北分行 0956",
							"0967": "玉山商業銀行大安分行 0967",
							"0978": "玉山商業銀行東港分行 0978",
							"0989": "玉山商業銀行古亭分行 0989",
							"0990": "玉山商業銀行草屯分行 0990",
							"1001": "玉山商業銀行新營分行 1001",
							"1012": "玉山商業銀行迴龍分行 1012",
							"1023": "玉山商業銀行花蓮分行 1023",
							"1034": "玉山商業銀行澎湖分行 1034",
							"1045": "玉山商業銀行三峽分行 1045",
							"1056": "玉山商業銀行松江分行 1056",
							"1067": "玉山商業銀行金華分行 1067",
							"1078": "玉山商業銀行光復分行 1078",
							"1089": "玉山商業銀行新湖分行 1089",
							"1090": "玉山商業銀行桃鶯分行 1090",
							"1104": "玉山商業銀行員林分行 1104",
							"1115": "玉山商業銀行永安分行 1115",
							"1126": "玉山商業銀行新豐分行 1126",
							"1137": "玉山商業銀行仁德分行 1137",
							"1148": "玉山商業銀行泰和分行 1148",
							"1159": "玉山商業銀行西屯分行 1159",
							"1160": "玉山商業銀行南勢角分行 1160",
							"1171": "玉山商業銀行板橋分行 1171",
							"1182": "玉山商業銀行南港分行 1182",
							"1193": "玉山商業銀行東門分行 1193",
							"1207": "玉山商業銀行南土城分行 1207",
							"1218": "玉山商業銀行朴子分行 1218",
							"1229": "玉山商業銀行信義分行 1229",
							"1230": "玉山商業銀行汐止分行 1230",
							"1241": "玉山商業銀行新樹分行 1241",
							"1252": "玉山商業銀行中工分行 1252",
							"1263": "玉山商業銀行瑞光分行 1263",
							"1274": "玉山商業銀行鹽行分行 1274",
							"1285": "玉山商業銀行頭份分行 1285",
							"1296": "玉山商業銀行後龍分行 1296",
							"1300": "玉山商業銀行五權分行 1300",
							"1311": "玉山商業銀行南永康分行 1311",
							"1322": "玉山商業銀行藝文分行 1322",
							"1333": "玉山商業銀行中原分行 1333",
							"1344": "玉山商業銀行竹科分行 1344",
							"1355": "玉山商業銀行太平分行 1355",
							"1366": "玉山商業銀行台中分行 1366",
							"1377": "玉山商業銀行六家分行 1377",
							"1388": "玉山商業銀行北屯分行 1388",
							"1399": "玉山商業銀行烏日分行 1399",
							"1403": "玉山商業銀行安南分行 1403",
							"1425": "玉山商業銀行沙鹿分行 1425",
							"1436": "玉山商業銀行東林口分行 1436",
							"1458": "玉山商業銀行南山廣場分行 1458",
							"7003": "玉山銀行(中國)有限公司 7003",
							"7014": "玉山銀行(中國)有限公司東莞分行 7014",
							"7025": "玉山銀行(中國)有限公司東莞長安支行 7025",
							"7036": "玉山銀行(中國)有限公司深圳分行 7036",
							"7058": "玉山銀行(中國)有限公司廣州分行 7058",
							"8000": "聯合商業銀行 8000",
							"8011": "聯合商業銀行西哈努克分行 8011",
							"8022": "聯合商業銀行暹粒分行 8022",
							"8033": "聯合商業銀行馬德望分行 8033",
							"8055": "聯合商業銀行奧林匹克分行 8055",
							"8066": "聯合商業銀行干拉省Vihear 8066",
							"8077": "聯合商業銀行鐵橋頭分行 8077",
							"8088": "聯合商業銀行五洲分行 8088",
							"8099": "聯合商業銀行堆谷分行 8099",
							"8103": "聯合商業銀行德他拉分行 8103",
							"8114": "聯合商業銀行德拉歐分行 8114",
							"8125": "聯合商業銀行舊運動場分行 8125",
							"8136": "聯合商業銀行上棉芷分行 8136",
							"8147": "聯合商業銀行舊市場分行 8147",
							"9007": "玉山商業銀行洛杉磯分行 9007",
							"9018": "玉山商業銀行香港分行 9018",
							"9052": "玉山商業銀行新加坡分行 9052",
							"9100": "玉山銀行同奈分行 9100",
							"9122": "玉山商業銀行雪梨分行 9122",
							"9133": "玉山商業銀行仰光分行 9133",
							"9155": "玉山銀行東京分行 9155",
							"9166": "玉山商業銀行布里斯本分行 9166",
							"9993": "玉山商業銀行河內代表人辦事處 9993"
						}
					},
					"809": {
						"one": "凱基商業銀行 809",
						"two": {
							"0016": "凱基商業銀行建成分行 0016",
							"0027": "凱基商業銀行忠孝分行 0027",
							"0038": "凱基商業銀行三重分行 0038",
							"0049": "凱基商業銀行台中分行 0049",
							"0050": "凱基商業銀行台南分行 0050",
							"0061": "凱基商業銀行高雄分行 0061",
							"0072": "凱基商業銀行城東分行 0072",
							"0083": "凱基商業銀行信託部 0083",
							"0094": "凱基商業銀行營業部 0094",
							"0108": "凱基商業銀行板橋分行 0108",
							"0119": "凱基商業銀行桃園分行 0119",
							"0120": "凱基商業銀行中壢分行 0120",
							"0131": "凱基商業銀行北高雄分行 0131",
							"0142": "凱基商業銀行國外部 0142",
							"0153": "凱基商業銀行新莊分行 0153",
							"0164": "凱基商業銀行左營分行 0164",
							"0175": "凱基商業銀行員林分行 0175",
							"0186": "凱基商業銀行國際金融業務分行 0186",
							"0197": "凱基商業銀行敦南分行 0197",
							"0201": "凱基商業銀行松江分行 0201",
							"0212": "凱基商業銀行蘆洲分行 0212",
							"0223": "凱基商業銀行鳳山分行 0223",
							"0234": "凱基商業銀行新竹分行 0234",
							"0245": "凱基商業銀行松山分行 0245",
							"0256": "凱基商業銀行土城分行 0256",
							"0267": "凱基商業銀行中和分行 0267",
							"0278": "凱基商業銀行赤崁分行 0278",
							"0289": "凱基商業銀行基隆分行 0289",
							"0304": "凱基商業銀行東門分行 0304",
							"0315": "凱基商業銀行北門分行 0315",
							"0326": "凱基商業銀行屏東分行 0326",
							"0337": "凱基商業銀行雙和分行 0337",
							"0348": "凱基商業銀行歸仁分行 0348",
							"0359": "凱基商業銀行海東分行 0359",
							"0371": "凱基商業銀行永康分行 0371",
							"0393": "凱基商業銀行新店分行 0393",
							"0407": "凱基商業銀行大安分行 0407",
							"0429": "凱基商業銀行苗栗分行 0429",
							"0430": "凱基商業銀行內湖分行 0430",
							"0452": "凱基商業銀行花蓮分行 0452",
							"0463": "凱基商業銀行繼光分行 0463",
							"0474": "凱基商業銀行彰化分行 0474",
							"0485": "凱基商業銀行豐原分行 0485",
							"0511": "凱基商業銀行大里分行 0511",
							"0522": "凱基商業銀行嘉義分行 0522",
							"0577": "凱基商業銀行風城分行 0577",
							"0588": "凱基商業銀行南大分行 0588",
							"0599": "凱基商業銀行竹科分行 0599",
							"0625": "凱基商業銀行台東分行 0625",
							"0669": "凱基商業銀行羅東分行 0669",
							"0670": "凱基商業銀行大直分行 0670",
							"0681": "凱基商業銀行高美館分行 0681",
							"0692": "凱基商業銀行市政分行 0692",
							"0706": "凱基商業銀行藝文分行 0706",
							"0717": "凱基商業銀行瑞光分行 0717",
							"0728": "凱基商業銀行民生分行 0728"
						}
					},
					"810": {
						"one": "星展(台灣)商業銀行 810",
						"two": {
							"0021": "星展(台灣)商業銀行忠孝分行 0021",
							"0043": "星展(台灣)商業銀行高雄分行 0043",
							"0054": "星展(台灣)商業銀行桃園分行 0054",
							"0065": "星展(台灣)商業銀行豐原分行 0065",
							"0098": "星展(台灣)商業銀行台南分行 0098",
							"0102": "星展(台灣)商業銀行大安分行 0102",
							"0113": "星展(台灣)商業銀行華山分行 0113",
							"0124": "星展(台灣)商業銀行太平分行 0124",
							"0135": "星展(台灣)商業銀行中清分行 0135",
							"0157": "星展(台灣)商業銀行三重分行 0157",
							"0168": "星展(台灣)商業銀行蘆洲分行 0168",
							"0179": "星展(台灣)商業銀行信義分行 0179",
							"0180": "星展(台灣)商業銀行中港分行 0180",
							"0191": "星展(台灣)商業銀行國際金融業務分行 0191",
							"0205": "星展(台灣)商業銀行左營分行 0205",
							"0216": "星展(台灣)商業銀行汐止分行 0216",
							"0227": "星展(台灣)商業銀行天母分行 0227",
							"0250": "星展(台灣)商業銀行新莊分行 0250",
							"0261": "星展(台灣)商業銀行板橋分行 0261",
							"0272": "星展(台灣)商業銀行中和分行 0272",
							"0283": "星展(台灣)商業銀行楠梓分行 0283",
							"0294": "星展(台灣)商業銀行民權分行 0294",
							"0308": "星展(台灣)商業銀行苓雅分行 0308",
							"0319": "星展(台灣)商業銀行東台南分行 0319",
							"0320": "星展(台灣)商業銀行新店分行 0320",
							"0331": "星展(台灣)商業銀行前鎮分行 0331",
							"0342": "星展(台灣)商業銀行東新竹分行 0342",
							"0364": "星展(台灣)商業銀行南京東路分行 0364",
							"0375": "星展(台灣)商業銀行莒光分行 0375",
							"0386": "星展(台灣)商業銀行中壢分行 0386",
							"0397": "星展(台灣)商業銀行新竹分行 0397",
							"0401": "星展(台灣)商業銀行大同分行 0401",
							"0412": "星展(台灣)商業銀行敦南分行 0412",
							"0423": "星展(台灣)商業銀行內湖分行 0423",
							"0434": "信託業務專責部門 0434",
							"0456": "星展(台灣)商業銀行松山分行 0456",
							"0467": "星展(台灣)商業銀行松江分行 0467",
							"0478": "星展(台灣)商業銀行松仁分行 0478",
							"0489": "星展(台灣)商業銀行新站分行 0489",
							"0490": "星展(台灣)商業銀行中正分行 0490",
							"0504": "星展(台灣)商業銀行中興分行 0504",
							"0559": "星展(台灣)商業銀行四維分行 0559",
							"0858": "星展(台灣)商業銀行內湖科學園區分行 0858"
						}
					},
					"812": {
						"one": "台新國際商業銀行 812",
						"two": {
							"0012": "台新國際商業銀行營業部 0012",
							"0023": "台新國際商業銀行敦南分行 0023",
							"0045": "台新國際商業銀行新生分行 0045",
							"0056": "台新國際商業銀行新莊分行 0056",
							"0067": "台新國際商業銀行桃園分行 0067",
							"0078": "台新國際商業銀行台中分行 0078",
							"0089": "台新國際商業銀行板橋分行 0089",
							"0090": "台新國際商業銀行高雄分行 0090",
							"0104": "台新國際商業銀行台南分行 0104",
							"0115": "台新國際商業銀行南京東路分行 0115",
							"0126": "台新國際商業銀行中壢分行 0126",
							"0137": "台新國際商業銀行信託部 0137",
							"0148": "台新國際商業銀行國外部 0148",
							"0159": "台新國際商業銀行苓雅分行 0159",
							"0160": "台新國際商業銀行蘆洲分行 0160",
							"0171": "台新國際商業銀行天母分行 0171",
							"0182": "台新國際商業銀行大里分行 0182",
							"0193": "台新國際商業銀行國際金融業務分行 0193",
							"0207": "台新國際商業銀行中和分行 0207",
							"0218": "台新國際商業銀行嘉義分行 0218",
							"0229": "台新國際商業銀行豐原分行 0229",
							"0230": "台新國際商業銀行花蓮分行 0230",
							"0241": "台新國際商業銀行新竹分行 0241",
							"0252": "台新國際商業銀行七賢分行 0252",
							"0263": "台新國際商業銀行信義分行 0263",
							"0274": "台新國際商業銀行北台中分行 0274",
							"0285": "台新國際商業銀行三重分行 0285",
							"0296": "台新國際商業銀行永福分行 0296",
							"0300": "台新國際商業銀行屏東分行 0300",
							"0311": "台新國際商業銀行大安分行 0311",
							"0322": "台新國際商業銀行龍潭分行 0322",
							"0333": "台新國際商業銀行崇德分行 0333",
							"0344": "台新國際商業銀行金華分行 0344",
							"0355": "台新國際商業銀行後甲分行 0355",
							"0366": "台新國際商業銀行海佃分行 0366",
							"0377": "台新國際商業銀行彰化分行 0377",
							"0388": "台新國際商業銀行五甲分行 0388",
							"0399": "台新國際商業銀行鳳山分行 0399",
							"0403": "台新國際商業銀行古亭分行 0403",
							"0414": "台新國際商業銀行建橋分行 0414",
							"0436": "台新國際商業銀行民生分行 0436",
							"0447": "台新國際商業銀行太平分行 0447",
							"0458": "台新國際商業銀行和平分行 0458",
							"0469": "台新國際商業銀行北高雄分行 0469",
							"0470": "台新國際商業銀行南新莊分行 0470",
							"0481": "台新國際商業銀行內湖分行 0481",
							"0492": "台新國際商業銀行永和分行 0492",
							"0517": "台新國際商業銀行逢甲分行 0517",
							"0528": "台新國際商業銀行竹科分行 0528",
							"0540": "台新國際商業銀行南屯分行 0540",
							"0551": "台新國際商業銀行大直分行 0551",
							"0562": "台新國際商業銀行南門分行 0562",
							"0610": "台新國際商業銀行西門分行 0610",
							"0621": "台新國際商業銀行敦北分行 0621",
							"0632": "台新國際商業銀行忠孝分行 0632",
							"0643": "台新國際商業銀行復興分行 0643",
							"0654": "台新國際商業銀行板南分行 0654",
							"0665": "台新國際商業銀行民權分行 0665",
							"0676": "台新國際商業銀行三民分行 0676",
							"0687": "台新國際商業銀行建北分行 0687",
							"0698": "台新國際商業銀行三和分行 0698",
							"0702": "台新國際商業銀行北新店分行 0702",
							"0713": "台新國際商業銀行府城分行 0713",
							"0724": "台新國際商業銀行東高雄分行 0724",
							"0735": "台新國際商業銀行基隆路分行 0735",
							"0746": "台新國際商業銀行新店分行 0746",
							"0757": "台新國際商業銀行北桃園分行 0757",
							"0768": "台新國際商業銀行大墩分行 0768",
							"0779": "台新國際商業銀行延平分行 0779",
							"0780": "台新國際商業銀行南崁分行 0780",
							"0791": "台新國際商業銀行景平分行 0791",
							"0805": "台新國際商業銀行文心分行 0805",
							"0816": "台新國際商業銀行岡山分行 0816",
							"0827": "台新國際商業銀行松江分行 0827",
							"0838": "台新國際商業銀行大雅分行 0838",
							"0849": "台新國際商業銀行汐止分行 0849",
							"0850": "台新國際商業銀行成功分行 0850",
							"0861": "台新國際商業銀行石牌分行 0861",
							"0872": "台新國際商業銀行永康分行 0872",
							"0883": "台新國際商業銀行南松山分行 0883",
							"0894": "台新國際商業銀行淡水分行 0894",
							"0908": "台新國際商業銀行東基隆分行 0908",
							"0919": "台新國際商業銀行新板分行 0919",
							"0920": "台新國際商業銀行北師分行 0920",
							"0931": "台新國際商業銀行佳里分行 0931",
							"0942": "台新國際商業銀行江翠分行 0942",
							"0975": "台新國際商業銀行松德分行 0975",
							"0986": "台新國際商業銀行北大分行 0986",
							"0997": "台新國際商業銀行南港分行 0997",
							"1008": "台新國際商業銀行關東橋分行 1008",
							"1019": "台新國際商業銀行竹北分行 1019",
							"1020": "台新國際商業銀行南寮分行 1020",
							"1031": "台新國際商業銀行八德分行 1031",
							"1042": "台新國際商業銀行員林分行 1042",
							"1053": "台新國際商業銀行市府分行 1053",
							"1064": "台新國際商業銀行右昌分行 1064",
							"1075": "台新國際商業銀行沙鹿分行 1075",
							"1086": "台新國際商業銀行竹南分行 1086",
							"1097": "台新國際商業銀行羅東分行 1097",
							"1101": "台新國際商業銀行東湖分行 1101",
							"1112": "台新國際商業銀行文山分行 1112",
							"1123": "台新國際商業銀行副都心分行 1123",
							"1134": "台新國際商業銀行景美分行 1134",
							"1145": "台新國際商業銀行雄科分行 1145",
							"9004": "台新國際商銀香港分行 9004",
							"9200": "台新國際商業銀行新加坡分行 9200",
							"9222": "台新國際商業銀行布里斯本分行 9222",
							"9233": "台新國際商業銀行東京分行 9233",
							"9244": "緬甸仰光代表人辦事處 9244",
							"9990": "越南胡志明市代表人辦事處 9990"
						}
					},
					"815": {
						"one": "日盛國際商業銀行 815",
						"two": {
							"0015": "日盛國際商業銀行營業部 0015",
							"0026": "日盛國際商業銀行松江分行 0026",
							"0037": "日盛國際商業銀行延平分行 0037",
							"0048": "日盛國際商業銀行內湖分行 0048",
							"0059": "日盛國際商業銀行桃園分行 0059",
							"0060": "日盛國際商業銀行台中分行 0060",
							"0071": "日盛國際商業銀行台南分行 0071",
							"0082": "日盛國際商業銀行信託處 0082",
							"0093": "日盛國際商業銀行高雄分行 0093",
							"0107": "日盛國際商業銀行新莊分行 0107",
							"0118": "日盛國際商業銀行中壢分行 0118",
							"0129": "日盛國際商業銀行松山分行 0129",
							"0130": "日盛國際商業銀行松南分行 0130",
							"0141": "日盛國際商業銀行八德分行 0141",
							"0152": "日盛國際商業銀行國外部 0152",
							"0163": "日盛國際商業銀行板橋分行 0163",
							"0174": "日盛國際商業銀行信義分行 0174",
							"0185": "日盛國際商業銀行苓雅分行 0185",
							"0196": "日盛國際商業銀行前金分行 0196",
							"0200": "日盛國際商銀國際金融業務分行 0200",
							"0211": "日盛國際商業銀行嘉義分行 0211",
							"0222": "日盛國際商業銀行三重分行 0222",
							"0233": "日盛國際商業銀行北台中分行 0233",
							"0244": "日盛國際商業銀行雙和分行 0244",
							"0255": "日盛國際商業銀行士林分行 0255",
							"0266": "日盛國際商業銀行樹林分行 0266",
							"0277": "日盛國際商業銀行北桃園分行 0277",
							"0288": "日盛國際商業銀行新竹分行 0288",
							"0299": "日盛國際商業銀行敦化分行 0299",
							"0303": "日盛國際商業銀行北高雄分行 0303",
							"0314": "日盛國際商業銀行新營分行 0314",
							"0325": "日盛國際商業銀行頭份分行 0325",
							"0336": "日盛國際商業銀行大里分行 0336",
							"0347": "日盛國際商業銀行光復分行 0347",
							"0358": "日盛國際商業銀行員林分行 0358",
							"0369": "日盛國際商業銀行虎尾分行 0369",
							"0370": "日盛國際商業銀行屏東分行 0370",
							"0381": "日盛國際商業銀行南門分行 0381",
							"0392": "日盛國際商業銀行大安分行 0392",
							"0406": "日盛國際商業銀行敦北分行 0406",
							"0417": "日盛國際商業銀行南京分行 0417",
							"0428": "日盛國際商業銀行竹北分行 0428",
							"0439": "日盛國際商業銀行安平分行 0439",
							"0451": "日盛國際商業銀行新店分行 0451",
							"0462": "日盛國際商業銀行土城分行 0462",
							"0473": "日盛國際商業銀行南港分行 0473",
							"0484": "日盛國際商業銀行蘆洲分行 0484",
							"0815": "日盛國際商業銀行信用卡事業處 0815",
							"9993": "日盛國際商業銀行香港代表辦事處 9993"
						}
					},
					"816": {
						"one": "安泰商業銀行 816",
						"two": {
							"0016": "安泰商業銀行長安東路分行 0016",
							"0027": "安泰商業銀行信義分行 0027",
							"0038": "安泰商業銀行營業部 0038",
							"0049": "安泰商業銀行新生分行 0049",
							"0050": "安泰商業銀行桃園分行 0050",
							"0061": "安泰商業銀行新莊分行 0061",
							"0072": "安泰商業銀行台中分行 0072",
							"0083": "安泰商業銀行高雄分行 0083",
							"0094": "安泰商業銀行台南分行 0094",
							"0108": "安泰商業銀行興隆分行 0108",
							"0119": "安泰商業銀行延平分行 0119",
							"0120": "安泰商業銀行中壢分行 0120",
							"0131": "安泰商業銀行板橋分行 0131",
							"0142": "安泰商業銀行豐原分行 0142",
							"0153": "安泰商業銀行前金分行 0153",
							"0164": "安泰商業銀行中和分行 0164",
							"0175": "安泰商業銀行國外部 0175",
							"0186": "安泰商業銀行鳳山分行 0186",
							"0197": "安泰商業銀行松江分行 0197",
							"0201": "安泰商業銀行中崙分行 0201",
							"0212": "安泰商業銀行嘉義分行 0212",
							"0223": "安泰商業銀行三重分行 0223",
							"0234": "安泰商業銀行國際金融業務分行 0234",
							"0245": "安泰商業銀行沙鹿分行 0245",
							"0256": "安泰商業銀行新竹分行 0256",
							"0267": "安泰商業銀行員林分行 0267",
							"0278": "安泰商業銀行建國分行 0278",
							"0289": "安泰商業銀行北高雄分行 0289",
							"0290": "安泰商業銀行新店分行 0290",
							"0304": "安泰商業銀行和平分行 0304",
							"0315": "安泰商業銀行成功分行 0315",
							"0326": "安泰商業銀行通化分行 0326",
							"0337": "安泰商業銀行南門分行 0337",
							"0348": "安泰商業銀行汀州分行 0348",
							"0359": "安泰商業銀行農安分行 0359",
							"0360": "安泰商業銀行景美分行 0360",
							"0371": "安泰商業銀行民權分行 0371",
							"0382": "安泰商業銀行松山分行 0382",
							"0393": "安泰商業銀行內湖分行 0393",
							"0407": "安泰商業銀行台北101分行 0407",
							"0418": "安泰商業銀行蘆洲分行 0418",
							"0429": "安泰商業銀行永康分行 0429",
							"0430": "安泰商業銀行西壢分行 0430",
							"0441": "安泰商業銀行北桃園簡易型分行 0441",
							"0452": "安泰商業銀行幸福分行 0452",
							"0463": "安泰商業銀行天母分行 0463",
							"0474": "安泰商業銀行龍潭簡易型分行 0474",
							"0500": "安泰商業銀行石牌分行 0500",
							"0511": "安泰商業銀行八德簡易型分行 0511",
							"0522": "安泰商業銀行竹北簡易型分行 0522",
							"0533": "安泰商業銀行永和分行 0533",
							"0566": "安泰商業銀行大里分行 0566",
							"9101": "安泰商業銀行信託部 9101"
						}
					},
					"822": {
						"one": "中國信託商業銀行 822",
						"two": {
							"0015": "中國信託商業銀行敦北分行 0015",
							"0026": "中國信託商業銀行台中分行 0026",
							"0037": "中國信託商業銀行高雄分行 0037",
							"0059": "中國信託商業銀行台南分行 0059",
							"0060": "中國信託商業銀行三重分行 0060",
							"0071": "中國信託商業銀行城東分行 0071",
							"0082": "中國信託商業銀行嘉義分行 0082",
							"0093": "中國信託商業銀行中崙分行 0093",
							"0107": "中國信託商業銀行城中分行 0107",
							"0118": "中國信託商業銀行三民分行 0118",
							"0129": "中國信託商業銀行中壢分行 0129",
							"0130": "中國信託商業銀行雙和分行 0130",
							"0141": "中國信託商業銀行中山分行 0141",
							"0152": "中國信託商業銀行仁愛分行 0152",
							"0163": "中國信託商業銀行敦南分行 0163",
							"0174": "中國信託商業銀行板橋分行 0174",
							"0185": "中國信託商業銀行忠孝分行 0185",
							"0196": "中國信託商業銀行新興分行 0196",
							"0200": "中國信託商業銀行南京東路分行 0200",
							"0211": "中國信託商業銀行信託部 0211",
							"0222": "中國信託商業銀行西台南分行 0222",
							"0244": "中國信託商業銀行國際金融業務分行 0244",
							"0255": "中國信託商業銀行松山分行 0255",
							"0266": "中國信託商業銀行新莊分行 0266",
							"0277": "中國信託商業銀行桃園分行 0277",
							"0288": "中國信託商業銀行中港分行 0288",
							"0299": "中國信託商業銀行新竹分行 0299",
							"0303": "中國信託商業銀行蘆洲分行 0303",
							"0314": "中國信託商業銀行新店分行 0314",
							"0325": "中國信託商業銀行員林分行 0325",
							"0336": "中國信託商業銀行東新竹分行 0336",
							"0347": "中國信託商業銀行公館分行 0347",
							"0358": "中國信託商業銀行永康分行 0358",
							"0369": "中國信託商業銀行土城分行 0369",
							"0370": "中國信託商業銀行頭份分行 0370",
							"0381": "中國信託商業銀行基隆分行 0381",
							"0392": "中國信託商業銀行豐原分行 0392",
							"0406": "中國信託商業銀行天母分行 0406",
							"0417": "中國信託商業銀行板新分行 0417",
							"0428": "中國信託商業銀行彰化分行 0428",
							"0439": "中國信託商業銀行東高雄分行 0439",
							"0440": "中國信託商業銀行中華分行 0440",
							"0451": "中國信託商業銀行內湖分行 0451",
							"0462": "中國信託商業銀行斗六分行 0462",
							"0473": "中國信託商業銀行文心分行 0473",
							"0484": "中國信託商業銀行重陽分行 0484",
							"0495": "中國信託商業銀行永吉分行 0495",
							"0509": "中國信託商業銀行前鎮分行 0509",
							"0510": "中國信託商業銀行南崁分行 0510",
							"0521": "中國信託商業銀行永和分行 0521",
							"0532": "中國信託商業銀行公益分行 0532",
							"0543": "中國信託商業銀行市府分行 0543",
							"0554": "中國信託商業銀行六家庄分行 0554",
							"0565": "中國信託商業銀行右昌分行 0565",
							"0576": "中國信託商業銀行江翠分行 0576",
							"0587": "中國信託商業銀行東湖分行 0587",
							"0598": "中國信託商業銀行中原分行 0598",
							"0602": "中國信託商業銀行大安分行 0602",
							"0613": "中國信託商業銀行北高雄分行 0613",
							"0624": "中國信託商業銀行承德分行 0624",
							"0635": "中國信託商業銀行復興分行 0635",
							"0646": "中國信託商業銀行石牌分行 0646",
							"0657": "中國信託商業銀行城北分行 0657",
							"0668": "中國信託商業銀行萬華分行 0668",
							"0679": "中國信託商業銀行西松分行 0679",
							"0680": "中國信託商業銀行北投分行 0680",
							"0691": "中國信託商業銀行安和分行 0691",
							"0705": "中國信託商業銀行西湖分行 0705",
							"0716": "中國信託商業銀行瑞光分行 0716",
							"0727": "中國信託商業銀行宜蘭分行 0727",
							"0738": "中國信託商業銀行民生分行 0738",
							"0749": "中國信託商業銀行中和分行 0749",
							"0750": "中國信託商業銀行重新分行 0750",
							"0761": "中國信託商業銀行丹鳳分行 0761",
							"0772": "中國信託商業銀行北新店分行 0772",
							"0783": "中國信託商業銀行汐止分行 0783",
							"0794": "中國信託商業銀行金城分行 0794",
							"0808": "中國信託商業銀行樹林分行 0808",
							"0819": "中國信託商業銀行南勢角分行 0819",
							"0820": "中國信託商業銀行北新莊分行 0820",
							"0853": "中國信託商業銀行南桃園分行 0853",
							"0864": "中國信託商業銀行北桃園分行 0864",
							"0875": "中國信託商業銀行竹科分行 0875",
							"0901": "中國信託商業銀行總行營業部 0901",
							"1012": "中國信託商業銀行八德分行 1012",
							"1023": "中國信託商業銀行林口分行 1023",
							"1034": "中國信託商業銀行竹北分行 1034",
							"1045": "中國信託商業銀行南屯分行 1045",
							"1056": "中國信託商業銀行大里分行 1056",
							"1067": "中國信託商業銀行洲際分行 1067",
							"1078": "中國信託商業銀行南投分行 1078",
							"1090": "中國信託商業銀行仁德分行 1090",
							"1104": "中國信託商業銀行中台南分行 1104",
							"1115": "中國信託商業銀行東台南分行 1115",
							"1126": "中國信託商業銀行台東分行 1126",
							"1137": "中國信託商業銀行南台南分行 1137",
							"1148": "中國信託商業銀行新營分行 1148",
							"1159": "中國信託商業銀行科博館分行 1159",
							"1160": "中國信託商業銀行西屯分行 1160",
							"1171": "中國信託商業銀行民族分行 1171",
							"1182": "中國信託商業銀行南高雄分行 1182",
							"1193": "中國信託商業銀行九如分行 1193",
							"1207": "中國信託商業銀行屏東分行 1207",
							"1218": "中國信託商業銀行復北分行 1218",
							"1229": "中國信託商業銀行鳳山分行 1229",
							"1230": "中國信託商業銀行五甲分行 1230",
							"1241": "中國信託商業銀行延吉分行 1241",
							"1252": "中國信託商業銀行信義分行 1252",
							"1263": "中國信託商業銀行青年分行 1263",
							"1274": "中國信託商業銀行岡山分行 1274",
							"1285": "中國信託商業銀行士林分行 1285",
							"1296": "中國信託商業銀行東民生分行 1296",
							"1300": "中國信託商業銀行文山分行 1300",
							"2101": "中國信託商業銀行淡水分行 2101",
							"2112": "中國信託商業銀行民安分行 2112",
							"2123": "中國信託商業銀行二重埔簡易型分行 2123",
							"2134": "中國信託商業銀行富錦分行 2134",
							"2145": "中國信託商業銀行站前分行 2145",
							"2156": "中國信託商業銀行惠中分行 2156",
							"2167": "中國信託商業銀行東蘆洲分行 2167",
							"2178": "中國信託商業銀行木柵分行 2178",
							"2189": "中國信託商業銀行東花蓮分行 2189",
							"2190": "中國信託商業銀行寶山分行 2190",
							"2204": "中國信託商業銀行藝文分行 2204",
							"2215": "中國信託商業銀行東門分行 2215",
							"2226": "中國信託商業銀行新板特區分行 2226",
							"2237": "中國信託商業銀行三和分行 2237",
							"2248": "中國信託商業銀行劍潭分行 2248",
							"2259": "中國信託商業銀行北蘆洲分行 2259",
							"2260": "中國信託商業銀行寶強分行 2260",
							"2271": "中國信託商業銀行華山分行 2271",
							"2282": "中國信託商業銀行龍江分行 2282",
							"2293": "中國信託商業銀行成功分行 2293",
							"3108": "中國信託商業銀行市政分行 3108",
							"3119": "中國信託商業銀行大直分行 3119",
							"3120": "中國信託商業銀行景美分行 3120",
							"3131": "中國信託商業銀行內壢分行 3131",
							"3142": "中國信託商業銀行重慶分行 3142",
							"3153": "中國信託商業銀行長安分行 3153",
							"3164": "中國信託商業銀行羅東分行 3164",
							"3175": "中國信託商業銀行南中壢分行 3175",
							"3186": "中國信託商業銀行板和簡易型分行 3186",
							"3197": "中國信託商業銀行花蓮分行 3197",
							"3201": "中國信託商業銀行北天母分行 3201",
							"3212": "中國信託商業銀行民權西路分行 3212",
							"3223": "中國信託商業銀行佳里分行 3223",
							"3234": "中國信託商業銀行博愛分行 3234",
							"3245": "中國信託商業銀行鹽行分行 3245",
							"3267": "中國信託商業銀行光復分行 3267",
							"3278": "中國信託商業銀行埔墘簡易型分行 3278",
							"3289": "中國信託商業銀行黎明分行 3289",
							"3290": "中國信託商業銀行新富分行 3290",
							"3603": "中國信託商業銀行三峽分行 3603",
							"3614": "中國信託商業銀行東林口分行 3614",
							"8549": "美國中信銀行亞凱迪亞分行 8549",
							"8550": "東京之星銀行-川口出張所 8550",
							"8561": "東京之星銀行-浜田山出張所 8561",
							"8572": "東京之星銀行-三軒茶屋出張所 8572",
							"8583": "美國中信銀行舊金山分行 8583",
							"8608": "中國信託商業銀行深圳分行 8608",
							"8619": "東京之星銀行-代代木上原出張所 8619",
							"8620": "東京之星銀行-南砂町出張所 8620",
							"8631": "中國信託商業銀行菲律賓子行-Iloilo 8631",
							"8642": "中國信託商業銀行仰光代表人辦事處 8642",
							"8653": "中國信託商業銀行雪梨代表人辦事處 8653",
							"8664": "中國信託商業銀行吉隆坡代表人辦事處 8664",
							"8675": "東京之星銀行-梅田分行 8675",
							"8686": "中國信託商業銀行廈門分行 8686",
							"8697": "中國信託商業銀行廣州分行 8697",
							"8701": "中國信託商業銀行上海自貿試驗區支行 8701",
							"8712": "中國信託商業銀行印尼子行-Jakarta(雅加達分行) 8712",
							"8723": "中國信託商業銀行加拿大子行-Vancouver 8723",
							"8734": "東京之星銀行-本店 8734",
							"8745": "東京之星銀行-難波分行 8745",
							"8756": "東京之星銀行-名古屋分行 8756",
							"8767": "東京之星銀行-廣島分行 8767",
							"8778": "東京之星銀行-福岡分行 8778",
							"8789": "東京之星銀行-神戶分行 8789",
							"8790": "東京之星銀行-仙台分行 8790",
							"8804": "東京之星銀行-札幌分行 8804",
							"8815": "東京之星銀行-大宮分行 8815",
							"8826": "東京之星銀行-浦和分行 8826",
							"8837": "東京之星銀行-船橋分行 8837",
							"8848": "東京之星銀行-松戶分行 8848",
							"8859": "東京之星銀行-千葉分行 8859",
							"8871": "東京之星銀行-港南台分行 8871",
							"8882": "東京之星銀行-渋谷站前分行(原溝之口分行搬遷後更名) 8882",
							"8893": "東京之星銀行-藤澤分行 8893",
							"8907": "東京之星銀行-橫濱分行 8907",
							"8918": "東京之星銀行-調布分行 8918",
							"8929": "東京之星銀行-自由之丘分行 8929",
							"8930": "東京之星銀行-日比谷分行 8930",
							"8941": "東京之星銀行-高島平分行 8941",
							"8952": "東京之星銀行-新宿分行 8952",
							"8963": "東京之星銀行-小平分行 8963",
							"8974": "東京之星銀行-立川分行 8974",
							"8985": "東京之星銀行-吉祥寺分行 8985",
							"8996": "東京之星銀行-小岩分行 8996",
							"9007": "東京之星銀行-上野分行 9007",
							"9018": "東京之星銀行-渋谷分行 9018",
							"9029": "中國信託商業銀行新德里分行 9029",
							"9041": "中國信託商業銀行香港分行 9041",
							"9052": "中國信託商業銀行紐約分行 9052",
							"9063": "中國信託商業銀行東京分行 9063",
							"9074": "中國信託商業銀行胡志明市分行 9074",
							"9085": "中國信託商業銀行印尼子行-Karawaci 9085",
							"9096": "中國信託商業銀行斯里伯魯德分行(清奈) 9096",
							"9100": "中國信託商業銀行上海分行 9100",
							"9111": "東京之星銀行-銀座分行 9111",
							"9122": "東京之星銀行-池袋分行 9122",
							"9133": "東京之星銀行-總行 9133",
							"9155": "東京之星銀行-子公司 9155",
							"9166": "東京之星銀行-子公司 9166",
							"9177": "中國信託商業銀行加拿大子行-Toronto 9177",
							"9188": "中國信託商業銀行印尼子行-Puri 9188",
							"9199": "中國信託商業銀行菲律賓子行-Bonifacio 9199",
							"9203": "中國信託商業銀行印尼子行-Darmo 9203",
							"9225": "中國信託商業銀行印尼子行-Pluit 9225",
							"9236": "中國信託商業銀行印尼子行-Dago 9236",
							"9247": "中國信託商業銀行新加坡分行 9247",
							"9292": "中國信託商業銀行菲律賓子行-Las 9292",
							"9306": "中國信託商業銀行菲律賓子行-Magallanes 9306",
							"9317": "中國信託商業銀行菲律賓子行-Cebu 9317",
							"9340": "中國信託商業銀行菲律賓子行-Davao 9340",
							"9351": "中國信託商業銀行菲律賓子行-Angeles 9351",
							"9362": "CTBC 9362",
							"9373": "中國信託商業銀行洛杉磯代表人辦事處 9373",
							"9409": "美國中信銀行-Rowland 9409",
							"9410": "中國信託商業銀行加拿大子行-Burnaby 9410",
							"9421": "中國信託商業銀行九龍分行(支行) 9421",
							"9432": "中國信託商業銀行印尼子行-Mangga 9432",
							"9443": "中國信託商業銀行加拿大子行-Richmond 9443",
							"9454": "中國信託商業銀行印尼子行-Kelapa 9454",
							"9465": "中國信託商業銀行印尼子行-Cikarang 9465",
							"9476": "中國信託商業銀行印尼子行-Surabaya(泗水分行) 9476",
							"9487": "中國信託商業銀行印尼子行-Bandung(萬隆分行) 9487",
							"9568": "中國信託商業銀行曼谷代表人辦事處 9568",
							"9579": "中國信託商業銀行北京代表人辦事處 9579",
							"9580": "中國信託商業銀行菲律賓子行-Del 9580",
							"9591": "中國信託商業銀行菲律賓子行-Cagayan 9591",
							"9605": "中國信託商業銀行菲律賓子行-Sucat 9605",
							"9616": "中國信託商業銀行菲律賓子行-Subic 9616",
							"9627": "中國信託商業銀行菲律賓子行-Dela 9627",
							"9638": "中國信託商業銀行菲律賓子行-Buendia-Pasong 9638",
							"9649": "中國信託商業銀行菲律賓子行-Ortigas 9649",
							"9650": "中國信託商業銀行菲律賓子行-Marikina 9650",
							"9661": "中國信託商業銀行菲律賓子行-Mabini 9661",
							"9672": "中國信託商業銀行菲律賓子行-Taytay 9672",
							"9683": "中國信託商業銀行菲律賓子行-Greenhills 9683",
							"9694": "中國信託商業銀行菲律賓子行-Cebu 9694",
							"9708": "中國信託商業銀行菲律賓子行-Cavite 9708",
							"9719": "中國信託商業銀行菲律賓子行-Carmona 9719",
							"9720": "中國信託商業銀行菲律賓子行-Binondo 9720",
							"9731": "中國信託商業銀行菲律賓子行-Ayala 9731",
							"9742": "中國信託商業銀行菲律賓子行-Rada 9742",
							"9753": "中國信託商業銀行菲律賓子行-Alabang 9753",
							"9797": "美國中信銀行-Flushing 9797",
							"9823": "美國中信銀行-Brooklyn 9823",
							"9834": "美國中信銀行-Edison 9834",
							"9845": "美國中信銀行-Los 9845",
							"9856": "美國中信銀行-City 9856",
							"9867": "美國中信銀行-San 9867",
							"9878": "美國中信銀行-Cupertino 9878",
							"9889": "美國中信銀行-Monterey 9889",
							"9904": "美國中信銀行-Milpitas 9904",
							"9915": "中國信託(菲律賓)商業銀行 9915",
							"9926": "中國信託商業銀行(加拿大) 9926",
							"9937": "中國信託商業銀行(印尼) 9937",
							"9948": "美國中信銀行 9948",
							"9959": "中國信託商業銀行河內代表人辦事處 9959",
							"9971": "美國中信銀行-Irvine 9971",
							"9982": "美國中信銀行-San 9982"
						}
					},
					"910": {
						"one": "財團法人農漁會聯合資訊中心 910"
					},
					"928": {
						"one": "板橋區農會電腦共用中心 928"
					},
					"951": {
						"one": "新北市農會附設北區農會電腦共同利用中心 951"
					},
					"952": {
						"one": "財團法人農漁會南區資訊中心 952"
					},
					"995": {
						"one": "關貿網路股份有限公司 995"
					},
					"996": {
						"one": "財政部國庫署 996"
					},
					"997": {
						"one": "中華民國信用合作社聯合社南區聯合資訊處理中心 997"
					}
				},
			};
		},
		computed: {
			bankOptions(){
				if(this.formBank.numberVal == ''){
					// 為空：
					return [];
				} else {
					let banks = this.bankList[this.formBank.numberVal]['two'];
					// two是否存在：
					if(banks){
						let list = [];
						for( let i in banks){
							let item = {};
							item.value = i;
							item.label = banks[i];
							// console.log(item);
							list.push(item);
						}
						return list;
					} else {
						let banks = this.bankList[this.formBank.numberVal]['one'];
						let item = {};
						item.value = this.formBank.numberVal;
						item.label = banks;
						let list = [];
						list.push(item);
						return list;
					}
					
				}
			}
		},
		methods: {
			numberValFun(){
				this.formBank.affiliation = '';
			},
			handleClick(tab, event) {
				// console.log(tab, event);
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						alert('submit!');
					} else {
						return false;
					}
				});
			},
			goLoginbu(){
				this.$router.push("/login/account/loginbu");
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			tabfun(index){
				this.lilist=index
			},
			buttonFun(){
				if(this.formBank.name == ''){
					this.formBankTF = true;
					return
				}
				if(this.formBank.numberVal == ''){
					this.formBankTF = true;
					return
				}
				if(this.formBank.affiliation == ''){
					this.formBankTF = true;
					return
				}
				if(this.formBank.account == ''){
					this.formBankTF = true;
					return
				}
				this.formBankTF = false;
				this.loading = true;
				// 發送ajax：
				axios.get(this.$store.state.axiosBusinessSettlementOpUrl, {
					params: {
						uid: this.$store.state.uid,
						action: 1,
						bankname: this.formBank.name,
						banknumber: this.formBank.numberVal,
						bankcode: this.formBank.affiliation,
						branch: this.formBank.account
					}
				}).then(res => {
					this.loading = false;
					// console.log(res.data);
					if(res.data.status){
						this.$store.commit('changeBank',1);
						this.$router.push("/login/loginaudit");
					} else {
						this.$message({
						showClose: true,
						message: res.data.message,
						type: 'error',
						duration: 1000
						});
					}
				})

			}
		},
		created(){
			axios.get(this.$store.state.axiosBusinessSettlementUrl, {
				params: {
					uid: this.$store.state.uid,
					action: 1
				}
			}).then(res => {
				// console.log(res.data.message.status);
				this.formBank.name = res.data.message.bankname;
				// if(res.data.message.status == '0'){
				// 	this.showTF = false;
				// 	// console.log(1);
				// } else {
				// 	this.showTF = true;
				// 	// console.log(2);
				// }
			})
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/* 表頭 */
	.remind_box {
		background: #fff4cc;
		padding: 20px 0;
		display: flex;
		align-items: center;
	}
	.icon_warning {
        font-size: 22px;
        color: #ff4a05;
        padding: 0 6px 0 24px;
    }
	.deal_index_box {
		margin: 20px;
		font-size: 15px;
		color: black;
	}
	.lstl_bock{
		height: 1px;
	}
	.p_list{
		color: #777777;
		padding-left: 30px;
		padding-top: 20px;
	}

	.deal_title {
		display: flex;
		justify-content: flex-start;
		padding-bottom: 10px;
	}

	.deal_title span {
		margin-left: 15px;
		margin-right: 8px;
	}

	.deal_title .deal_hr {
		flex: 1;
		margin-left: 18px;
	}

	.deal_title .deal_hr .cut_off {
		height: 3px;
		background: black;
		margin-top: 8px;
	}

	.select_div {
		width: 100%;
	}

	/* 内容 */
	.datetime_box>span {
		margin: 10px;
	}

	.deal_content_box {
		font-size: 13px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.deal_content_title {
		height: 42px;
		background: #666666;
		line-height: 42px;
		color: white;
		padding-left: 14px;
	}

	.deal_content {
		box-sizing: border-box;
		/* height: 53.6vw; */
		min-height: 300px;
		border: 1px solid #666666;
		background: #ffffff;
		padding: 20px;
	}
	/* 銀行 */
	.bank_box {
		margin-top: 30px;
	}
	.bank_content {
		box-sizing: border-box;
		border: 2px solid #e73262;
		padding: 30px;
		width: 620px;
	}
	.form_bank_box {
		height: 18px;
	}
	.form_bank {
		font-size: 13px;
		color: #e73262;
		text-align: center;
		display: flex;
		justify-content: center;
		line-height: 18px;
	}
	.right_box {
		height: 40px;
		display: flex;
		justify-content: flex-start;
	}
	/* BTN */
	.btn_box {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}
	.btn_go {
		margin: 20px 20px 20px 0;
	}
</style>
